export const fileColors = [
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.100.jpg",
    "colors": {
      "hex": "#a1a396",
      "hls": [
        0.1923076923076923,
        0.611328125,
        0.06532663316582915
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.101.jpg",
    "colors": {
      "hex": "#9e9c8f",
      "hls": [
        0.14444444444444446,
        0.587890625,
        0.07109004739336493
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.102.jpg",
    "colors": {
      "hex": "#99958d",
      "hls": [
        0.11111111111111112,
        0.57421875,
        0.05504587155963303
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.103.jpg",
    "colors": {
      "hex": "#a29e96",
      "hls": [
        0.11111111111111112,
        0.609375,
        0.06
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.104.jpg",
    "colors": {
      "hex": "#938e82",
      "hls": [
        0.1176470588235294,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.105.jpg",
    "colors": {
      "hex": "#868279",
      "hls": [
        0.11538461538461538,
        0.498046875,
        0.050980392156862744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.106.jpg",
    "colors": {
      "hex": "#8c887f",
      "hls": [
        0.11538461538461538,
        0.521484375,
        0.053061224489795916
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.107.jpg",
    "colors": {
      "hex": "#98968d",
      "hls": [
        0.13636363636363635,
        0.572265625,
        0.0502283105022831
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.108.jpg",
    "colors": {
      "hex": "#8c927d",
      "hls": [
        0.21428571428571427,
        0.529296875,
        0.08713692946058091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.109.jpg",
    "colors": {
      "hex": "#929780",
      "hls": [
        0.2028985507246377,
        0.544921875,
        0.09871244635193133
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.11.jpg",
    "colors": {
      "hex": "#9c9a88",
      "hls": [
        0.15,
        0.5703125,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.110.jpg",
    "colors": {
      "hex": "#979d89",
      "hls": [
        0.21666666666666665,
        0.57421875,
        0.09174311926605505
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.111.jpg",
    "colors": {
      "hex": "#939a84",
      "hls": [
        0.21969696969696972,
        0.55859375,
        0.09734513274336283
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.112.jpg",
    "colors": {
      "hex": "#8f8a7f",
      "hls": [
        0.11458333333333333,
        0.52734375,
        0.06611570247933884
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.113.jpg",
    "colors": {
      "hex": "#948e83",
      "hls": [
        0.10784313725490195,
        0.544921875,
        0.07296137339055794
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.114.jpg",
    "colors": {
      "hex": "#918a7f",
      "hls": [
        0.10185185185185186,
        0.53125,
        0.075
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.115.jpg",
    "colors": {
      "hex": "#928d7f",
      "hls": [
        0.12280701754385966,
        0.533203125,
        0.0794979079497908
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.116.jpg",
    "colors": {
      "hex": "#8c867c",
      "hls": [
        0.10416666666666667,
        0.515625,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.117.jpg",
    "colors": {
      "hex": "#aaa496",
      "hls": [
        0.11666666666666665,
        0.625,
        0.10416666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.118.jpg",
    "colors": {
      "hex": "#9f9888",
      "hls": [
        0.11594202898550725,
        0.576171875,
        0.10599078341013825
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.119.jpg",
    "colors": {
      "hex": "#8a867c",
      "hls": [
        0.11904761904761905,
        0.51171875,
        0.056
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.12.jpg",
    "colors": {
      "hex": "#b1b2a1",
      "hls": [
        0.17647058823529407,
        0.662109375,
        0.09826589595375723
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.120.jpg",
    "colors": {
      "hex": "#95988f",
      "hls": [
        0.22222222222222224,
        0.576171875,
        0.041474654377880185
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.121.jpg",
    "colors": {
      "hex": "#979288",
      "hls": [
        0.11111111111111112,
        0.560546875,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.122.jpg",
    "colors": {
      "hex": "#a29c8e",
      "hls": [
        0.11666666666666665,
        0.59375,
        0.09615384615384616
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.123.jpg",
    "colors": {
      "hex": "#989384",
      "hls": [
        0.125,
        0.5546875,
        0.08771929824561403
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.124.jpg",
    "colors": {
      "hex": "#84837a",
      "hls": [
        0.15,
        0.49609375,
        0.03937007874015748
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.125.jpg",
    "colors": {
      "hex": "#9c9686",
      "hls": [
        0.12121212121212122,
        0.56640625,
        0.0990990990990991
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.126.jpg",
    "colors": {
      "hex": "#a39f90",
      "hls": [
        0.13157894736842105,
        0.599609375,
        0.09268292682926829
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.127.jpg",
    "colors": {
      "hex": "#969c8b",
      "hls": [
        0.22549019607843138,
        0.576171875,
        0.07834101382488479
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.128.jpg",
    "colors": {
      "hex": "#959586",
      "hls": [
        0.16666666666666666,
        0.552734375,
        0.06550218340611354
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.129.jpg",
    "colors": {
      "hex": "#949480",
      "hls": [
        0.16666666666666666,
        0.5390625,
        0.0847457627118644
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.13.jpg",
    "colors": {
      "hex": "#888780",
      "hls": [
        0.14583333333333334,
        0.515625,
        0.03225806451612903
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.130.jpg",
    "colors": {
      "hex": "#a1a69b",
      "hls": [
        0.24242424242424243,
        0.626953125,
        0.05759162303664921
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.132.jpg",
    "colors": {
      "hex": "#8f9180",
      "hls": [
        0.18627450980392157,
        0.533203125,
        0.07112970711297072
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.133.jpg",
    "colors": {
      "hex": "#a5a893",
      "hls": [
        0.19047619047619047,
        0.615234375,
        0.1065989847715736
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.134.jpg",
    "colors": {
      "hex": "#9b9c8c",
      "hls": [
        0.17708333333333334,
        0.578125,
        0.07407407407407407
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.135.jpg",
    "colors": {
      "hex": "#949a87",
      "hls": [
        0.2192982456140351,
        0.564453125,
        0.08520179372197309
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.136.jpg",
    "colors": {
      "hex": "#9c9e8b",
      "hls": [
        0.18421052631578946,
        0.580078125,
        0.08837209302325581
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.137.jpg",
    "colors": {
      "hex": "#8e9281",
      "hls": [
        0.2058823529411765,
        0.537109375,
        0.07172995780590717
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.14.jpg",
    "colors": {
      "hex": "#8e8f87",
      "hls": [
        0.1875,
        0.54296875,
        0.03418803418803419
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.15.jpg",
    "colors": {
      "hex": "#817d73",
      "hls": [
        0.11904761904761905,
        0.4765625,
        0.05737704918032787
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.16.jpg",
    "colors": {
      "hex": "#928e80",
      "hls": [
        0.12962962962962962,
        0.53515625,
        0.07563025210084033
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.17.jpg",
    "colors": {
      "hex": "#807b70",
      "hls": [
        0.11458333333333333,
        0.46875,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.18.jpg",
    "colors": {
      "hex": "#7d7a6f",
      "hls": [
        0.13095238095238096,
        0.4609375,
        0.059322033898305086
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.19.jpg",
    "colors": {
      "hex": "#87847b",
      "hls": [
        0.125,
        0.50390625,
        0.047244094488188976
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.2.jpg",
    "colors": {
      "hex": "#9f9d8d",
      "hls": [
        0.14814814814814814,
        0.5859375,
        0.08490566037735849
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.20.jpg",
    "colors": {
      "hex": "#8c8d84",
      "hls": [
        0.1851851851851852,
        0.533203125,
        0.03765690376569038
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.21.jpg",
    "colors": {
      "hex": "#8d8a80",
      "hls": [
        0.1282051282051282,
        0.525390625,
        0.053497942386831275
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.23.jpg",
    "colors": {
      "hex": "#807e75",
      "hls": [
        0.13636363636363635,
        0.478515625,
        0.044897959183673466
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.24.jpg",
    "colors": {
      "hex": "#858075",
      "hls": [
        0.11458333333333333,
        0.48828125,
        0.064
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.25.jpg",
    "colors": {
      "hex": "#888579",
      "hls": [
        0.13333333333333333,
        0.501953125,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.26.jpg",
    "colors": {
      "hex": "#898478",
      "hls": [
        0.1176470588235294,
        0.501953125,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.27.jpg",
    "colors": {
      "hex": "#89887b",
      "hls": [
        0.15476190476190477,
        0.5078125,
        0.05555555555555555
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.28.jpg",
    "colors": {
      "hex": "#817f74",
      "hls": [
        0.14102564102564102,
        0.478515625,
        0.053061224489795916
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.29.jpg",
    "colors": {
      "hex": "#8c887e",
      "hls": [
        0.11904761904761905,
        0.51953125,
        0.056910569105691054
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.3.jpg",
    "colors": {
      "hex": "#939288",
      "hls": [
        0.15151515151515152,
        0.552734375,
        0.048034934497816595
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.30.jpg",
    "colors": {
      "hex": "#958f83",
      "hls": [
        0.11111111111111112,
        0.546875,
        0.07758620689655173
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.31.jpg",
    "colors": {
      "hex": "#8c9179",
      "hls": [
        0.20138888888888892,
        0.51953125,
        0.0975609756097561
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.32.jpg",
    "colors": {
      "hex": "#8c8c7e",
      "hls": [
        0.16666666666666666,
        0.51953125,
        0.056910569105691054
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.33.jpg",
    "colors": {
      "hex": "#87897d",
      "hls": [
        0.19444444444444442,
        0.51171875,
        0.048
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.34.jpg",
    "colors": {
      "hex": "#9a9a8a",
      "hls": [
        0.16666666666666666,
        0.5703125,
        0.07272727272727272
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.35.jpg",
    "colors": {
      "hex": "#8c8d7d",
      "hls": [
        0.17708333333333334,
        0.51953125,
        0.06504065040650407
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.36.jpg",
    "colors": {
      "hex": "#8e9184",
      "hls": [
        0.20512820512820515,
        0.541015625,
        0.05531914893617021
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.37.jpg",
    "colors": {
      "hex": "#979789",
      "hls": [
        0.16666666666666666,
        0.5625,
        0.0625
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.38.jpg",
    "colors": {
      "hex": "#8e9382",
      "hls": [
        0.2156862745098039,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.39.jpg",
    "colors": {
      "hex": "#979c8f",
      "hls": [
        0.23076923076923075,
        0.583984375,
        0.06103286384976526
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.4.jpg",
    "colors": {
      "hex": "#929487",
      "hls": [
        0.1923076923076923,
        0.552734375,
        0.056768558951965066
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.40.jpg",
    "colors": {
      "hex": "#9d998c",
      "hls": [
        0.12745098039215685,
        0.580078125,
        0.07906976744186046
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.43.jpg",
    "colors": {
      "hex": "#827f75",
      "hls": [
        0.1282051282051282,
        0.482421875,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.44.jpg",
    "colors": {
      "hex": "#8f8d80",
      "hls": [
        0.14444444444444446,
        0.529296875,
        0.06224066390041494
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.45.jpg",
    "colors": {
      "hex": "#868378",
      "hls": [
        0.13095238095238096,
        0.49609375,
        0.05511811023622047
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.46.jpg",
    "colors": {
      "hex": "#898579",
      "hls": [
        0.125,
        0.50390625,
        0.06299212598425197
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.47.jpg",
    "colors": {
      "hex": "#8e8a7f",
      "hls": [
        0.12222222222222223,
        0.525390625,
        0.06172839506172839
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.48.jpg",
    "colors": {
      "hex": "#8c8a7b",
      "hls": [
        0.14705882352941177,
        0.513671875,
        0.06827309236947791
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.49.jpg",
    "colors": {
      "hex": "#8f9281",
      "hls": [
        0.196078431372549,
        0.537109375,
        0.07172995780590717
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.5.jpg",
    "colors": {
      "hex": "#a2a393",
      "hls": [
        0.17708333333333334,
        0.60546875,
        0.07920792079207921
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.50.jpg",
    "colors": {
      "hex": "#8d8c7d",
      "hls": [
        0.15625,
        0.51953125,
        0.06504065040650407
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.51.jpg",
    "colors": {
      "hex": "#93947f",
      "hls": [
        0.17460317460317457,
        0.537109375,
        0.08860759493670886
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.52.jpg",
    "colors": {
      "hex": "#8e8c7d",
      "hls": [
        0.14705882352941177,
        0.521484375,
        0.06938775510204082
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.53.jpg",
    "colors": {
      "hex": "#8b9281",
      "hls": [
        0.2352941176470588,
        0.537109375,
        0.07172995780590717
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.54.jpg",
    "colors": {
      "hex": "#959383",
      "hls": [
        0.14814814814814814,
        0.546875,
        0.07758620689655173
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.55.jpg",
    "colors": {
      "hex": "#747773",
      "hls": [
        0.2916666666666667,
        0.45703125,
        0.017094017094017096
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.57.jpg",
    "colors": {
      "hex": "#919088",
      "hls": [
        0.14814814814814814,
        0.548828125,
        0.03896103896103896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.58.jpg",
    "colors": {
      "hex": "#9e9d92",
      "hls": [
        0.15277777777777776,
        0.59375,
        0.057692307692307696
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.59.jpg",
    "colors": {
      "hex": "#959489",
      "hls": [
        0.15277777777777776,
        0.55859375,
        0.05309734513274336
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.61.jpg",
    "colors": {
      "hex": "#95948b",
      "hls": [
        0.15,
        0.5625,
        0.044642857142857144
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.62.jpg",
    "colors": {
      "hex": "#9b988e",
      "hls": [
        0.1282051282051282,
        0.580078125,
        0.06046511627906977
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.63.jpg",
    "colors": {
      "hex": "#7e7c72",
      "hls": [
        0.1388888888888889,
        0.46875,
        0.05
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.65.jpg",
    "colors": {
      "hex": "#87897b",
      "hls": [
        0.19047619047619047,
        0.5078125,
        0.05555555555555555
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.66.jpg",
    "colors": {
      "hex": "#959086",
      "hls": [
        0.11111111111111112,
        0.552734375,
        0.06550218340611354
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.67.jpg",
    "colors": {
      "hex": "#919084",
      "hls": [
        0.15384615384615385,
        0.541015625,
        0.05531914893617021
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.68.jpg",
    "colors": {
      "hex": "#8d8b81",
      "hls": [
        0.1388888888888889,
        0.52734375,
        0.049586776859504134
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.73.jpg",
    "colors": {
      "hex": "#959285",
      "hls": [
        0.13541666666666666,
        0.55078125,
        0.06956521739130435
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.74.jpg",
    "colors": {
      "hex": "#838579",
      "hls": [
        0.19444444444444442,
        0.49609375,
        0.047244094488188976
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.75.jpg",
    "colors": {
      "hex": "#939082",
      "hls": [
        0.1372549019607843,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.76.jpg",
    "colors": {
      "hex": "#8e8f81",
      "hls": [
        0.1785714285714286,
        0.53125,
        0.058333333333333334
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.77.jpg",
    "colors": {
      "hex": "#908d82",
      "hls": [
        0.13095238095238096,
        0.53515625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.78.jpg",
    "colors": {
      "hex": "#8b887a",
      "hls": [
        0.1372549019607843,
        0.509765625,
        0.06772908366533864
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.79.jpg",
    "colors": {
      "hex": "#87867a",
      "hls": [
        0.15384615384615385,
        0.501953125,
        0.050980392156862744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.8.jpg",
    "colors": {
      "hex": "#aeb0a2",
      "hls": [
        0.19047619047619047,
        0.66015625,
        0.08045977011494253
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.82.jpg",
    "colors": {
      "hex": "#959387",
      "hls": [
        0.14285714285714288,
        0.5546875,
        0.06140350877192982
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.83.jpg",
    "colors": {
      "hex": "#8b8d82",
      "hls": [
        0.19696969696969693,
        0.529296875,
        0.04564315352697095
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.85.jpg",
    "colors": {
      "hex": "#8f8e85",
      "hls": [
        0.15,
        0.5390625,
        0.0423728813559322
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.86.jpg",
    "colors": {
      "hex": "#858579",
      "hls": [
        0.16666666666666666,
        0.49609375,
        0.047244094488188976
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.9.jpg",
    "colors": {
      "hex": "#acaea5",
      "hls": [
        0.20370370370370372,
        0.662109375,
        0.05202312138728324
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.91.jpg",
    "colors": {
      "hex": "#929882",
      "hls": [
        0.21212121212121207,
        0.55078125,
        0.09565217391304348
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.92.jpg",
    "colors": {
      "hex": "#8b8f78",
      "hls": [
        0.19565217391304346,
        0.513671875,
        0.09236947791164658
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.93.jpg",
    "colors": {
      "hex": "#8a9586",
      "hls": [
        0.2888888888888889,
        0.552734375,
        0.06550218340611354
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.94.jpg",
    "colors": {
      "hex": "#9b9c82",
      "hls": [
        0.17307692307692304,
        0.55859375,
        0.11504424778761062
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.96.jpg",
    "colors": {
      "hex": "#9c9f86",
      "hls": [
        0.18666666666666668,
        0.572265625,
        0.1141552511415525
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.97.jpg",
    "colors": {
      "hex": "#989b84",
      "hls": [
        0.1884057971014493,
        0.560546875,
        0.10222222222222223
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.98.jpg",
    "colors": {
      "hex": "#9c9e87",
      "hls": [
        0.18115942028985507,
        0.572265625,
        0.1050228310502283
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D004.99.jpg",
    "colors": {
      "hex": "#909781",
      "hls": [
        0.21969696969696972,
        0.546875,
        0.09482758620689655
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.10.jpg",
    "colors": {
      "hex": "#a3a68b",
      "hls": [
        0.1851851851851852,
        0.595703125,
        0.13043478260869565
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.100.jpg",
    "colors": {
      "hex": "#b1aa98",
      "hls": [
        0.12,
        0.642578125,
        0.1366120218579235
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.101.jpg",
    "colors": {
      "hex": "#97938a",
      "hls": [
        0.11538461538461538,
        0.564453125,
        0.05829596412556054
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.102.jpg",
    "colors": {
      "hex": "#aea99a",
      "hls": [
        0.125,
        0.640625,
        0.10869565217391304
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.103.jpg",
    "colors": {
      "hex": "#aea998",
      "hls": [
        0.12878787878787878,
        0.63671875,
        0.11827956989247312
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.104.jpg",
    "colors": {
      "hex": "#9a9589",
      "hls": [
        0.1176470588235294,
        0.568359375,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.105.jpg",
    "colors": {
      "hex": "#959a87",
      "hls": [
        0.21052631578947367,
        0.564453125,
        0.08520179372197309
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.106.jpg",
    "colors": {
      "hex": "#96a289",
      "hls": [
        0.24666666666666667,
        0.583984375,
        0.11737089201877934
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.107.jpg",
    "colors": {
      "hex": "#989a7d",
      "hls": [
        0.17816091954022992,
        0.544921875,
        0.12446351931330472
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.108.jpg",
    "colors": {
      "hex": "#8c8e7a",
      "hls": [
        0.18333333333333335,
        0.515625,
        0.08064516129032258
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.109.jpg",
    "colors": {
      "hex": "#9da084",
      "hls": [
        0.18452380952380953,
        0.5703125,
        0.12727272727272726
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.11.jpg",
    "colors": {
      "hex": "#909087",
      "hls": [
        0.16666666666666666,
        0.544921875,
        0.03862660944206009
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.110.jpg",
    "colors": {
      "hex": "#939b82",
      "hls": [
        0.21999999999999997,
        0.556640625,
        0.11013215859030837
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.112.jpg",
    "colors": {
      "hex": "#9fa389",
      "hls": [
        0.1923076923076923,
        0.5859375,
        0.12264150943396226
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.113.jpg",
    "colors": {
      "hex": "#8c8f76",
      "hls": [
        0.18666666666666668,
        0.509765625,
        0.099601593625498
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.114.jpg",
    "colors": {
      "hex": "#939890",
      "hls": [
        0.2708333333333333,
        0.578125,
        0.037037037037037035
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.115.jpg",
    "colors": {
      "hex": "#b0a99b",
      "hls": [
        0.11111111111111112,
        0.646484375,
        0.11602209944751381
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.116.jpg",
    "colors": {
      "hex": "#a5a193",
      "hls": [
        0.12962962962962962,
        0.609375,
        0.09
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.117.jpg",
    "colors": {
      "hex": "#9b988d",
      "hls": [
        0.13095238095238096,
        0.578125,
        0.06481481481481481
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.118.jpg",
    "colors": {
      "hex": "#a19d89",
      "hls": [
        0.1388888888888889,
        0.58203125,
        0.11214953271028037
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.119.jpg",
    "colors": {
      "hex": "#99958a",
      "hls": [
        0.12222222222222223,
        0.568359375,
        0.06787330316742081
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.12.jpg",
    "colors": {
      "hex": "#9d9b8d",
      "hls": [
        0.14583333333333334,
        0.58203125,
        0.07476635514018691
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.120.jpg",
    "colors": {
      "hex": "#8d9084",
      "hls": [
        0.20833333333333334,
        0.5390625,
        0.05084745762711865
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.122.jpg",
    "colors": {
      "hex": "#9fa995",
      "hls": [
        0.25,
        0.62109375,
        0.10309278350515463
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.123.jpg",
    "colors": {
      "hex": "#a79f8b",
      "hls": [
        0.11904761904761905,
        0.59765625,
        0.13592233009708737
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.124.jpg",
    "colors": {
      "hex": "#939e91",
      "hls": [
        0.3076923076923077,
        0.591796875,
        0.06220095693779904
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.125.jpg",
    "colors": {
      "hex": "#9ea190",
      "hls": [
        0.196078431372549,
        0.595703125,
        0.0821256038647343
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.126.jpg",
    "colors": {
      "hex": "#939084",
      "hls": [
        0.13333333333333333,
        0.544921875,
        0.06437768240343347
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.127.jpg",
    "colors": {
      "hex": "#9fa68e",
      "hls": [
        0.21527777777777776,
        0.6015625,
        0.11764705882352941
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.128.jpg",
    "colors": {
      "hex": "#9a9482",
      "hls": [
        0.125,
        0.5546875,
        0.10526315789473684
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.129.jpg",
    "colors": {
      "hex": "#aca490",
      "hls": [
        0.11904761904761905,
        0.6171875,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.13.jpg",
    "colors": {
      "hex": "#938e7e",
      "hls": [
        0.12698412698412698,
        0.533203125,
        0.08786610878661087
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.130.jpg",
    "colors": {
      "hex": "#9ea48b",
      "hls": [
        0.2066666666666667,
        0.591796875,
        0.11961722488038277
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.131.jpg",
    "colors": {
      "hex": "#999986",
      "hls": [
        0.16666666666666666,
        0.560546875,
        0.08444444444444445
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.132.jpg",
    "colors": {
      "hex": "#a0a087",
      "hls": [
        0.16666666666666666,
        0.576171875,
        0.1152073732718894
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.133.jpg",
    "colors": {
      "hex": "#a0ad94",
      "hls": [
        0.25333333333333335,
        0.626953125,
        0.13089005235602094
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.134.jpg",
    "colors": {
      "hex": "#9e9980",
      "hls": [
        0.1388888888888889,
        0.55859375,
        0.13274336283185842
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.135.jpg",
    "colors": {
      "hex": "#9ca990",
      "hls": [
        0.25333333333333335,
        0.611328125,
        0.12562814070351758
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.136.jpg",
    "colors": {
      "hex": "#949884",
      "hls": [
        0.20000000000000004,
        0.5546875,
        0.08771929824561403
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.137.jpg",
    "colors": {
      "hex": "#abac8d",
      "hls": [
        0.17204301075268816,
        0.611328125,
        0.15577889447236182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.138.jpg",
    "colors": {
      "hex": "#9b9f82",
      "hls": [
        0.18965517241379307,
        0.564453125,
        0.13004484304932734
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.139.jpg",
    "colors": {
      "hex": "#afa999",
      "hls": [
        0.12121212121212122,
        0.640625,
        0.11956521739130435
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.14.jpg",
    "colors": {
      "hex": "#9a9484",
      "hls": [
        0.12121212121212122,
        0.55859375,
        0.09734513274336283
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.140.jpg",
    "colors": {
      "hex": "#abb09b",
      "hls": [
        0.20634920634920637,
        0.646484375,
        0.11602209944751381
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.141.jpg",
    "colors": {
      "hex": "#a8a48f",
      "hls": [
        0.13999999999999999,
        0.607421875,
        0.12437810945273632
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.142.jpg",
    "colors": {
      "hex": "#a9a992",
      "hls": [
        0.16666666666666666,
        0.615234375,
        0.116751269035533
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.143.jpg",
    "colors": {
      "hex": "#a8a893",
      "hls": [
        0.16666666666666666,
        0.615234375,
        0.1065989847715736
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.144.jpg",
    "colors": {
      "hex": "#a6a894",
      "hls": [
        0.18333333333333335,
        0.6171875,
        0.10204081632653061
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.145.jpg",
    "colors": {
      "hex": "#9fa387",
      "hls": [
        0.19047619047619047,
        0.58203125,
        0.1308411214953271
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.146.jpg",
    "colors": {
      "hex": "#969b86",
      "hls": [
        0.20634920634920637,
        0.564453125,
        0.09417040358744394
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.147.jpg",
    "colors": {
      "hex": "#a9a389",
      "hls": [
        0.13541666666666666,
        0.59765625,
        0.1553398058252427
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.148.jpg",
    "colors": {
      "hex": "#9d937d",
      "hls": [
        0.11458333333333333,
        0.55078125,
        0.1391304347826087
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.149.jpg",
    "colors": {
      "hex": "#a29884",
      "hls": [
        0.11111111111111112,
        0.57421875,
        0.13761467889908258
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.15.jpg",
    "colors": {
      "hex": "#a8a993",
      "hls": [
        0.17424242424242423,
        0.6171875,
        0.11224489795918367
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.150.jpg",
    "colors": {
      "hex": "#aca98d",
      "hls": [
        0.15053763440860216,
        0.611328125,
        0.15577889447236182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.151.jpg",
    "colors": {
      "hex": "#7b756d",
      "hls": [
        0.09523809523809523,
        0.453125,
        0.0603448275862069
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.152.jpg",
    "colors": {
      "hex": "#8f9581",
      "hls": [
        0.21666666666666665,
        0.54296875,
        0.08547008547008547
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.153.jpg",
    "colors": {
      "hex": "#958e84",
      "hls": [
        0.09803921568627451,
        0.548828125,
        0.0735930735930736
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.157.jpg",
    "colors": {
      "hex": "#a9aa97",
      "hls": [
        0.1754385964912281,
        0.626953125,
        0.09947643979057591
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.158.jpg",
    "colors": {
      "hex": "#9a9d8c",
      "hls": [
        0.196078431372549,
        0.580078125,
        0.07906976744186046
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.159.jpg",
    "colors": {
      "hex": "#919285",
      "hls": [
        0.17948717948717952,
        0.544921875,
        0.055793991416309016
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.16.jpg",
    "colors": {
      "hex": "#b4b59e",
      "hls": [
        0.1739130434782609,
        0.662109375,
        0.1329479768786127
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.161.jpg",
    "colors": {
      "hex": "#a2a299",
      "hls": [
        0.16666666666666666,
        0.615234375,
        0.04568527918781726
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.162.jpg",
    "colors": {
      "hex": "#9a9b85",
      "hls": [
        0.17424242424242423,
        0.5625,
        0.09821428571428571
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.163.jpg",
    "colors": {
      "hex": "#aeb09e",
      "hls": [
        0.1851851851851852,
        0.65234375,
        0.10112359550561797
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.164.jpg",
    "colors": {
      "hex": "#90927b",
      "hls": [
        0.18115942028985507,
        0.525390625,
        0.09465020576131687
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.165.jpg",
    "colors": {
      "hex": "#999886",
      "hls": [
        0.15789473684210528,
        0.560546875,
        0.08444444444444445
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.166.jpg",
    "colors": {
      "hex": "#a4a598",
      "hls": [
        0.17948717948717952,
        0.619140625,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.167.jpg",
    "colors": {
      "hex": "#989987",
      "hls": [
        0.1759259259259259,
        0.5625,
        0.08035714285714286
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.168.jpg",
    "colors": {
      "hex": "#97958c",
      "hls": [
        0.13636363636363635,
        0.568359375,
        0.049773755656108594
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.169.jpg",
    "colors": {
      "hex": "#a5ad98",
      "hls": [
        0.23015873015873015,
        0.634765625,
        0.11229946524064172
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.17.jpg",
    "colors": {
      "hex": "#a39e8d",
      "hls": [
        0.12878787878787878,
        0.59375,
        0.10576923076923077
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.170.jpg",
    "colors": {
      "hex": "#939786",
      "hls": [
        0.2058823529411765,
        0.556640625,
        0.07488986784140969
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.172.jpg",
    "colors": {
      "hex": "#b5b6a4",
      "hls": [
        0.1759259259259259,
        0.67578125,
        0.10843373493975904
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.173.jpg",
    "colors": {
      "hex": "#acb198",
      "hls": [
        0.20000000000000004,
        0.642578125,
        0.1366120218579235
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.174.jpg",
    "colors": {
      "hex": "#918d80",
      "hls": [
        0.12745098039215685,
        0.533203125,
        0.07112970711297072
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.175.jpg",
    "colors": {
      "hex": "#91978b",
      "hls": [
        0.25,
        0.56640625,
        0.05405405405405406
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.176.jpg",
    "colors": {
      "hex": "#bbbea3",
      "hls": [
        0.1851851851851852,
        0.689453125,
        0.16981132075471697
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.177.jpg",
    "colors": {
      "hex": "#a7ab9a",
      "hls": [
        0.2058823529411765,
        0.634765625,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.178.jpg",
    "colors": {
      "hex": "#929381",
      "hls": [
        0.1759259259259259,
        0.5390625,
        0.07627118644067797
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.179.jpg",
    "colors": {
      "hex": "#a0a692",
      "hls": [
        0.21666666666666665,
        0.609375,
        0.1
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.180.jpg",
    "colors": {
      "hex": "#a3a99d",
      "hls": [
        0.25,
        0.63671875,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.181.jpg",
    "colors": {
      "hex": "#979c89",
      "hls": [
        0.21052631578947367,
        0.572265625,
        0.0867579908675799
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.182.jpg",
    "colors": {
      "hex": "#979388",
      "hls": [
        0.12222222222222223,
        0.560546875,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.183.jpg",
    "colors": {
      "hex": "#a29c90",
      "hls": [
        0.11111111111111112,
        0.59765625,
        0.08737864077669903
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.184.jpg",
    "colors": {
      "hex": "#a8ab98",
      "hls": [
        0.1929824561403509,
        0.630859375,
        0.10052910052910052
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.185.jpg",
    "colors": {
      "hex": "#b1b4a3",
      "hls": [
        0.196078431372549,
        0.669921875,
        0.10059171597633136
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.186.jpg",
    "colors": {
      "hex": "#a9aa97",
      "hls": [
        0.1754385964912281,
        0.626953125,
        0.09947643979057591
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.187.jpg",
    "colors": {
      "hex": "#858074",
      "hls": [
        0.1176470588235294,
        0.486328125,
        0.06827309236947791
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.188.jpg",
    "colors": {
      "hex": "#a3a798",
      "hls": [
        0.2111111111111111,
        0.623046875,
        0.07772020725388601
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.189.jpg",
    "colors": {
      "hex": "#afb29f",
      "hls": [
        0.1929824561403509,
        0.658203125,
        0.10857142857142857
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.190.jpg",
    "colors": {
      "hex": "#958d7f",
      "hls": [
        0.10606060606060606,
        0.5390625,
        0.09322033898305085
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.191.jpg",
    "colors": {
      "hex": "#9b9c8c",
      "hls": [
        0.17708333333333334,
        0.578125,
        0.07407407407407407
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.192.jpg",
    "colors": {
      "hex": "#9f9d85",
      "hls": [
        0.15384615384615385,
        0.5703125,
        0.11818181818181818
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.193.jpg",
    "colors": {
      "hex": "#b0b1a6",
      "hls": [
        0.1818181818181818,
        0.669921875,
        0.0650887573964497
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.194.jpg",
    "colors": {
      "hex": "#989487",
      "hls": [
        0.12745098039215685,
        0.560546875,
        0.07555555555555556
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.195.jpg",
    "colors": {
      "hex": "#8f968a",
      "hls": [
        0.2638888888888889,
        0.5625,
        0.05357142857142857
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.196.jpg",
    "colors": {
      "hex": "#a29c85",
      "hls": [
        0.13218390804597702,
        0.576171875,
        0.1336405529953917
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.197.jpg",
    "colors": {
      "hex": "#9e9d8d",
      "hls": [
        0.1568627450980392,
        0.583984375,
        0.07981220657276995
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.199.jpg",
    "colors": {
      "hex": "#939086",
      "hls": [
        0.1282051282051282,
        0.548828125,
        0.05627705627705628
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.20.jpg",
    "colors": {
      "hex": "#b5b5a2",
      "hls": [
        0.16666666666666666,
        0.669921875,
        0.11242603550295859
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.200.jpg",
    "colors": {
      "hex": "#a2a191",
      "hls": [
        0.1568627450980392,
        0.599609375,
        0.08292682926829269
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.201.jpg",
    "colors": {
      "hex": "#a3a094",
      "hls": [
        0.13333333333333333,
        0.607421875,
        0.07462686567164178
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.202.jpg",
    "colors": {
      "hex": "#848177",
      "hls": [
        0.1282051282051282,
        0.490234375,
        0.05179282868525897
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.203.jpg",
    "colors": {
      "hex": "#948f84",
      "hls": [
        0.11458333333333333,
        0.546875,
        0.06896551724137931
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.204.jpg",
    "colors": {
      "hex": "#a0a38f",
      "hls": [
        0.19166666666666665,
        0.59765625,
        0.0970873786407767
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.205.jpg",
    "colors": {
      "hex": "#a3aa92",
      "hls": [
        0.21527777777777776,
        0.6171875,
        0.12244897959183673
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.206.jpg",
    "colors": {
      "hex": "#938d82",
      "hls": [
        0.10784313725490195,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.207.jpg",
    "colors": {
      "hex": "#939382",
      "hls": [
        0.16666666666666666,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.208.jpg",
    "colors": {
      "hex": "#929f8c",
      "hls": [
        0.2807017543859649,
        0.583984375,
        0.0892018779342723
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.21.jpg",
    "colors": {
      "hex": "#a1a590",
      "hls": [
        0.19841269841269846,
        0.603515625,
        0.10344827586206896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.211.jpg",
    "colors": {
      "hex": "#938f85",
      "hls": [
        0.11904761904761905,
        0.546875,
        0.0603448275862069
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.212.jpg",
    "colors": {
      "hex": "#949485",
      "hls": [
        0.16666666666666666,
        0.548828125,
        0.06493506493506493
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.213.jpg",
    "colors": {
      "hex": "#aeac95",
      "hls": [
        0.15333333333333335,
        0.630859375,
        0.13227513227513227
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.214.jpg",
    "colors": {
      "hex": "#8e8d83",
      "hls": [
        0.15151515151515152,
        0.533203125,
        0.04602510460251046
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.215.jpg",
    "colors": {
      "hex": "#97917f",
      "hls": [
        0.125,
        0.54296875,
        0.10256410256410256
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.217.jpg",
    "colors": {
      "hex": "#949781",
      "hls": [
        0.18939393939393936,
        0.546875,
        0.09482758620689655
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.218.jpg",
    "colors": {
      "hex": "#a9a99f",
      "hls": [
        0.16666666666666666,
        0.640625,
        0.05434782608695652
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.219.jpg",
    "colors": {
      "hex": "#acad9a",
      "hls": [
        0.1754385964912281,
        0.638671875,
        0.10270270270270271
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.22.jpg",
    "colors": {
      "hex": "#989b84",
      "hls": [
        0.1884057971014493,
        0.560546875,
        0.10222222222222223
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.220.jpg",
    "colors": {
      "hex": "#b1ad93",
      "hls": [
        0.14444444444444446,
        0.6328125,
        0.1595744680851064
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.221.jpg",
    "colors": {
      "hex": "#b2b1a4",
      "hls": [
        0.15476190476190477,
        0.66796875,
        0.08235294117647059
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.222.jpg",
    "colors": {
      "hex": "#a4a398",
      "hls": [
        0.15277777777777776,
        0.6171875,
        0.061224489795918366
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.223.jpg",
    "colors": {
      "hex": "#9a9890",
      "hls": [
        0.13333333333333333,
        0.58203125,
        0.04672897196261682
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.224.jpg",
    "colors": {
      "hex": "#a9ad96",
      "hls": [
        0.19565217391304346,
        0.630859375,
        0.12169312169312169
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.225.jpg",
    "colors": {
      "hex": "#aaab9f",
      "hls": [
        0.18055555555555558,
        0.64453125,
        0.06593406593406594
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.226.jpg",
    "colors": {
      "hex": "#88867b",
      "hls": [
        0.14102564102564102,
        0.505859375,
        0.05138339920948617
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.229.jpg",
    "colors": {
      "hex": "#aca698",
      "hls": [
        0.11666666666666665,
        0.6328125,
        0.10638297872340426
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.23.jpg",
    "colors": {
      "hex": "#a5a58b",
      "hls": [
        0.16666666666666666,
        0.59375,
        0.125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.230.jpg",
    "colors": {
      "hex": "#89887a",
      "hls": [
        0.15555555555555556,
        0.505859375,
        0.05928853754940711
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.231.jpg",
    "colors": {
      "hex": "#959385",
      "hls": [
        0.14583333333333334,
        0.55078125,
        0.06956521739130435
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.232.jpg",
    "colors": {
      "hex": "#acae98",
      "hls": [
        0.1818181818181818,
        0.63671875,
        0.11827956989247312
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.233.jpg",
    "colors": {
      "hex": "#a2a399",
      "hls": [
        0.18333333333333335,
        0.6171875,
        0.05102040816326531
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.234.jpg",
    "colors": {
      "hex": "#a8aa98",
      "hls": [
        0.1851851851851852,
        0.62890625,
        0.09473684210526316
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.235.jpg",
    "colors": {
      "hex": "#adae9e",
      "hls": [
        0.17708333333333334,
        0.6484375,
        0.08888888888888889
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.236.jpg",
    "colors": {
      "hex": "#aca79a",
      "hls": [
        0.12037037037037036,
        0.63671875,
        0.0967741935483871
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.237.jpg",
    "colors": {
      "hex": "#9fa28f",
      "hls": [
        0.1929824561403509,
        0.595703125,
        0.09178743961352658
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.238.jpg",
    "colors": {
      "hex": "#908b82",
      "hls": [
        0.10714285714285714,
        0.53515625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.239.jpg",
    "colors": {
      "hex": "#918f87",
      "hls": [
        0.13333333333333333,
        0.546875,
        0.04310344827586207
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.24.jpg",
    "colors": {
      "hex": "#8f8c7e",
      "hls": [
        0.1372549019607843,
        0.525390625,
        0.06995884773662552
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.240.jpg",
    "colors": {
      "hex": "#94948a",
      "hls": [
        0.16666666666666666,
        0.55859375,
        0.04424778761061947
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.241.jpg",
    "colors": {
      "hex": "#8b887e",
      "hls": [
        0.1282051282051282,
        0.517578125,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.242.jpg",
    "colors": {
      "hex": "#adab9b",
      "hls": [
        0.14814814814814814,
        0.640625,
        0.09782608695652174
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.243.jpg",
    "colors": {
      "hex": "#b2b19d",
      "hls": [
        0.15873015873015872,
        0.654296875,
        0.11864406779661017
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.244.jpg",
    "colors": {
      "hex": "#929086",
      "hls": [
        0.1388888888888889,
        0.546875,
        0.05172413793103448
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.245.jpg",
    "colors": {
      "hex": "#a0a593",
      "hls": [
        0.21296296296296294,
        0.609375,
        0.09
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.246.jpg",
    "colors": {
      "hex": "#a9a191",
      "hls": [
        0.11111111111111112,
        0.61328125,
        0.12121212121212122
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.247.jpg",
    "colors": {
      "hex": "#9f9d8f",
      "hls": [
        0.14583333333333334,
        0.58984375,
        0.0761904761904762
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.248.jpg",
    "colors": {
      "hex": "#9e998d",
      "hls": [
        0.1176470588235294,
        0.583984375,
        0.07981220657276995
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.249.jpg",
    "colors": {
      "hex": "#b1afa0",
      "hls": [
        0.14705882352941177,
        0.658203125,
        0.09714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.25.jpg",
    "colors": {
      "hex": "#989e88",
      "hls": [
        0.21212121212121207,
        0.57421875,
        0.10091743119266056
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.250.jpg",
    "colors": {
      "hex": "#a2a198",
      "hls": [
        0.15,
        0.61328125,
        0.050505050505050504
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.251.jpg",
    "colors": {
      "hex": "#a2a593",
      "hls": [
        0.19444444444444442,
        0.609375,
        0.09
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.252.jpg",
    "colors": {
      "hex": "#a5ae95",
      "hls": [
        0.22666666666666666,
        0.630859375,
        0.13227513227513227
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.253.jpg",
    "colors": {
      "hex": "#b3ac9e",
      "hls": [
        0.11111111111111112,
        0.658203125,
        0.12
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.254.jpg",
    "colors": {
      "hex": "#b3aea4",
      "hls": [
        0.11111111111111112,
        0.669921875,
        0.08875739644970414
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.255.jpg",
    "colors": {
      "hex": "#ada796",
      "hls": [
        0.12318840579710144,
        0.630859375,
        0.12169312169312169
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.257.jpg",
    "colors": {
      "hex": "#9a9c8f",
      "hls": [
        0.1923076923076923,
        0.583984375,
        0.06103286384976526
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.258.jpg",
    "colors": {
      "hex": "#a3a793",
      "hls": [
        0.20000000000000004,
        0.61328125,
        0.10101010101010101
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.259.jpg",
    "colors": {
      "hex": "#9e9f89",
      "hls": [
        0.17424242424242423,
        0.578125,
        0.10185185185185185
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.26.jpg",
    "colors": {
      "hex": "#abab94",
      "hls": [
        0.16666666666666666,
        0.623046875,
        0.11917098445595854
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.260.jpg",
    "colors": {
      "hex": "#9e9f8c",
      "hls": [
        0.1754385964912281,
        0.583984375,
        0.0892018779342723
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.261.jpg",
    "colors": {
      "hex": "#989a8c",
      "hls": [
        0.19047619047619047,
        0.57421875,
        0.06422018348623854
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.262.jpg",
    "colors": {
      "hex": "#9c998a",
      "hls": [
        0.1388888888888889,
        0.57421875,
        0.08256880733944955
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.263.jpg",
    "colors": {
      "hex": "#8f8b7d",
      "hls": [
        0.12962962962962962,
        0.5234375,
        0.07377049180327869
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.264.jpg",
    "colors": {
      "hex": "#909488",
      "hls": [
        0.22222222222222224,
        0.5546875,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.265.jpg",
    "colors": {
      "hex": "#a8aba3",
      "hls": [
        0.22916666666666666,
        0.65234375,
        0.0449438202247191
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.266.jpg",
    "colors": {
      "hex": "#9e9a8d",
      "hls": [
        0.12745098039215685,
        0.583984375,
        0.07981220657276995
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.267.jpg",
    "colors": {
      "hex": "#a4a39c",
      "hls": [
        0.14583333333333334,
        0.625,
        0.041666666666666664
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.268.jpg",
    "colors": {
      "hex": "#b4b8a7",
      "hls": [
        0.2058823529411765,
        0.685546875,
        0.10559006211180125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.269.jpg",
    "colors": {
      "hex": "#a19c8d",
      "hls": [
        0.125,
        0.58984375,
        0.09523809523809523
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.27.jpg",
    "colors": {
      "hex": "#abad9c",
      "hls": [
        0.18627450980392157,
        0.642578125,
        0.09289617486338798
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.270.jpg",
    "colors": {
      "hex": "#9f9e8b",
      "hls": [
        0.15833333333333333,
        0.58203125,
        0.09345794392523364
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.271.jpg",
    "colors": {
      "hex": "#afaca0",
      "hls": [
        0.13333333333333333,
        0.654296875,
        0.0847457627118644
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.274.jpg",
    "colors": {
      "hex": "#9d968a",
      "hls": [
        0.10526315789473684,
        0.576171875,
        0.08755760368663594
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.275.jpg",
    "colors": {
      "hex": "#a39d8f",
      "hls": [
        0.11666666666666665,
        0.59765625,
        0.0970873786407767
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.276.jpg",
    "colors": {
      "hex": "#9ba188",
      "hls": [
        0.2066666666666667,
        0.580078125,
        0.11627906976744186
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.277.jpg",
    "colors": {
      "hex": "#b2ab9d",
      "hls": [
        0.11111111111111112,
        0.654296875,
        0.11864406779661017
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.278.jpg",
    "colors": {
      "hex": "#9f9789",
      "hls": [
        0.10606060606060606,
        0.578125,
        0.10185185185185185
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.28.jpg",
    "colors": {
      "hex": "#b1ae9a",
      "hls": [
        0.14492753623188406,
        0.646484375,
        0.1270718232044199
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.280.jpg",
    "colors": {
      "hex": "#ada596",
      "hls": [
        0.10869565217391304,
        0.630859375,
        0.12169312169312169
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.281.jpg",
    "colors": {
      "hex": "#ada697",
      "hls": [
        0.11363636363636365,
        0.6328125,
        0.11702127659574468
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.283.jpg",
    "colors": {
      "hex": "#9d998d",
      "hls": [
        0.125,
        0.58203125,
        0.07476635514018691
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.284.jpg",
    "colors": {
      "hex": "#8c8f76",
      "hls": [
        0.18666666666666668,
        0.509765625,
        0.099601593625498
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.285.jpg",
    "colors": {
      "hex": "#9a9588",
      "hls": [
        0.12037037037037036,
        0.56640625,
        0.08108108108108109
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.286.jpg",
    "colors": {
      "hex": "#999586",
      "hls": [
        0.13157894736842105,
        0.560546875,
        0.08444444444444445
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.287.jpg",
    "colors": {
      "hex": "#9e9e8d",
      "hls": [
        0.16666666666666666,
        0.583984375,
        0.07981220657276995
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.288.jpg",
    "colors": {
      "hex": "#989384",
      "hls": [
        0.125,
        0.5546875,
        0.08771929824561403
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.289.jpg",
    "colors": {
      "hex": "#878276",
      "hls": [
        0.1176470588235294,
        0.494140625,
        0.06719367588932806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.29.jpg",
    "colors": {
      "hex": "#a29d90",
      "hls": [
        0.12037037037037036,
        0.59765625,
        0.08737864077669903
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.30.jpg",
    "colors": {
      "hex": "#a5a99a",
      "hls": [
        0.2111111111111111,
        0.630859375,
        0.07936507936507936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.31.jpg",
    "colors": {
      "hex": "#9ca391",
      "hls": [
        0.23148148148148148,
        0.6015625,
        0.08823529411764706
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.32.jpg",
    "colors": {
      "hex": "#a0a593",
      "hls": [
        0.21296296296296294,
        0.609375,
        0.09
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.33.jpg",
    "colors": {
      "hex": "#9ba18f",
      "hls": [
        0.22222222222222224,
        0.59375,
        0.08653846153846154
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.34.jpg",
    "colors": {
      "hex": "#929886",
      "hls": [
        0.22222222222222224,
        0.55859375,
        0.07964601769911504
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.35.jpg",
    "colors": {
      "hex": "#818178",
      "hls": [
        0.16666666666666666,
        0.486328125,
        0.03614457831325301
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.36.jpg",
    "colors": {
      "hex": "#8e8e84",
      "hls": [
        0.16666666666666666,
        0.53515625,
        0.04201680672268908
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.37.jpg",
    "colors": {
      "hex": "#8c8a81",
      "hls": [
        0.13636363636363635,
        0.525390625,
        0.04526748971193416
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.38.jpg",
    "colors": {
      "hex": "#878678",
      "hls": [
        0.15555555555555556,
        0.498046875,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.39.jpg",
    "colors": {
      "hex": "#8d8d82",
      "hls": [
        0.16666666666666666,
        0.529296875,
        0.04564315352697095
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.4.jpg",
    "colors": {
      "hex": "#a3a494",
      "hls": [
        0.17708333333333334,
        0.609375,
        0.08
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.40.jpg",
    "colors": {
      "hex": "#a5a693",
      "hls": [
        0.1754385964912281,
        0.611328125,
        0.09547738693467336
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.41.jpg",
    "colors": {
      "hex": "#85837b",
      "hls": [
        0.13333333333333333,
        0.5,
        0.0390625
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.42.jpg",
    "colors": {
      "hex": "#7c7d76",
      "hls": [
        0.19047619047619047,
        0.474609375,
        0.02880658436213992
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.43.jpg",
    "colors": {
      "hex": "#828178",
      "hls": [
        0.15,
        0.48828125,
        0.04
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.44.jpg",
    "colors": {
      "hex": "#7e7d79",
      "hls": [
        0.13333333333333333,
        0.482421875,
        0.020242914979757085
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.45.jpg",
    "colors": {
      "hex": "#75746d",
      "hls": [
        0.14583333333333334,
        0.44140625,
        0.035398230088495575
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.46.jpg",
    "colors": {
      "hex": "#87867d",
      "hls": [
        0.15,
        0.5078125,
        0.03968253968253968
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.47.jpg",
    "colors": {
      "hex": "#83827c",
      "hls": [
        0.14285714285714288,
        0.498046875,
        0.027450980392156862
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.48.jpg",
    "colors": {
      "hex": "#979985",
      "hls": [
        0.18333333333333335,
        0.55859375,
        0.08849557522123894
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.49.jpg",
    "colors": {
      "hex": "#9da089",
      "hls": [
        0.1884057971014493,
        0.580078125,
        0.10697674418604651
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.5.jpg",
    "colors": {
      "hex": "#8f9587",
      "hls": [
        0.23809523809523805,
        0.5546875,
        0.06140350877192982
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.50.jpg",
    "colors": {
      "hex": "#9ba38e",
      "hls": [
        0.23015873015873015,
        0.595703125,
        0.10144927536231885
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.51.jpg",
    "colors": {
      "hex": "#8e8e7a",
      "hls": [
        0.16666666666666666,
        0.515625,
        0.08064516129032258
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.52.jpg",
    "colors": {
      "hex": "#9ba189",
      "hls": [
        0.20833333333333334,
        0.58203125,
        0.11214953271028037
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.53.jpg",
    "colors": {
      "hex": "#959b84",
      "hls": [
        0.21014492753623185,
        0.560546875,
        0.10222222222222223
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.54.jpg",
    "colors": {
      "hex": "#919785",
      "hls": [
        0.22222222222222224,
        0.5546875,
        0.07894736842105263
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.55.jpg",
    "colors": {
      "hex": "#969c81",
      "hls": [
        0.20370370370370372,
        0.556640625,
        0.11894273127753303
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.57.jpg",
    "colors": {
      "hex": "#949380",
      "hls": [
        0.15833333333333333,
        0.5390625,
        0.0847457627118644
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.58.jpg",
    "colors": {
      "hex": "#94987f",
      "hls": [
        0.19333333333333336,
        0.544921875,
        0.1072961373390558
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.59.jpg",
    "colors": {
      "hex": "#9aa094",
      "hls": [
        0.25,
        0.6015625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.6.jpg",
    "colors": {
      "hex": "#b4b4a8",
      "hls": [
        0.16666666666666666,
        0.6796875,
        0.07317073170731707
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.60.jpg",
    "colors": {
      "hex": "#959c8b",
      "hls": [
        0.2352941176470588,
        0.576171875,
        0.07834101382488479
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.61.jpg",
    "colors": {
      "hex": "#a4a797",
      "hls": [
        0.19791666666666666,
        0.62109375,
        0.08247422680412371
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.62.jpg",
    "colors": {
      "hex": "#a2a89b",
      "hls": [
        0.2435897435897436,
        0.630859375,
        0.06878306878306878
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.63.jpg",
    "colors": {
      "hex": "#9da490",
      "hls": [
        0.225,
        0.6015625,
        0.09803921568627451
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.64.jpg",
    "colors": {
      "hex": "#9da191",
      "hls": [
        0.20833333333333334,
        0.59765625,
        0.07766990291262135
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.65.jpg",
    "colors": {
      "hex": "#9ca397",
      "hls": [
        0.2638888888888889,
        0.61328125,
        0.06060606060606061
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.66.jpg",
    "colors": {
      "hex": "#9aa193",
      "hls": [
        0.25,
        0.6015625,
        0.06862745098039216
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.68.jpg",
    "colors": {
      "hex": "#a19c8c",
      "hls": [
        0.12698412698412698,
        0.587890625,
        0.0995260663507109
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.69.jpg",
    "colors": {
      "hex": "#98948a",
      "hls": [
        0.11904761904761905,
        0.56640625,
        0.06306306306306306
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.70.jpg",
    "colors": {
      "hex": "#9f998b",
      "hls": [
        0.11666666666666665,
        0.58203125,
        0.09345794392523364
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.71.jpg",
    "colors": {
      "hex": "#a6a79e",
      "hls": [
        0.1851851851851852,
        0.634765625,
        0.0481283422459893
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.72.jpg",
    "colors": {
      "hex": "#aca192",
      "hls": [
        0.09615384615384615,
        0.62109375,
        0.13402061855670103
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.73.jpg",
    "colors": {
      "hex": "#a8a9a1",
      "hls": [
        0.1875,
        0.64453125,
        0.04395604395604396
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.74.jpg",
    "colors": {
      "hex": "#989b96",
      "hls": [
        0.26666666666666666,
        0.595703125,
        0.024154589371980676
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.75.jpg",
    "colors": {
      "hex": "#8d8e7b",
      "hls": [
        0.1754385964912281,
        0.517578125,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.76.jpg",
    "colors": {
      "hex": "#868775",
      "hls": [
        0.1759259259259259,
        0.4921875,
        0.07142857142857142
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.77.jpg",
    "colors": {
      "hex": "#9a9d85",
      "hls": [
        0.1875,
        0.56640625,
        0.10810810810810811
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.78.jpg",
    "colors": {
      "hex": "#969682",
      "hls": [
        0.16666666666666666,
        0.546875,
        0.08620689655172414
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.79.jpg",
    "colors": {
      "hex": "#918d77",
      "hls": [
        0.14102564102564102,
        0.515625,
        0.10483870967741936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.8.jpg",
    "colors": {
      "hex": "#9ba08f",
      "hls": [
        0.2156862745098039,
        0.591796875,
        0.08133971291866028
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.80.jpg",
    "colors": {
      "hex": "#969b7e",
      "hls": [
        0.19540229885057472,
        0.548828125,
        0.12554112554112554
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.81.jpg",
    "colors": {
      "hex": "#8d907b",
      "hls": [
        0.19047619047619047,
        0.521484375,
        0.08571428571428572
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.82.jpg",
    "colors": {
      "hex": "#969780",
      "hls": [
        0.1739130434782609,
        0.544921875,
        0.09871244635193133
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.83.jpg",
    "colors": {
      "hex": "#83827c",
      "hls": [
        0.14285714285714288,
        0.498046875,
        0.027450980392156862
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.84.jpg",
    "colors": {
      "hex": "#86857e",
      "hls": [
        0.14583333333333334,
        0.5078125,
        0.031746031746031744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.85.jpg",
    "colors": {
      "hex": "#888881",
      "hls": [
        0.16666666666666666,
        0.517578125,
        0.02834008097165992
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.86.jpg",
    "colors": {
      "hex": "#898a82",
      "hls": [
        0.1875,
        0.5234375,
        0.03278688524590164
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.87.jpg",
    "colors": {
      "hex": "#84847d",
      "hls": [
        0.16666666666666666,
        0.501953125,
        0.027450980392156862
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.88.jpg",
    "colors": {
      "hex": "#8e8c83",
      "hls": [
        0.13636363636363635,
        0.533203125,
        0.04602510460251046
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.89.jpg",
    "colors": {
      "hex": "#767570",
      "hls": [
        0.1388888888888889,
        0.44921875,
        0.02608695652173913
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.9.jpg",
    "colors": {
      "hex": "#848b78",
      "hls": [
        0.22807017543859645,
        0.505859375,
        0.07509881422924901
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.90.jpg",
    "colors": {
      "hex": "#8b8a83",
      "hls": [
        0.14583333333333334,
        0.52734375,
        0.03305785123966942
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.91.jpg",
    "colors": {
      "hex": "#a9ac97",
      "hls": [
        0.19047619047619047,
        0.630859375,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.92.jpg",
    "colors": {
      "hex": "#9ea594",
      "hls": [
        0.2352941176470588,
        0.611328125,
        0.08542713567839195
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.93.jpg",
    "colors": {
      "hex": "#9da394",
      "hls": [
        0.2333333333333333,
        0.607421875,
        0.07462686567164178
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.94.jpg",
    "colors": {
      "hex": "#9ca296",
      "hls": [
        0.25,
        0.609375,
        0.06
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.95.jpg",
    "colors": {
      "hex": "#989e90",
      "hls": [
        0.23809523809523805,
        0.58984375,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.96.jpg",
    "colors": {
      "hex": "#959b8b",
      "hls": [
        0.22916666666666666,
        0.57421875,
        0.07339449541284404
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.97.jpg",
    "colors": {
      "hex": "#a5a897",
      "hls": [
        0.196078431372549,
        0.623046875,
        0.08808290155440414
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.98.jpg",
    "colors": {
      "hex": "#9aa091",
      "hls": [
        0.2333333333333333,
        0.595703125,
        0.07246376811594203
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D010a.99.jpg",
    "colors": {
      "hex": "#aea995",
      "hls": [
        0.13333333333333333,
        0.630859375,
        0.13227513227513227
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.10.jpg",
    "colors": {
      "hex": "#a8afa5",
      "hls": [
        0.2833333333333334,
        0.6640625,
        0.05813953488372093
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.100.jpg",
    "colors": {
      "hex": "#949991",
      "hls": [
        0.2708333333333333,
        0.58203125,
        0.037383177570093455
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.101.jpg",
    "colors": {
      "hex": "#999d90",
      "hls": [
        0.21794871794871792,
        0.587890625,
        0.061611374407582936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.102.jpg",
    "colors": {
      "hex": "#9a9a85",
      "hls": [
        0.16666666666666666,
        0.560546875,
        0.09333333333333334
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.103.jpg",
    "colors": {
      "hex": "#9b9e94",
      "hls": [
        0.21666666666666665,
        0.59765625,
        0.04854368932038835
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.104.jpg",
    "colors": {
      "hex": "#959789",
      "hls": [
        0.19047619047619047,
        0.5625,
        0.0625
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.105.jpg",
    "colors": {
      "hex": "#878d81",
      "hls": [
        0.25,
        0.52734375,
        0.049586776859504134
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.106.jpg",
    "colors": {
      "hex": "#b0b8b0",
      "hls": [
        0.3333333333333333,
        0.703125,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.107.jpg",
    "colors": {
      "hex": "#a7ac97",
      "hls": [
        0.20634920634920637,
        0.630859375,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.108.jpg",
    "colors": {
      "hex": "#abab99",
      "hls": [
        0.16666666666666666,
        0.6328125,
        0.09574468085106383
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.109.jpg",
    "colors": {
      "hex": "#a2a595",
      "hls": [
        0.19791666666666666,
        0.61328125,
        0.08080808080808081
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.11.jpg",
    "colors": {
      "hex": "#a3aa9f",
      "hls": [
        0.2727272727272727,
        0.642578125,
        0.060109289617486336
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.110.jpg",
    "colors": {
      "hex": "#9c9d88",
      "hls": [
        0.17460317460317457,
        0.572265625,
        0.0958904109589041
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.111.jpg",
    "colors": {
      "hex": "#aab0a2",
      "hls": [
        0.23809523809523805,
        0.66015625,
        0.08045977011494253
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.112.jpg",
    "colors": {
      "hex": "#b1b6a5",
      "hls": [
        0.2156862745098039,
        0.677734375,
        0.10303030303030303
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.113.jpg",
    "colors": {
      "hex": "#a6ac9f",
      "hls": [
        0.2435897435897436,
        0.646484375,
        0.0718232044198895
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.114.jpg",
    "colors": {
      "hex": "#8a938c",
      "hls": [
        0.3703703703703704,
        0.556640625,
        0.039647577092511016
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.115.jpg",
    "colors": {
      "hex": "#aeb2a0",
      "hls": [
        0.20370370370370372,
        0.66015625,
        0.10344827586206896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.116.jpg",
    "colors": {
      "hex": "#a2a598",
      "hls": [
        0.20512820512820515,
        0.619140625,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.117.jpg",
    "colors": {
      "hex": "#b4b7ac",
      "hls": [
        0.21212121212121207,
        0.693359375,
        0.07006369426751592
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.118.jpg",
    "colors": {
      "hex": "#9da296",
      "hls": [
        0.23611111111111108,
        0.609375,
        0.06
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.119.jpg",
    "colors": {
      "hex": "#9ea18a",
      "hls": [
        0.1884057971014493,
        0.583984375,
        0.107981220657277
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.12.jpg",
    "colors": {
      "hex": "#84867e",
      "hls": [
        0.20833333333333334,
        0.5078125,
        0.031746031746031744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.120.jpg",
    "colors": {
      "hex": "#a8ad9e",
      "hls": [
        0.22222222222222224,
        0.646484375,
        0.08287292817679558
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.122.jpg",
    "colors": {
      "hex": "#aead9f",
      "hls": [
        0.15555555555555556,
        0.650390625,
        0.08379888268156424
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.123.jpg",
    "colors": {
      "hex": "#9ea08c",
      "hls": [
        0.18333333333333335,
        0.5859375,
        0.09433962264150944
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.124.jpg",
    "colors": {
      "hex": "#a1a28d",
      "hls": [
        0.17460317460317457,
        0.591796875,
        0.10047846889952153
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.127.jpg",
    "colors": {
      "hex": "#a0a38e",
      "hls": [
        0.19047619047619047,
        0.595703125,
        0.10144927536231885
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.128.jpg",
    "colors": {
      "hex": "#b1afa3",
      "hls": [
        0.14285714285714288,
        0.6640625,
        0.08139534883720931
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.129.jpg",
    "colors": {
      "hex": "#acaf9a",
      "hls": [
        0.19047619047619047,
        0.642578125,
        0.11475409836065574
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.13.jpg",
    "colors": {
      "hex": "#a4a59d",
      "hls": [
        0.1875,
        0.62890625,
        0.042105263157894736
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.130.jpg",
    "colors": {
      "hex": "#b3b6a0",
      "hls": [
        0.18939393939393936,
        0.66796875,
        0.12941176470588237
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.131.jpg",
    "colors": {
      "hex": "#b3b7a5",
      "hls": [
        0.20370370370370372,
        0.6796875,
        0.10975609756097561
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.132.jpg",
    "colors": {
      "hex": "#a9aa96",
      "hls": [
        0.17499999999999996,
        0.625,
        0.10416666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.133.jpg",
    "colors": {
      "hex": "#aba999",
      "hls": [
        0.14814814814814814,
        0.6328125,
        0.09574468085106383
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.135.jpg",
    "colors": {
      "hex": "#afb5a7",
      "hls": [
        0.23809523809523805,
        0.6796875,
        0.08536585365853659
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.136.jpg",
    "colors": {
      "hex": "#9a9f8f",
      "hls": [
        0.21875,
        0.58984375,
        0.0761904761904762
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.137.jpg",
    "colors": {
      "hex": "#a2a58e",
      "hls": [
        0.1884057971014493,
        0.599609375,
        0.11219512195121951
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.138.jpg",
    "colors": {
      "hex": "#989d8f",
      "hls": [
        0.2261904761904762,
        0.5859375,
        0.0660377358490566
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.139.jpg",
    "colors": {
      "hex": "#9b9d88",
      "hls": [
        0.18253968253968256,
        0.572265625,
        0.0958904109589041
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.14.jpg",
    "colors": {
      "hex": "#a6ad9f",
      "hls": [
        0.25,
        0.6484375,
        0.07777777777777778
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.140.jpg",
    "colors": {
      "hex": "#9ba296",
      "hls": [
        0.2638888888888889,
        0.609375,
        0.06
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.141.jpg",
    "colors": {
      "hex": "#9da196",
      "hls": [
        0.2272727272727273,
        0.607421875,
        0.05472636815920398
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.142.jpg",
    "colors": {
      "hex": "#9ca28d",
      "hls": [
        0.21428571428571427,
        0.591796875,
        0.10047846889952153
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.143.jpg",
    "colors": {
      "hex": "#9b9d8d",
      "hls": [
        0.1875,
        0.58203125,
        0.07476635514018691
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.144.jpg",
    "colors": {
      "hex": "#98a08c",
      "hls": [
        0.2333333333333333,
        0.5859375,
        0.09433962264150944
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.145.jpg",
    "colors": {
      "hex": "#a9ab94",
      "hls": [
        0.18115942028985507,
        0.623046875,
        0.11917098445595854
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.146.jpg",
    "colors": {
      "hex": "#8f9489",
      "hls": [
        0.24242424242424243,
        0.556640625,
        0.048458149779735685
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.147.jpg",
    "colors": {
      "hex": "#969d8f",
      "hls": [
        0.25,
        0.5859375,
        0.0660377358490566
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.148.jpg",
    "colors": {
      "hex": "#a0a795",
      "hls": [
        0.23148148148148148,
        0.6171875,
        0.09183673469387756
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.149.jpg",
    "colors": {
      "hex": "#a2a28e",
      "hls": [
        0.16666666666666666,
        0.59375,
        0.09615384615384616
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.15.jpg",
    "colors": {
      "hex": "#9fa698",
      "hls": [
        0.25,
        0.62109375,
        0.07216494845360824
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.150.jpg",
    "colors": {
      "hex": "#9da697",
      "hls": [
        0.26666666666666666,
        0.619140625,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.151.jpg",
    "colors": {
      "hex": "#979a8b",
      "hls": [
        0.20000000000000004,
        0.572265625,
        0.0684931506849315
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.152.jpg",
    "colors": {
      "hex": "#9ba192",
      "hls": [
        0.2333333333333333,
        0.599609375,
        0.07317073170731707
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.153.jpg",
    "colors": {
      "hex": "#a09d89",
      "hls": [
        0.14492753623188406,
        0.580078125,
        0.10697674418604651
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.154.jpg",
    "colors": {
      "hex": "#a8a592",
      "hls": [
        0.14393939393939395,
        0.61328125,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.155.jpg",
    "colors": {
      "hex": "#a0a491",
      "hls": [
        0.20175438596491224,
        0.603515625,
        0.09359605911330049
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.156.jpg",
    "colors": {
      "hex": "#adb09b",
      "hls": [
        0.19047619047619047,
        0.646484375,
        0.11602209944751381
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.157.jpg",
    "colors": {
      "hex": "#a0a896",
      "hls": [
        0.24074074074074078,
        0.62109375,
        0.09278350515463918
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.158.jpg",
    "colors": {
      "hex": "#afb39b",
      "hls": [
        0.19444444444444442,
        0.65234375,
        0.1348314606741573
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.159.jpg",
    "colors": {
      "hex": "#999680",
      "hls": [
        0.14666666666666667,
        0.548828125,
        0.10822510822510822
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.160.jpg",
    "colors": {
      "hex": "#a3a68d",
      "hls": [
        0.18666666666666668,
        0.599609375,
        0.12195121951219512
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.161.jpg",
    "colors": {
      "hex": "#8d9485",
      "hls": [
        0.24444444444444446,
        0.548828125,
        0.06493506493506493
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.162.jpg",
    "colors": {
      "hex": "#92927b",
      "hls": [
        0.16666666666666666,
        0.525390625,
        0.09465020576131687
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.163.jpg",
    "colors": {
      "hex": "#b2b6aa",
      "hls": [
        0.22222222222222224,
        0.6875,
        0.075
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.164.jpg",
    "colors": {
      "hex": "#aeb29b",
      "hls": [
        0.19565217391304346,
        0.650390625,
        0.12849162011173185
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.165.jpg",
    "colors": {
      "hex": "#a1a18d",
      "hls": [
        0.16666666666666666,
        0.58984375,
        0.09523809523809523
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.166.jpg",
    "colors": {
      "hex": "#a19e8a",
      "hls": [
        0.14492753623188406,
        0.583984375,
        0.107981220657277
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.167.jpg",
    "colors": {
      "hex": "#8f8f7e",
      "hls": [
        0.16666666666666666,
        0.525390625,
        0.06995884773662552
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.168.jpg",
    "colors": {
      "hex": "#9b9886",
      "hls": [
        0.14285714285714288,
        0.564453125,
        0.09417040358744394
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.169.jpg",
    "colors": {
      "hex": "#a1a290",
      "hls": [
        0.1759259259259259,
        0.59765625,
        0.08737864077669903
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.17.jpg",
    "colors": {
      "hex": "#989686",
      "hls": [
        0.14814814814814814,
        0.55859375,
        0.07964601769911504
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.170.jpg",
    "colors": {
      "hex": "#999b89",
      "hls": [
        0.1851851851851852,
        0.5703125,
        0.08181818181818182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.171.jpg",
    "colors": {
      "hex": "#9ea18b",
      "hls": [
        0.18939393939393936,
        0.5859375,
        0.10377358490566038
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.172.jpg",
    "colors": {
      "hex": "#93907e",
      "hls": [
        0.14285714285714288,
        0.533203125,
        0.08786610878661087
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.173.jpg",
    "colors": {
      "hex": "#8b958b",
      "hls": [
        0.3333333333333333,
        0.5625,
        0.044642857142857144
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.174.jpg",
    "colors": {
      "hex": "#a7ac95",
      "hls": [
        0.2028985507246377,
        0.626953125,
        0.12041884816753927
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.175.jpg",
    "colors": {
      "hex": "#9ba28c",
      "hls": [
        0.21969696969696972,
        0.58984375,
        0.10476190476190476
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.176.jpg",
    "colors": {
      "hex": "#a3ac95",
      "hls": [
        0.2318840579710145,
        0.626953125,
        0.12041884816753927
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.178.jpg",
    "colors": {
      "hex": "#9d9c83",
      "hls": [
        0.16025641025641027,
        0.5625,
        0.11607142857142858
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.179.jpg",
    "colors": {
      "hex": "#a6aa95",
      "hls": [
        0.19841269841269846,
        0.623046875,
        0.10880829015544041
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.18.jpg",
    "colors": {
      "hex": "#9ea090",
      "hls": [
        0.1875,
        0.59375,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.180.jpg",
    "colors": {
      "hex": "#a1a48e",
      "hls": [
        0.18939393939393936,
        0.59765625,
        0.10679611650485436
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.181.jpg",
    "colors": {
      "hex": "#aaac95",
      "hls": [
        0.18115942028985507,
        0.626953125,
        0.12041884816753927
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.182.jpg",
    "colors": {
      "hex": "#9c9e87",
      "hls": [
        0.18115942028985507,
        0.572265625,
        0.1050228310502283
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.183.jpg",
    "colors": {
      "hex": "#a4a58a",
      "hls": [
        0.17283950617283952,
        0.591796875,
        0.1291866028708134
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.184.jpg",
    "colors": {
      "hex": "#a4a593",
      "hls": [
        0.1759259259259259,
        0.609375,
        0.09
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.185.jpg",
    "colors": {
      "hex": "#9d9b82",
      "hls": [
        0.15432098765432098,
        0.560546875,
        0.12
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.186.jpg",
    "colors": {
      "hex": "#a1a28d",
      "hls": [
        0.17460317460317457,
        0.591796875,
        0.10047846889952153
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.187.jpg",
    "colors": {
      "hex": "#a1a38e",
      "hls": [
        0.18253968253968256,
        0.595703125,
        0.10144927536231885
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.188.jpg",
    "colors": {
      "hex": "#aab29d",
      "hls": [
        0.23015873015873015,
        0.654296875,
        0.11864406779661017
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.189.jpg",
    "colors": {
      "hex": "#999b88",
      "hls": [
        0.18421052631578946,
        0.568359375,
        0.08597285067873303
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.19.jpg",
    "colors": {
      "hex": "#a7aa99",
      "hls": [
        0.196078431372549,
        0.630859375,
        0.08994708994708994
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.190.jpg",
    "colors": {
      "hex": "#969986",
      "hls": [
        0.1929824561403509,
        0.560546875,
        0.08444444444444445
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.191.jpg",
    "colors": {
      "hex": "#a2a391",
      "hls": [
        0.1759259259259259,
        0.6015625,
        0.08823529411764706
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.192.jpg",
    "colors": {
      "hex": "#8c937f",
      "hls": [
        0.225,
        0.53515625,
        0.08403361344537816
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.193.jpg",
    "colors": {
      "hex": "#b1b8a0",
      "hls": [
        0.21527777777777776,
        0.671875,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.194.jpg",
    "colors": {
      "hex": "#a9ad98",
      "hls": [
        0.19841269841269846,
        0.634765625,
        0.11229946524064172
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.196.jpg",
    "colors": {
      "hex": "#999880",
      "hls": [
        0.16,
        0.548828125,
        0.10822510822510822
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.197.jpg",
    "colors": {
      "hex": "#979b8c",
      "hls": [
        0.2111111111111111,
        0.576171875,
        0.06912442396313365
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.198.jpg",
    "colors": {
      "hex": "#a8a994",
      "hls": [
        0.17460317460317457,
        0.619140625,
        0.1076923076923077
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.199.jpg",
    "colors": {
      "hex": "#919889",
      "hls": [
        0.24444444444444446,
        0.564453125,
        0.06726457399103139
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.20.jpg",
    "colors": {
      "hex": "#919184",
      "hls": [
        0.16666666666666666,
        0.541015625,
        0.05531914893617021
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.200.jpg",
    "colors": {
      "hex": "#b0b499",
      "hls": [
        0.191358024691358,
        0.650390625,
        0.15083798882681565
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.201.jpg",
    "colors": {
      "hex": "#a9ad94",
      "hls": [
        0.19333333333333336,
        0.626953125,
        0.13089005235602094
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.203.jpg",
    "colors": {
      "hex": "#a6a58f",
      "hls": [
        0.15942028985507248,
        0.603515625,
        0.11330049261083744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.204.jpg",
    "colors": {
      "hex": "#989483",
      "hls": [
        0.1349206349206349,
        0.552734375,
        0.09170305676855896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.205.jpg",
    "colors": {
      "hex": "#9fa08c",
      "hls": [
        0.17499999999999996,
        0.5859375,
        0.09433962264150944
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.206.jpg",
    "colors": {
      "hex": "#b0b69d",
      "hls": [
        0.2066666666666667,
        0.662109375,
        0.14450867052023122
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.207.jpg",
    "colors": {
      "hex": "#969686",
      "hls": [
        0.16666666666666666,
        0.5546875,
        0.07017543859649122
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.208.jpg",
    "colors": {
      "hex": "#a3a695",
      "hls": [
        0.196078431372549,
        0.615234375,
        0.08629441624365482
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.209.jpg",
    "colors": {
      "hex": "#9ba08e",
      "hls": [
        0.21296296296296294,
        0.58984375,
        0.08571428571428572
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.21.jpg",
    "colors": {
      "hex": "#a4a994",
      "hls": [
        0.20634920634920637,
        0.619140625,
        0.1076923076923077
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.210.jpg",
    "colors": {
      "hex": "#9da291",
      "hls": [
        0.2156862745098039,
        0.599609375,
        0.08292682926829269
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.211.jpg",
    "colors": {
      "hex": "#afb59d",
      "hls": [
        0.20833333333333334,
        0.66015625,
        0.13793103448275862
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.212.jpg",
    "colors": {
      "hex": "#9d9d8a",
      "hls": [
        0.16666666666666666,
        0.576171875,
        0.08755760368663594
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.213.jpg",
    "colors": {
      "hex": "#acb097",
      "hls": [
        0.19333333333333336,
        0.638671875,
        0.13513513513513514
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.214.jpg",
    "colors": {
      "hex": "#a5ab9b",
      "hls": [
        0.22916666666666666,
        0.63671875,
        0.08602150537634409
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.215.jpg",
    "colors": {
      "hex": "#999d86",
      "hls": [
        0.19565217391304346,
        0.568359375,
        0.10407239819004525
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.216.jpg",
    "colors": {
      "hex": "#aeb8a5",
      "hls": [
        0.25438596491228066,
        0.681640625,
        0.1165644171779141
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.217.jpg",
    "colors": {
      "hex": "#a6a38b",
      "hls": [
        0.14814814814814814,
        0.595703125,
        0.13043478260869565
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.218.jpg",
    "colors": {
      "hex": "#969d85",
      "hls": [
        0.21527777777777776,
        0.56640625,
        0.10810810810810811
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.22.jpg",
    "colors": {
      "hex": "#9a9b8b",
      "hls": [
        0.17708333333333334,
        0.57421875,
        0.07339449541284404
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.220.jpg",
    "colors": {
      "hex": "#a7a792",
      "hls": [
        0.16666666666666666,
        0.611328125,
        0.10552763819095477
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.221.jpg",
    "colors": {
      "hex": "#a9ad96",
      "hls": [
        0.19565217391304346,
        0.630859375,
        0.12169312169312169
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.222.jpg",
    "colors": {
      "hex": "#adb59e",
      "hls": [
        0.22463768115942026,
        0.662109375,
        0.1329479768786127
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.224.jpg",
    "colors": {
      "hex": "#b3b39c",
      "hls": [
        0.16666666666666666,
        0.654296875,
        0.12994350282485875
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.226.jpg",
    "colors": {
      "hex": "#9d9e84",
      "hls": [
        0.17307692307692304,
        0.56640625,
        0.11711711711711711
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.227.jpg",
    "colors": {
      "hex": "#9fa38e",
      "hls": [
        0.19841269841269846,
        0.595703125,
        0.10144927536231885
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.229.jpg",
    "colors": {
      "hex": "#b0b5a4",
      "hls": [
        0.2156862745098039,
        0.673828125,
        0.10179640718562874
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.23.jpg",
    "colors": {
      "hex": "#9c9d8d",
      "hls": [
        0.17708333333333334,
        0.58203125,
        0.07476635514018691
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.230.jpg",
    "colors": {
      "hex": "#b3b59b",
      "hls": [
        0.17948717948717952,
        0.65625,
        0.14772727272727273
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.231.jpg",
    "colors": {
      "hex": "#b0b29a",
      "hls": [
        0.18055555555555558,
        0.6484375,
        0.13333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.232.jpg",
    "colors": {
      "hex": "#a2a68f",
      "hls": [
        0.19565217391304346,
        0.603515625,
        0.11330049261083744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.233.jpg",
    "colors": {
      "hex": "#a9ab93",
      "hls": [
        0.18055555555555558,
        0.62109375,
        0.12371134020618557
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.234.jpg",
    "colors": {
      "hex": "#aeb59f",
      "hls": [
        0.21969696969696972,
        0.6640625,
        0.12790697674418605
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.236.jpg",
    "colors": {
      "hex": "#9b9e90",
      "hls": [
        0.2023809523809524,
        0.58984375,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.237.jpg",
    "colors": {
      "hex": "#b0b6a4",
      "hls": [
        0.22222222222222224,
        0.67578125,
        0.10843373493975904
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.238.jpg",
    "colors": {
      "hex": "#a2a590",
      "hls": [
        0.19047619047619047,
        0.603515625,
        0.10344827586206896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.239.jpg",
    "colors": {
      "hex": "#a9a693",
      "hls": [
        0.14393939393939395,
        0.6171875,
        0.11224489795918367
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.24.jpg",
    "colors": {
      "hex": "#93978a",
      "hls": [
        0.21794871794871792,
        0.564453125,
        0.05829596412556054
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.240.jpg",
    "colors": {
      "hex": "#a2a395",
      "hls": [
        0.1785714285714286,
        0.609375,
        0.07
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.241.jpg",
    "colors": {
      "hex": "#b9bcab",
      "hls": [
        0.196078431372549,
        0.701171875,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.242.jpg",
    "colors": {
      "hex": "#989e87",
      "hls": [
        0.21014492753623185,
        0.572265625,
        0.1050228310502283
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.243.jpg",
    "colors": {
      "hex": "#92978b",
      "hls": [
        0.23611111111111108,
        0.56640625,
        0.05405405405405406
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.244.jpg",
    "colors": {
      "hex": "#969588",
      "hls": [
        0.15476190476190477,
        0.55859375,
        0.061946902654867256
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.245.jpg",
    "colors": {
      "hex": "#a7ac9f",
      "hls": [
        0.23076923076923075,
        0.646484375,
        0.0718232044198895
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.247.jpg",
    "colors": {
      "hex": "#9fa08c",
      "hls": [
        0.17499999999999996,
        0.5859375,
        0.09433962264150944
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.248.jpg",
    "colors": {
      "hex": "#959c87",
      "hls": [
        0.22222222222222224,
        0.568359375,
        0.09502262443438914
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.249.jpg",
    "colors": {
      "hex": "#a8a690",
      "hls": [
        0.15277777777777776,
        0.609375,
        0.12
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.25.jpg",
    "colors": {
      "hex": "#9ca28c",
      "hls": [
        0.21212121212121207,
        0.58984375,
        0.10476190476190476
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.250.jpg",
    "colors": {
      "hex": "#8a8b76",
      "hls": [
        0.17460317460317457,
        0.501953125,
        0.08235294117647059
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.26.jpg",
    "colors": {
      "hex": "#949b92",
      "hls": [
        0.2962962962962963,
        0.587890625,
        0.04265402843601896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.29.jpg",
    "colors": {
      "hex": "#93907f",
      "hls": [
        0.14166666666666666,
        0.53515625,
        0.08403361344537816
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.30.jpg",
    "colors": {
      "hex": "#929784",
      "hls": [
        0.21052631578947367,
        0.552734375,
        0.08296943231441048
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.31.jpg",
    "colors": {
      "hex": "#b3b5a3",
      "hls": [
        0.1851851851851852,
        0.671875,
        0.10714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.33.jpg",
    "colors": {
      "hex": "#a3a895",
      "hls": [
        0.21052631578947367,
        0.619140625,
        0.09743589743589744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.34.jpg",
    "colors": {
      "hex": "#8d8f86",
      "hls": [
        0.20370370370370372,
        0.541015625,
        0.03829787234042553
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.35.jpg",
    "colors": {
      "hex": "#8d8d81",
      "hls": [
        0.16666666666666666,
        0.52734375,
        0.049586776859504134
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.36.jpg",
    "colors": {
      "hex": "#abaf9c",
      "hls": [
        0.20175438596491224,
        0.646484375,
        0.10497237569060773
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.37.jpg",
    "colors": {
      "hex": "#979b8e",
      "hls": [
        0.21794871794871792,
        0.580078125,
        0.06046511627906977
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.38.jpg",
    "colors": {
      "hex": "#aaafa0",
      "hls": [
        0.22222222222222224,
        0.654296875,
        0.0847457627118644
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.39.jpg",
    "colors": {
      "hex": "#9ca08e",
      "hls": [
        0.20370370370370372,
        0.58984375,
        0.08571428571428572
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.41.jpg",
    "colors": {
      "hex": "#a3a490",
      "hls": [
        0.17499999999999996,
        0.6015625,
        0.09803921568627451
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.42.jpg",
    "colors": {
      "hex": "#9ea694",
      "hls": [
        0.24074074074074078,
        0.61328125,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.43.jpg",
    "colors": {
      "hex": "#a0a18b",
      "hls": [
        0.17424242424242423,
        0.5859375,
        0.10377358490566038
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.44.jpg",
    "colors": {
      "hex": "#909487",
      "hls": [
        0.21794871794871792,
        0.552734375,
        0.056768558951965066
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.45.jpg",
    "colors": {
      "hex": "#9a9c8f",
      "hls": [
        0.1923076923076923,
        0.583984375,
        0.06103286384976526
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.46.jpg",
    "colors": {
      "hex": "#b0b4a5",
      "hls": [
        0.2111111111111111,
        0.673828125,
        0.08982035928143713
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.47.jpg",
    "colors": {
      "hex": "#9c9d90",
      "hls": [
        0.17948717948717952,
        0.587890625,
        0.061611374407582936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.48.jpg",
    "colors": {
      "hex": "#a6a997",
      "hls": [
        0.19444444444444442,
        0.625,
        0.09375
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.49.jpg",
    "colors": {
      "hex": "#9fa494",
      "hls": [
        0.21875,
        0.609375,
        0.08
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.50.jpg",
    "colors": {
      "hex": "#a9ab96",
      "hls": [
        0.18253968253968256,
        0.626953125,
        0.1099476439790576
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.51.jpg",
    "colors": {
      "hex": "#a1a389",
      "hls": [
        0.17948717948717952,
        0.5859375,
        0.12264150943396226
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.52.jpg",
    "colors": {
      "hex": "#929481",
      "hls": [
        0.18421052631578946,
        0.541015625,
        0.08085106382978724
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.53.jpg",
    "colors": {
      "hex": "#8f9284",
      "hls": [
        0.2023809523809524,
        0.54296875,
        0.05982905982905983
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.54.jpg",
    "colors": {
      "hex": "#8f988c",
      "hls": [
        0.2916666666666667,
        0.5703125,
        0.05454545454545454
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.55.jpg",
    "colors": {
      "hex": "#929885",
      "hls": [
        0.2192982456140351,
        0.556640625,
        0.08370044052863436
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.56.jpg",
    "colors": {
      "hex": "#959a87",
      "hls": [
        0.21052631578947367,
        0.564453125,
        0.08520179372197309
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.57.jpg",
    "colors": {
      "hex": "#a6ae9e",
      "hls": [
        0.25,
        0.6484375,
        0.08888888888888889
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.58.jpg",
    "colors": {
      "hex": "#b8baa9",
      "hls": [
        0.18627450980392157,
        0.693359375,
        0.10828025477707007
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.59.jpg",
    "colors": {
      "hex": "#aeab95",
      "hls": [
        0.14666666666666667,
        0.630859375,
        0.13227513227513227
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.6.jpg",
    "colors": {
      "hex": "#8c897c",
      "hls": [
        0.13541666666666666,
        0.515625,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.60.jpg",
    "colors": {
      "hex": "#a5a798",
      "hls": [
        0.18888888888888888,
        0.623046875,
        0.07772020725388601
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.61.jpg",
    "colors": {
      "hex": "#999987",
      "hls": [
        0.16666666666666666,
        0.5625,
        0.08035714285714286
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.62.jpg",
    "colors": {
      "hex": "#a2a492",
      "hls": [
        0.1851851851851852,
        0.60546875,
        0.0891089108910891
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.63.jpg",
    "colors": {
      "hex": "#aba992",
      "hls": [
        0.15333333333333335,
        0.619140625,
        0.1282051282051282
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.64.jpg",
    "colors": {
      "hex": "#92917e",
      "hls": [
        0.15833333333333333,
        0.53125,
        0.08333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.66.jpg",
    "colors": {
      "hex": "#989e8c",
      "hls": [
        0.22222222222222224,
        0.58203125,
        0.08411214953271028
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.67.jpg",
    "colors": {
      "hex": "#90988e",
      "hls": [
        0.3,
        0.57421875,
        0.045871559633027525
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.68.jpg",
    "colors": {
      "hex": "#969d8f",
      "hls": [
        0.25,
        0.5859375,
        0.0660377358490566
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.69.jpg",
    "colors": {
      "hex": "#a9a292",
      "hls": [
        0.11594202898550725,
        0.615234375,
        0.116751269035533
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.7.jpg",
    "colors": {
      "hex": "#91887c",
      "hls": [
        0.09523809523809523,
        0.525390625,
        0.08641975308641975
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.70.jpg",
    "colors": {
      "hex": "#a1a194",
      "hls": [
        0.16666666666666666,
        0.603515625,
        0.06403940886699508
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.71.jpg",
    "colors": {
      "hex": "#9ba194",
      "hls": [
        0.2435897435897436,
        0.603515625,
        0.06403940886699508
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.72.jpg",
    "colors": {
      "hex": "#959a89",
      "hls": [
        0.2156862745098039,
        0.568359375,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.73.jpg",
    "colors": {
      "hex": "#9ea096",
      "hls": [
        0.20000000000000004,
        0.60546875,
        0.04950495049504951
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.74.jpg",
    "colors": {
      "hex": "#949487",
      "hls": [
        0.16666666666666666,
        0.552734375,
        0.056768558951965066
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.76.jpg",
    "colors": {
      "hex": "#8d958c",
      "hls": [
        0.3148148148148148,
        0.564453125,
        0.04035874439461883
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.77.jpg",
    "colors": {
      "hex": "#929687",
      "hls": [
        0.2111111111111111,
        0.556640625,
        0.06607929515418502
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.78.jpg",
    "colors": {
      "hex": "#a3aa9e",
      "hls": [
        0.2638888888888889,
        0.640625,
        0.06521739130434782
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.79.jpg",
    "colors": {
      "hex": "#aeb2a3",
      "hls": [
        0.2111111111111111,
        0.666015625,
        0.08771929824561403
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.8.jpg",
    "colors": {
      "hex": "#a6aca3",
      "hls": [
        0.27777777777777773,
        0.654296875,
        0.05084745762711865
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.80.jpg",
    "colors": {
      "hex": "#acb1a1",
      "hls": [
        0.21875,
        0.66015625,
        0.09195402298850575
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.81.jpg",
    "colors": {
      "hex": "#979e93",
      "hls": [
        0.2727272727272727,
        0.595703125,
        0.05314009661835749
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.82.jpg",
    "colors": {
      "hex": "#acac99",
      "hls": [
        0.16666666666666666,
        0.634765625,
        0.10160427807486631
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.83.jpg",
    "colors": {
      "hex": "#8e9688",
      "hls": [
        0.26190476190476186,
        0.55859375,
        0.061946902654867256
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.84.jpg",
    "colors": {
      "hex": "#a4a493",
      "hls": [
        0.16666666666666666,
        0.607421875,
        0.0845771144278607
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.85.jpg",
    "colors": {
      "hex": "#aeb3a2",
      "hls": [
        0.2156862745098039,
        0.666015625,
        0.09941520467836257
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.86.jpg",
    "colors": {
      "hex": "#919481",
      "hls": [
        0.1929824561403509,
        0.541015625,
        0.08085106382978724
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.87.jpg",
    "colors": {
      "hex": "#999783",
      "hls": [
        0.15151515151515152,
        0.5546875,
        0.09649122807017543
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.88.jpg",
    "colors": {
      "hex": "#a4a38e",
      "hls": [
        0.1590909090909091,
        0.59765625,
        0.10679611650485436
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.89.jpg",
    "colors": {
      "hex": "#9a9f8c",
      "hls": [
        0.21052631578947367,
        0.583984375,
        0.0892018779342723
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.9.jpg",
    "colors": {
      "hex": "#a2a9a2",
      "hls": [
        0.3333333333333333,
        0.646484375,
        0.03867403314917127
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.90.jpg",
    "colors": {
      "hex": "#a1a48f",
      "hls": [
        0.19047619047619047,
        0.599609375,
        0.1024390243902439
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.91.jpg",
    "colors": {
      "hex": "#9ea08c",
      "hls": [
        0.18333333333333335,
        0.5859375,
        0.09433962264150944
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.92.jpg",
    "colors": {
      "hex": "#a0a694",
      "hls": [
        0.22222222222222224,
        0.61328125,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.93.jpg",
    "colors": {
      "hex": "#959d91",
      "hls": [
        0.27777777777777773,
        0.58984375,
        0.05714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.94.jpg",
    "colors": {
      "hex": "#a0a89e",
      "hls": [
        0.3,
        0.63671875,
        0.053763440860215055
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.95.jpg",
    "colors": {
      "hex": "#a1a08b",
      "hls": [
        0.1590909090909091,
        0.5859375,
        0.10377358490566038
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.96.jpg",
    "colors": {
      "hex": "#979482",
      "hls": [
        0.14285714285714288,
        0.548828125,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.97.jpg",
    "colors": {
      "hex": "#a3a79c",
      "hls": [
        0.2272727272727273,
        0.630859375,
        0.0582010582010582
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.98.jpg",
    "colors": {
      "hex": "#a8a895",
      "hls": [
        0.16666666666666666,
        0.619140625,
        0.09743589743589744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D013.99.jpg",
    "colors": {
      "hex": "#9a9d8d",
      "hls": [
        0.19791666666666666,
        0.58203125,
        0.07476635514018691
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.10.jpg",
    "colors": {
      "hex": "#9ab390",
      "hls": [
        0.28571428571428575,
        0.630859375,
        0.18518518518518517
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.100.jpg",
    "colors": {
      "hex": "#92ad7e",
      "hls": [
        0.2624113475177305,
        0.583984375,
        0.22065727699530516
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.101.jpg",
    "colors": {
      "hex": "#94b48a",
      "hls": [
        0.29365079365079366,
        0.62109375,
        0.21649484536082475
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.102.jpg",
    "colors": {
      "hex": "#90b082",
      "hls": [
        0.2826086956521739,
        0.59765625,
        0.22330097087378642
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.11.jpg",
    "colors": {
      "hex": "#8dac87",
      "hls": [
        0.3063063063063063,
        0.599609375,
        0.18048780487804877
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.12.jpg",
    "colors": {
      "hex": "#bbb2ab",
      "hls": [
        0.07291666666666667,
        0.69921875,
        0.1038961038961039
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.13.jpg",
    "colors": {
      "hex": "#c2b8b3",
      "hls": [
        0.05555555555555556,
        0.728515625,
        0.1079136690647482
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.14.jpg",
    "colors": {
      "hex": "#83a88f",
      "hls": [
        0.3873873873873874,
        0.583984375,
        0.17370892018779344
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.15.jpg",
    "colors": {
      "hex": "#948a85",
      "hls": [
        0.05555555555555556,
        0.548828125,
        0.06493506493506493
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.17.jpg",
    "colors": {
      "hex": "#aec5a6",
      "hls": [
        0.2903225806451613,
        0.708984375,
        0.2080536912751678
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.18.jpg",
    "colors": {
      "hex": "#9ab391",
      "hls": [
        0.28921568627450983,
        0.6328125,
        0.18085106382978725
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.19.jpg",
    "colors": {
      "hex": "#a49692",
      "hls": [
        0.037037037037037035,
        0.60546875,
        0.0891089108910891
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.20.jpg",
    "colors": {
      "hex": "#90827e",
      "hls": [
        0.037037037037037035,
        0.52734375,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.21.jpg",
    "colors": {
      "hex": "#8a8079",
      "hls": [
        0.06862745098039215,
        0.505859375,
        0.06719367588932806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.22.jpg",
    "colors": {
      "hex": "#8e8681",
      "hls": [
        0.0641025641025641,
        0.529296875,
        0.05394190871369295
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.23.jpg",
    "colors": {
      "hex": "#8c7e7d",
      "hls": [
        0.011111111111111108,
        0.517578125,
        0.06072874493927125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.24.jpg",
    "colors": {
      "hex": "#86a583",
      "hls": [
        0.31862745098039214,
        0.578125,
        0.1574074074074074
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.25.jpg",
    "colors": {
      "hex": "#81a77c",
      "hls": [
        0.31395348837209297,
        0.568359375,
        0.19457013574660634
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.26.jpg",
    "colors": {
      "hex": "#88ab82",
      "hls": [
        0.30894308943089427,
        0.587890625,
        0.1943127962085308
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.27.jpg",
    "colors": {
      "hex": "#88a992",
      "hls": [
        0.3838383838383838,
        0.595703125,
        0.15942028985507245
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.28.jpg",
    "colors": {
      "hex": "#7b9a8f",
      "hls": [
        0.44086021505376344,
        0.541015625,
        0.13191489361702127
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.29.jpg",
    "colors": {
      "hex": "#7c8995",
      "hls": [
        0.5800000000000001,
        0.533203125,
        0.10460251046025104
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.3.jpg",
    "colors": {
      "hex": "#8a827c",
      "hls": [
        0.07142857142857144,
        0.51171875,
        0.056
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.30.jpg",
    "colors": {
      "hex": "#9a8b8a",
      "hls": [
        0.010416666666666666,
        0.5703125,
        0.07272727272727272
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.31.jpg",
    "colors": {
      "hex": "#918684",
      "hls": [
        0.025641025641025644,
        0.541015625,
        0.05531914893617021
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.32.jpg",
    "colors": {
      "hex": "#a39998",
      "hls": [
        0.015151515151515157,
        0.615234375,
        0.05583756345177665
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.33.jpg",
    "colors": {
      "hex": "#998887",
      "hls": [
        0.009259259259259264,
        0.5625,
        0.08035714285714286
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.34.jpg",
    "colors": {
      "hex": "#81a586",
      "hls": [
        0.35648148148148145,
        0.57421875,
        0.1651376146788991
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.35.jpg",
    "colors": {
      "hex": "#95a383",
      "hls": [
        0.23958333333333334,
        0.57421875,
        0.14678899082568808
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.36.jpg",
    "colors": {
      "hex": "#84ac7f",
      "hls": [
        0.3148148148148148,
        0.583984375,
        0.2112676056338028
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.37.jpg",
    "colors": {
      "hex": "#8eae8b",
      "hls": [
        0.319047619047619,
        0.611328125,
        0.17587939698492464
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.38.jpg",
    "colors": {
      "hex": "#a6a187",
      "hls": [
        0.13978494623655915,
        0.587890625,
        0.14691943127962084
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.39.jpg",
    "colors": {
      "hex": "#899178",
      "hls": [
        0.21999999999999997,
        0.517578125,
        0.10121457489878542
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.4.jpg",
    "colors": {
      "hex": "#8e8380",
      "hls": [
        0.03571428571428572,
        0.52734375,
        0.05785123966942149
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.40.jpg",
    "colors": {
      "hex": "#8f8b84",
      "hls": [
        0.10606060606060606,
        0.537109375,
        0.046413502109704644
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.41.jpg",
    "colors": {
      "hex": "#9b9690",
      "hls": [
        0.0909090909090909,
        0.583984375,
        0.051643192488262914
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.42.jpg",
    "colors": {
      "hex": "#9f9a95",
      "hls": [
        0.08333333333333333,
        0.6015625,
        0.049019607843137254
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.43.jpg",
    "colors": {
      "hex": "#8a8581",
      "hls": [
        0.07407407407407407,
        0.521484375,
        0.036734693877551024
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.45.jpg",
    "colors": {
      "hex": "#a19591",
      "hls": [
        0.041666666666666664,
        0.59765625,
        0.07766990291262135
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.46.jpg",
    "colors": {
      "hex": "#9c8e86",
      "hls": [
        0.06060606060606061,
        0.56640625,
        0.0990990990990991
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.47.jpg",
    "colors": {
      "hex": "#918681",
      "hls": [
        0.052083333333333336,
        0.53515625,
        0.06722689075630252
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.48.jpg",
    "colors": {
      "hex": "#8b8078",
      "hls": [
        0.07017543859649122,
        0.505859375,
        0.07509881422924901
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.5.jpg",
    "colors": {
      "hex": "#94807f",
      "hls": [
        0.007936507936507945,
        0.537109375,
        0.08860759493670886
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.51.jpg",
    "colors": {
      "hex": "#90af86",
      "hls": [
        0.2926829268292683,
        0.603515625,
        0.2019704433497537
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.52.jpg",
    "colors": {
      "hex": "#afc2bb",
      "hls": [
        0.4385964912280702,
        0.720703125,
        0.13286713286713286
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.53.jpg",
    "colors": {
      "hex": "#84817b",
      "hls": [
        0.11111111111111112,
        0.498046875,
        0.03529411764705882
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.56.jpg",
    "colors": {
      "hex": "#86a883",
      "hls": [
        0.31981981981981983,
        0.583984375,
        0.17370892018779344
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.57.jpg",
    "colors": {
      "hex": "#87847f",
      "hls": [
        0.10416666666666667,
        0.51171875,
        0.032
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.58.jpg",
    "colors": {
      "hex": "#86837b",
      "hls": [
        0.12121212121212122,
        0.501953125,
        0.043137254901960784
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.59.jpg",
    "colors": {
      "hex": "#93918b",
      "hls": [
        0.125,
        0.55859375,
        0.035398230088495575
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.6.jpg",
    "colors": {
      "hex": "#8b7c79",
      "hls": [
        0.027777777777777773,
        0.5078125,
        0.07142857142857142
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.60.jpg",
    "colors": {
      "hex": "#938e88",
      "hls": [
        0.0909090909090909,
        0.552734375,
        0.048034934497816595
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.61.jpg",
    "colors": {
      "hex": "#93aa9f",
      "hls": [
        0.4202898550724638,
        0.619140625,
        0.11794871794871795
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.62.jpg",
    "colors": {
      "hex": "#96938c",
      "hls": [
        0.11666666666666665,
        0.56640625,
        0.04504504504504504
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.63.jpg",
    "colors": {
      "hex": "#84a093",
      "hls": [
        0.4226190476190476,
        0.5703125,
        0.12727272727272726
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.64.jpg",
    "colors": {
      "hex": "#819f82",
      "hls": [
        0.33888888888888885,
        0.5625,
        0.13392857142857142
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.65.jpg",
    "colors": {
      "hex": "#7e7671",
      "hls": [
        0.0641025641025641,
        0.466796875,
        0.05439330543933055
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.66.jpg",
    "colors": {
      "hex": "#90aa7f",
      "hls": [
        0.2674418604651163,
        0.580078125,
        0.2
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.67.jpg",
    "colors": {
      "hex": "#94a67e",
      "hls": [
        0.2416666666666667,
        0.5703125,
        0.18181818181818182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.68.jpg",
    "colors": {
      "hex": "#92a57d",
      "hls": [
        0.24583333333333335,
        0.56640625,
        0.18018018018018017
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.69.jpg",
    "colors": {
      "hex": "#85949d",
      "hls": [
        0.5625,
        0.56640625,
        0.10810810810810811
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.7.jpg",
    "colors": {
      "hex": "#a7af95",
      "hls": [
        0.21794871794871792,
        0.6328125,
        0.13829787234042554
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.70.jpg",
    "colors": {
      "hex": "#888981",
      "hls": [
        0.1875,
        0.51953125,
        0.032520325203252036
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.71.jpg",
    "colors": {
      "hex": "#86827e",
      "hls": [
        0.08333333333333333,
        0.5078125,
        0.031746031746031744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.72.jpg",
    "colors": {
      "hex": "#938c84",
      "hls": [
        0.08888888888888889,
        0.544921875,
        0.06437768240343347
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.73.jpg",
    "colors": {
      "hex": "#857f76",
      "hls": [
        0.09999999999999999,
        0.490234375,
        0.05976095617529881
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.74.jpg",
    "colors": {
      "hex": "#85847c",
      "hls": [
        0.14814814814814814,
        0.501953125,
        0.03529411764705882
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.76.jpg",
    "colors": {
      "hex": "#a3b491",
      "hls": [
        0.24761904761904763,
        0.634765625,
        0.18716577540106952
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.77.jpg",
    "colors": {
      "hex": "#97b084",
      "hls": [
        0.2613636363636364,
        0.6015625,
        0.21568627450980393
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.78.jpg",
    "colors": {
      "hex": "#8aaf82",
      "hls": [
        0.30370370370370364,
        0.595703125,
        0.21739130434782608
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.79.jpg",
    "colors": {
      "hex": "#97938f",
      "hls": [
        0.08333333333333333,
        0.57421875,
        0.03669724770642202
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.8.jpg",
    "colors": {
      "hex": "#91b098",
      "hls": [
        0.3709677419354838,
        0.626953125,
        0.16230366492146597
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.80.jpg",
    "colors": {
      "hex": "#8d8a83",
      "hls": [
        0.11666666666666665,
        0.53125,
        0.041666666666666664
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.81.jpg",
    "colors": {
      "hex": "#95918f",
      "hls": [
        0.05555555555555556,
        0.5703125,
        0.02727272727272727
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.82.jpg",
    "colors": {
      "hex": "#8c8b83",
      "hls": [
        0.14814814814814814,
        0.529296875,
        0.03734439834024896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.83.jpg",
    "colors": {
      "hex": "#968c82",
      "hls": [
        0.08333333333333333,
        0.546875,
        0.08620689655172414
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.86.jpg",
    "colors": {
      "hex": "#93b284",
      "hls": [
        0.2789855072463768,
        0.60546875,
        0.22772277227722773
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.87.jpg",
    "colors": {
      "hex": "#9ab68f",
      "hls": [
        0.28632478632478636,
        0.634765625,
        0.20855614973262032
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.88.jpg",
    "colors": {
      "hex": "#8c8680",
      "hls": [
        0.08333333333333333,
        0.5234375,
        0.04918032786885246
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.89.jpg",
    "colors": {
      "hex": "#97928b",
      "hls": [
        0.09722222222222221,
        0.56640625,
        0.05405405405405406
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.9.jpg",
    "colors": {
      "hex": "#99b69f",
      "hls": [
        0.367816091954023,
        0.654296875,
        0.1638418079096045
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.90.jpg",
    "colors": {
      "hex": "#9f9283",
      "hls": [
        0.08928571428571429,
        0.56640625,
        0.12612612612612611
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.91.jpg",
    "colors": {
      "hex": "#8e8882",
      "hls": [
        0.08333333333333333,
        0.53125,
        0.05
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.92.jpg",
    "colors": {
      "hex": "#93908a",
      "hls": [
        0.11111111111111112,
        0.556640625,
        0.039647577092511016
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.93.jpg",
    "colors": {
      "hex": "#98958e",
      "hls": [
        0.11666666666666665,
        0.57421875,
        0.045871559633027525
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.94.jpg",
    "colors": {
      "hex": "#8c9182",
      "hls": [
        0.22222222222222224,
        0.537109375,
        0.06329113924050633
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.95.jpg",
    "colors": {
      "hex": "#908e89",
      "hls": [
        0.11904761904761905,
        0.548828125,
        0.030303030303030304
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.96.jpg",
    "colors": {
      "hex": "#89837d",
      "hls": [
        0.08333333333333333,
        0.51171875,
        0.048
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.97.jpg",
    "colors": {
      "hex": "#94a27f",
      "hls": [
        0.2333333333333333,
        0.564453125,
        0.15695067264573992
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.98.jpg",
    "colors": {
      "hex": "#adb398",
      "hls": [
        0.20370370370370372,
        0.646484375,
        0.14917127071823205
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D018.99.jpg",
    "colors": {
      "hex": "#91a080",
      "hls": [
        0.24479166666666666,
        0.5625,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.10.jpg",
    "colors": {
      "hex": "#7f7b72",
      "hls": [
        0.11538461538461538,
        0.470703125,
        0.05394190871369295
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.100.jpg",
    "colors": {
      "hex": "#a0b593",
      "hls": [
        0.2696078431372549,
        0.640625,
        0.18478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.101.jpg",
    "colors": {
      "hex": "#9bb19e",
      "hls": [
        0.356060606060606,
        0.6484375,
        0.12222222222222222
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.102.jpg",
    "colors": {
      "hex": "#8c9e8a",
      "hls": [
        0.31666666666666665,
        0.578125,
        0.09259259259259259
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.103.jpg",
    "colors": {
      "hex": "#80a189",
      "hls": [
        0.37878787878787873,
        0.564453125,
        0.14798206278026907
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.104.jpg",
    "colors": {
      "hex": "#80a084",
      "hls": [
        0.3541666666666667,
        0.5625,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.105.jpg",
    "colors": {
      "hex": "#84a284",
      "hls": [
        0.3333333333333333,
        0.57421875,
        0.13761467889908258
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.106.jpg",
    "colors": {
      "hex": "#82a287",
      "hls": [
        0.359375,
        0.5703125,
        0.14545454545454545
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.107.jpg",
    "colors": {
      "hex": "#98ad82",
      "hls": [
        0.24806201550387597,
        0.591796875,
        0.20574162679425836
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.108.jpg",
    "colors": {
      "hex": "#88a38d",
      "hls": [
        0.36419753086419754,
        0.583984375,
        0.1267605633802817
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.109.jpg",
    "colors": {
      "hex": "#85a885",
      "hls": [
        0.3333333333333333,
        0.587890625,
        0.16587677725118483
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.11.jpg",
    "colors": {
      "hex": "#7a7b75",
      "hls": [
        0.19444444444444442,
        0.46875,
        0.025
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.110.jpg",
    "colors": {
      "hex": "#a1a980",
      "hls": [
        0.19918699186991873,
        0.580078125,
        0.19069767441860466
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.111.jpg",
    "colors": {
      "hex": "#83a895",
      "hls": [
        0.4144144144144144,
        0.583984375,
        0.17370892018779344
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.112.jpg",
    "colors": {
      "hex": "#919b80",
      "hls": [
        0.22839506172839505,
        0.552734375,
        0.11790393013100436
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.113.jpg",
    "colors": {
      "hex": "#a2b699",
      "hls": [
        0.28160919540229884,
        0.654296875,
        0.1638418079096045
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.117.jpg",
    "colors": {
      "hex": "#8ea28c",
      "hls": [
        0.3181818181818182,
        0.58984375,
        0.10476190476190476
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.12.jpg",
    "colors": {
      "hex": "#87837a",
      "hls": [
        0.11538461538461538,
        0.501953125,
        0.050980392156862744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.13.jpg",
    "colors": {
      "hex": "#7f7c74",
      "hls": [
        0.12121212121212122,
        0.474609375,
        0.04526748971193416
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.14.jpg",
    "colors": {
      "hex": "#86827d",
      "hls": [
        0.0925925925925926,
        0.505859375,
        0.03557312252964427
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.15.jpg",
    "colors": {
      "hex": "#8a8680",
      "hls": [
        0.09999999999999999,
        0.51953125,
        0.04065040650406504
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.16.jpg",
    "colors": {
      "hex": "#867f79",
      "hls": [
        0.07692307692307693,
        0.498046875,
        0.050980392156862744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.17.jpg",
    "colors": {
      "hex": "#908c82",
      "hls": [
        0.11904761904761905,
        0.53515625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.18.jpg",
    "colors": {
      "hex": "#998b81",
      "hls": [
        0.06944444444444443,
        0.55078125,
        0.10434782608695652
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.19.jpg",
    "colors": {
      "hex": "#89867d",
      "hls": [
        0.125,
        0.51171875,
        0.048
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.2.jpg",
    "colors": {
      "hex": "#8e867d",
      "hls": [
        0.08823529411764706,
        0.521484375,
        0.06938775510204082
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.20.jpg",
    "colors": {
      "hex": "#9c9088",
      "hls": [
        0.06666666666666667,
        0.5703125,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.22.jpg",
    "colors": {
      "hex": "#8c8982",
      "hls": [
        0.11666666666666665,
        0.52734375,
        0.04132231404958678
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.23.jpg",
    "colors": {
      "hex": "#8d8a84",
      "hls": [
        0.11111111111111112,
        0.533203125,
        0.03765690376569038
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.24.jpg",
    "colors": {
      "hex": "#958a81",
      "hls": [
        0.075,
        0.54296875,
        0.08547008547008547
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.25.jpg",
    "colors": {
      "hex": "#8f8680",
      "hls": [
        0.06666666666666667,
        0.529296875,
        0.06224066390041494
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.26.jpg",
    "colors": {
      "hex": "#908b82",
      "hls": [
        0.10714285714285714,
        0.53515625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.27.jpg",
    "colors": {
      "hex": "#877f78",
      "hls": [
        0.07777777777777778,
        0.498046875,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.28.jpg",
    "colors": {
      "hex": "#908782",
      "hls": [
        0.059523809523809514,
        0.53515625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.29.jpg",
    "colors": {
      "hex": "#87887e",
      "hls": [
        0.18333333333333335,
        0.51171875,
        0.04
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.30.jpg",
    "colors": {
      "hex": "#928881",
      "hls": [
        0.06862745098039215,
        0.537109375,
        0.07172995780590717
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.31.jpg",
    "colors": {
      "hex": "#89817b",
      "hls": [
        0.07142857142857144,
        0.5078125,
        0.05555555555555555
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.32.jpg",
    "colors": {
      "hex": "#938a85",
      "hls": [
        0.059523809523809514,
        0.546875,
        0.0603448275862069
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.33.jpg",
    "colors": {
      "hex": "#8c8a85",
      "hls": [
        0.11904761904761905,
        0.533203125,
        0.029288702928870293
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.34.jpg",
    "colors": {
      "hex": "#a1908d",
      "hls": [
        0.025000000000000005,
        0.58984375,
        0.09523809523809523
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.35.jpg",
    "colors": {
      "hex": "#8d7f7a",
      "hls": [
        0.04385964912280702,
        0.513671875,
        0.07630522088353414
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.36.jpg",
    "colors": {
      "hex": "#93827d",
      "hls": [
        0.03787878787878788,
        0.53125,
        0.09166666666666666
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.37.jpg",
    "colors": {
      "hex": "#96827c",
      "hls": [
        0.03846153846153846,
        0.53515625,
        0.1092436974789916
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.38.jpg",
    "colors": {
      "hex": "#7c7674",
      "hls": [
        0.041666666666666664,
        0.46875,
        0.03333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.39.jpg",
    "colors": {
      "hex": "#7c7973",
      "hls": [
        0.11111111111111112,
        0.466796875,
        0.03765690376569038
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.40.jpg",
    "colors": {
      "hex": "#857e79",
      "hls": [
        0.06944444444444443,
        0.49609375,
        0.047244094488188976
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.41.jpg",
    "colors": {
      "hex": "#9b8f87",
      "hls": [
        0.06666666666666667,
        0.56640625,
        0.09009009009009009
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.42.jpg",
    "colors": {
      "hex": "#91867e",
      "hls": [
        0.07017543859649122,
        0.529296875,
        0.07883817427385892
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.43.jpg",
    "colors": {
      "hex": "#827e76",
      "hls": [
        0.11111111111111112,
        0.484375,
        0.04838709677419355
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.44.jpg",
    "colors": {
      "hex": "#91867e",
      "hls": [
        0.07017543859649122,
        0.529296875,
        0.07883817427385892
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.45.jpg",
    "colors": {
      "hex": "#7b8472",
      "hls": [
        0.25,
        0.48046875,
        0.07317073170731707
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.46.jpg",
    "colors": {
      "hex": "#817d75",
      "hls": [
        0.11111111111111112,
        0.48046875,
        0.04878048780487805
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.47.jpg",
    "colors": {
      "hex": "#818678",
      "hls": [
        0.2261904761904762,
        0.49609375,
        0.05511811023622047
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.48.jpg",
    "colors": {
      "hex": "#7c7e7c",
      "hls": [
        0.3333333333333333,
        0.48828125,
        0.008
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.49.jpg",
    "colors": {
      "hex": "#9a8f79",
      "hls": [
        0.11111111111111112,
        0.537109375,
        0.13924050632911392
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.5.jpg",
    "colors": {
      "hex": "#989792",
      "hls": [
        0.1388888888888889,
        0.58203125,
        0.028037383177570093
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.50.jpg",
    "colors": {
      "hex": "#968b86",
      "hls": [
        0.052083333333333336,
        0.5546875,
        0.07017543859649122
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.51.jpg",
    "colors": {
      "hex": "#8e8a86",
      "hls": [
        0.08333333333333333,
        0.5390625,
        0.03389830508474576
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.52.jpg",
    "colors": {
      "hex": "#88827e",
      "hls": [
        0.06666666666666667,
        0.51171875,
        0.04
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.53.jpg",
    "colors": {
      "hex": "#a79995",
      "hls": [
        0.037037037037037035,
        0.6171875,
        0.09183673469387756
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.54.jpg",
    "colors": {
      "hex": "#a6918d",
      "hls": [
        0.026666666666666672,
        0.599609375,
        0.12195121951219512
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.55.jpg",
    "colors": {
      "hex": "#848077",
      "hls": [
        0.11538461538461538,
        0.490234375,
        0.05179282868525897
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.56.jpg",
    "colors": {
      "hex": "#9f9082",
      "hls": [
        0.08045977011494253,
        0.564453125,
        0.13004484304932734
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.57.jpg",
    "colors": {
      "hex": "#8a8a80",
      "hls": [
        0.16666666666666666,
        0.51953125,
        0.04065040650406504
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.58.jpg",
    "colors": {
      "hex": "#888279",
      "hls": [
        0.09999999999999999,
        0.501953125,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.59.jpg",
    "colors": {
      "hex": "#8a827a",
      "hls": [
        0.08333333333333333,
        0.5078125,
        0.06349206349206349
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.6.jpg",
    "colors": {
      "hex": "#7f7d79",
      "hls": [
        0.11111111111111112,
        0.484375,
        0.024193548387096774
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.60.jpg",
    "colors": {
      "hex": "#85847e",
      "hls": [
        0.14285714285714288,
        0.505859375,
        0.02766798418972332
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.61.jpg",
    "colors": {
      "hex": "#8a8882",
      "hls": [
        0.125,
        0.5234375,
        0.03278688524590164
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.62.jpg",
    "colors": {
      "hex": "#8c8681",
      "hls": [
        0.07575757575757576,
        0.525390625,
        0.04526748971193416
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.63.jpg",
    "colors": {
      "hex": "#85827d",
      "hls": [
        0.10416666666666667,
        0.50390625,
        0.031496062992125984
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.64.jpg",
    "colors": {
      "hex": "#b4a69a",
      "hls": [
        0.07692307692307693,
        0.65234375,
        0.14606741573033707
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.65.jpg",
    "colors": {
      "hex": "#8c847f",
      "hls": [
        0.0641025641025641,
        0.521484375,
        0.053061224489795916
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.66.jpg",
    "colors": {
      "hex": "#82897b",
      "hls": [
        0.25,
        0.5078125,
        0.05555555555555555
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.67.jpg",
    "colors": {
      "hex": "#868a81",
      "hls": [
        0.24074074074074078,
        0.521484375,
        0.036734693877551024
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.68.jpg",
    "colors": {
      "hex": "#8c8b7f",
      "hls": [
        0.15384615384615385,
        0.521484375,
        0.053061224489795916
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.69.jpg",
    "colors": {
      "hex": "#807c7a",
      "hls": [
        0.05555555555555556,
        0.48828125,
        0.024
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.7.jpg",
    "colors": {
      "hex": "#85867d",
      "hls": [
        0.1851851851851852,
        0.505859375,
        0.03557312252964427
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.70.jpg",
    "colors": {
      "hex": "#868282",
      "hls": [
        0,
        0.515625,
        0.016129032258064516
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.71.jpg",
    "colors": {
      "hex": "#877e7c",
      "hls": [
        0.030303030303030293,
        0.505859375,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.72.jpg",
    "colors": {
      "hex": "#8bad7e",
      "hls": [
        0.28723404255319146,
        0.583984375,
        0.22065727699530516
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.73.jpg",
    "colors": {
      "hex": "#96ae7c",
      "hls": [
        0.24666666666666667,
        0.58203125,
        0.2336448598130841
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.74.jpg",
    "colors": {
      "hex": "#94b48e",
      "hls": [
        0.30701754385964913,
        0.62890625,
        0.2
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.76.jpg",
    "colors": {
      "hex": "#809882",
      "hls": [
        0.34722222222222227,
        0.546875,
        0.10344827586206896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.77.jpg",
    "colors": {
      "hex": "#91ad85",
      "hls": [
        0.2833333333333334,
        0.59765625,
        0.1941747572815534
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.78.jpg",
    "colors": {
      "hex": "#7e908e",
      "hls": [
        0.48148148148148145,
        0.52734375,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.79.jpg",
    "colors": {
      "hex": "#908880",
      "hls": [
        0.08333333333333333,
        0.53125,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.8.jpg",
    "colors": {
      "hex": "#86867f",
      "hls": [
        0.16666666666666666,
        0.509765625,
        0.027888446215139442
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.80.jpg",
    "colors": {
      "hex": "#908982",
      "hls": [
        0.08333333333333333,
        0.53515625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.81.jpg",
    "colors": {
      "hex": "#978e87",
      "hls": [
        0.07291666666666667,
        0.55859375,
        0.07079646017699115
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.82.jpg",
    "colors": {
      "hex": "#ada2a0",
      "hls": [
        0.025641025641025644,
        0.650390625,
        0.07262569832402235
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.83.jpg",
    "colors": {
      "hex": "#86827d",
      "hls": [
        0.0925925925925926,
        0.505859375,
        0.03557312252964427
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.84.jpg",
    "colors": {
      "hex": "#9c9c98",
      "hls": [
        0.16666666666666666,
        0.6015625,
        0.0196078431372549
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.87.jpg",
    "colors": {
      "hex": "#8bb08e",
      "hls": [
        0.34684684684684686,
        0.615234375,
        0.18781725888324874
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.88.jpg",
    "colors": {
      "hex": "#9da37f",
      "hls": [
        0.19444444444444442,
        0.56640625,
        0.16216216216216217
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.89.jpg",
    "colors": {
      "hex": "#80a882",
      "hls": [
        0.3416666666666666,
        0.578125,
        0.18518518518518517
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.9.jpg",
    "colors": {
      "hex": "#84877d",
      "hls": [
        0.21666666666666665,
        0.5078125,
        0.03968253968253968
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.90.jpg",
    "colors": {
      "hex": "#88a37c",
      "hls": [
        0.2820512820512821,
        0.560546875,
        0.17333333333333334
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.92.jpg",
    "colors": {
      "hex": "#88af87",
      "hls": [
        0.32916666666666666,
        0.60546875,
        0.19801980198019803
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.93.jpg",
    "colors": {
      "hex": "#9bae87",
      "hls": [
        0.24786324786324787,
        0.603515625,
        0.1921182266009852
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.94.jpg",
    "colors": {
      "hex": "#9cb087",
      "hls": [
        0.24796747967479674,
        0.607421875,
        0.20398009950248755
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.95.jpg",
    "colors": {
      "hex": "#8cac82",
      "hls": [
        0.29365079365079366,
        0.58984375,
        0.2
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.96.jpg",
    "colors": {
      "hex": "#bbb39f",
      "hls": [
        0.11904761904761905,
        0.67578125,
        0.1686746987951807
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.97.jpg",
    "colors": {
      "hex": "#8ba17a",
      "hls": [
        0.26068376068376065,
        0.552734375,
        0.1703056768558952
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.98.jpg",
    "colors": {
      "hex": "#8c9777",
      "hls": [
        0.22395833333333334,
        0.52734375,
        0.1322314049586777
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D019.99.jpg",
    "colors": {
      "hex": "#b2bda3",
      "hls": [
        0.23717948717948714,
        0.6875,
        0.1625
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.10.jpg",
    "colors": {
      "hex": "#84af85",
      "hls": [
        0.3372093023255814,
        0.599609375,
        0.2097560975609756
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.11.jpg",
    "colors": {
      "hex": "#99ae80",
      "hls": [
        0.24275362318840576,
        0.58984375,
        0.21904761904761905
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.12.jpg",
    "colors": {
      "hex": "#9c9c7c",
      "hls": [
        0.16666666666666666,
        0.546875,
        0.13793103448275862
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.13.jpg",
    "colors": {
      "hex": "#7f9d92",
      "hls": [
        0.4388888888888889,
        0.5546875,
        0.13157894736842105
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.14.jpg",
    "colors": {
      "hex": "#7b9b89",
      "hls": [
        0.40625,
        0.54296875,
        0.13675213675213677
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.15.jpg",
    "colors": {
      "hex": "#8ca989",
      "hls": [
        0.3177083333333333,
        0.59765625,
        0.1553398058252427
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.16.jpg",
    "colors": {
      "hex": "#8fa4a5",
      "hls": [
        0.5075757575757577,
        0.6015625,
        0.10784313725490197
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.17.jpg",
    "colors": {
      "hex": "#7d8d77",
      "hls": [
        0.2878787878787879,
        0.5078125,
        0.0873015873015873
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.18.jpg",
    "colors": {
      "hex": "#78978d",
      "hls": [
        0.44623655913978494,
        0.529296875,
        0.12863070539419086
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.19.jpg",
    "colors": {
      "hex": "#a1b28a",
      "hls": [
        0.23749999999999996,
        0.6171875,
        0.20408163265306123
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.20.jpg",
    "colors": {
      "hex": "#8b9f97",
      "hls": [
        0.43333333333333335,
        0.58203125,
        0.09345794392523364
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.21.jpg",
    "colors": {
      "hex": "#92a889",
      "hls": [
        0.2849462365591398,
        0.595703125,
        0.1497584541062802
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.22.jpg",
    "colors": {
      "hex": "#81a28e",
      "hls": [
        0.398989898989899,
        0.568359375,
        0.1493212669683258
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.23.jpg",
    "colors": {
      "hex": "#76908c",
      "hls": [
        0.4743589743589744,
        0.51171875,
        0.104
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.24.jpg",
    "colors": {
      "hex": "#89a789",
      "hls": [
        0.3333333333333333,
        0.59375,
        0.14423076923076922
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.25.jpg",
    "colors": {
      "hex": "#98ad86",
      "hls": [
        0.2564102564102564,
        0.599609375,
        0.1902439024390244
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.26.jpg",
    "colors": {
      "hex": "#919ca2",
      "hls": [
        0.5588235294117646,
        0.599609375,
        0.08292682926829269
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.27.jpg",
    "colors": {
      "hex": "#9cb997",
      "hls": [
        0.3088235294117647,
        0.65625,
        0.19318181818181818
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.28.jpg",
    "colors": {
      "hex": "#7d9989",
      "hls": [
        0.4047619047619048,
        0.54296875,
        0.11965811965811966
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.29.jpg",
    "colors": {
      "hex": "#8daf89",
      "hls": [
        0.31578947368421056,
        0.609375,
        0.19
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.3.jpg",
    "colors": {
      "hex": "#a8b9a6",
      "hls": [
        0.31578947368421056,
        0.685546875,
        0.11801242236024845
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.30.jpg",
    "colors": {
      "hex": "#a2a8a6",
      "hls": [
        0.4444444444444444,
        0.64453125,
        0.03296703296703297
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.31.jpg",
    "colors": {
      "hex": "#84a88e",
      "hls": [
        0.3796296296296296,
        0.5859375,
        0.16981132075471697
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.32.jpg",
    "colors": {
      "hex": "#849c97",
      "hls": [
        0.46527777777777773,
        0.5625,
        0.10714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.34.jpg",
    "colors": {
      "hex": "#9eae8d",
      "hls": [
        0.2474747474747475,
        0.615234375,
        0.16751269035532995
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.35.jpg",
    "colors": {
      "hex": "#8aa885",
      "hls": [
        0.30952380952380953,
        0.587890625,
        0.16587677725118483
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.38.jpg",
    "colors": {
      "hex": "#99af8d",
      "hls": [
        0.2745098039215686,
        0.6171875,
        0.17346938775510204
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.4.jpg",
    "colors": {
      "hex": "#95b28b",
      "hls": [
        0.2905982905982906,
        0.619140625,
        0.2
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.40.jpg",
    "colors": {
      "hex": "#99a98a",
      "hls": [
        0.25268817204301075,
        0.599609375,
        0.15121951219512195
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.41.jpg",
    "colors": {
      "hex": "#8ead7f",
      "hls": [
        0.2789855072463768,
        0.5859375,
        0.2169811320754717
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.42.jpg",
    "colors": {
      "hex": "#91ac8a",
      "hls": [
        0.29901960784313725,
        0.60546875,
        0.16831683168316833
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.43.jpg",
    "colors": {
      "hex": "#9caf8b",
      "hls": [
        0.2546296296296296,
        0.61328125,
        0.18181818181818182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.44.jpg",
    "colors": {
      "hex": "#92b696",
      "hls": [
        0.35185185185185186,
        0.640625,
        0.1956521739130435
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.46.jpg",
    "colors": {
      "hex": "#86af87",
      "hls": [
        0.33739837398373984,
        0.603515625,
        0.2019704433497537
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.48.jpg",
    "colors": {
      "hex": "#a8aa8f",
      "hls": [
        0.17901234567901234,
        0.611328125,
        0.135678391959799
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.49.jpg",
    "colors": {
      "hex": "#89a68f",
      "hls": [
        0.367816091954023,
        0.591796875,
        0.13875598086124402
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.5.jpg",
    "colors": {
      "hex": "#95b090",
      "hls": [
        0.3072916666666667,
        0.625,
        0.16666666666666666
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.51.jpg",
    "colors": {
      "hex": "#83af81",
      "hls": [
        0.3260869565217391,
        0.59375,
        0.22115384615384615
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.52.jpg",
    "colors": {
      "hex": "#849d91",
      "hls": [
        0.42,
        0.564453125,
        0.11210762331838565
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.53.jpg",
    "colors": {
      "hex": "#c8d4c8",
      "hls": [
        0.3333333333333333,
        0.8046875,
        0.12
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.55.jpg",
    "colors": {
      "hex": "#9aac8a",
      "hls": [
        0.2549019607843137,
        0.60546875,
        0.16831683168316833
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.56.jpg",
    "colors": {
      "hex": "#85a286",
      "hls": [
        0.3390804597701149,
        0.576171875,
        0.1336405529953917
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.57.jpg",
    "colors": {
      "hex": "#7ea87f",
      "hls": [
        0.33730158730158727,
        0.57421875,
        0.1926605504587156
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.58.jpg",
    "colors": {
      "hex": "#81a87e",
      "hls": [
        0.32142857142857145,
        0.57421875,
        0.1926605504587156
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.59.jpg",
    "colors": {
      "hex": "#86ab84",
      "hls": [
        0.3247863247863248,
        0.591796875,
        0.18660287081339713
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.6.jpg",
    "colors": {
      "hex": "#b1c2a8",
      "hls": [
        0.2756410256410256,
        0.70703125,
        0.17333333333333334
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.60.jpg",
    "colors": {
      "hex": "#99a77f",
      "hls": [
        0.225,
        0.57421875,
        0.1834862385321101
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.61.jpg",
    "colors": {
      "hex": "#7d9289",
      "hls": [
        0.4285714285714286,
        0.529296875,
        0.08713692946058091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.62.jpg",
    "colors": {
      "hex": "#9db7a2",
      "hls": [
        0.3653846153846154,
        0.6640625,
        0.1511627906976744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.63.jpg",
    "colors": {
      "hex": "#96a890",
      "hls": [
        0.2916666666666667,
        0.609375,
        0.12
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.64.jpg",
    "colors": {
      "hex": "#89a48c",
      "hls": [
        0.35185185185185186,
        0.587890625,
        0.12796208530805686
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.65.jpg",
    "colors": {
      "hex": "#99af88",
      "hls": [
        0.26068376068376065,
        0.607421875,
        0.19402985074626866
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.7.jpg",
    "colors": {
      "hex": "#90aa7f",
      "hls": [
        0.2674418604651163,
        0.580078125,
        0.2
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.8.jpg",
    "colors": {
      "hex": "#8faf8b",
      "hls": [
        0.3148148148148148,
        0.61328125,
        0.18181818181818182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D020.9.jpg",
    "colors": {
      "hex": "#9ab485",
      "hls": [
        0.2588652482269504,
        0.611328125,
        0.23618090452261306
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.100.jpg",
    "colors": {
      "hex": "#908c76",
      "hls": [
        0.14102564102564102,
        0.51171875,
        0.104
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.11.jpg",
    "colors": {
      "hex": "#8a887b",
      "hls": [
        0.14444444444444446,
        0.509765625,
        0.05976095617529881
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.12.jpg",
    "colors": {
      "hex": "#9b9b8f",
      "hls": [
        0.16666666666666666,
        0.58203125,
        0.056074766355140186
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.14.jpg",
    "colors": {
      "hex": "#8b8975",
      "hls": [
        0.15151515151515152,
        0.5,
        0.0859375
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.15.jpg",
    "colors": {
      "hex": "#8a8c7d",
      "hls": [
        0.18888888888888888,
        0.517578125,
        0.06072874493927125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.17.jpg",
    "colors": {
      "hex": "#a1a294",
      "hls": [
        0.1785714285714286,
        0.60546875,
        0.06930693069306931
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.18.jpg",
    "colors": {
      "hex": "#949281",
      "hls": [
        0.14912280701754385,
        0.541015625,
        0.08085106382978724
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.19.jpg",
    "colors": {
      "hex": "#989683",
      "hls": [
        0.15079365079365079,
        0.552734375,
        0.09170305676855896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.2.jpg",
    "colors": {
      "hex": "#9d9c8b",
      "hls": [
        0.1574074074074074,
        0.578125,
        0.08333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.21.jpg",
    "colors": {
      "hex": "#8b8774",
      "hls": [
        0.13768115942028986,
        0.498046875,
        0.09019607843137255
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.22.jpg",
    "colors": {
      "hex": "#888a77",
      "hls": [
        0.18421052631578946,
        0.501953125,
        0.07450980392156863
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.23.jpg",
    "colors": {
      "hex": "#7f8172",
      "hls": [
        0.18888888888888888,
        0.474609375,
        0.06172839506172839
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.24.jpg",
    "colors": {
      "hex": "#878978",
      "hls": [
        0.18627450980392157,
        0.501953125,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.26.jpg",
    "colors": {
      "hex": "#868176",
      "hls": [
        0.11458333333333333,
        0.4921875,
        0.06349206349206349
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.27.jpg",
    "colors": {
      "hex": "#87887d",
      "hls": [
        0.1818181818181818,
        0.509765625,
        0.043824701195219126
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.28.jpg",
    "colors": {
      "hex": "#98978b",
      "hls": [
        0.15384615384615385,
        0.568359375,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.29.jpg",
    "colors": {
      "hex": "#8d8d7e",
      "hls": [
        0.16666666666666666,
        0.521484375,
        0.061224489795918366
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.3.jpg",
    "colors": {
      "hex": "#9d9d8f",
      "hls": [
        0.16666666666666666,
        0.5859375,
        0.0660377358490566
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.30.jpg",
    "colors": {
      "hex": "#858476",
      "hls": [
        0.15555555555555556,
        0.490234375,
        0.05976095617529881
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.31.jpg",
    "colors": {
      "hex": "#8c8d7f",
      "hls": [
        0.1785714285714286,
        0.5234375,
        0.05737704918032787
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.32.jpg",
    "colors": {
      "hex": "#9e9d89",
      "hls": [
        0.15873015873015872,
        0.576171875,
        0.0967741935483871
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.33.jpg",
    "colors": {
      "hex": "#9d9c8c",
      "hls": [
        0.1568627450980392,
        0.580078125,
        0.07906976744186046
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.35.jpg",
    "colors": {
      "hex": "#97978a",
      "hls": [
        0.16666666666666666,
        0.564453125,
        0.05829596412556054
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.36.jpg",
    "colors": {
      "hex": "#8c8c7c",
      "hls": [
        0.16666666666666666,
        0.515625,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.37.jpg",
    "colors": {
      "hex": "#9b9b89",
      "hls": [
        0.16666666666666666,
        0.5703125,
        0.08181818181818182
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.38.jpg",
    "colors": {
      "hex": "#8a8979",
      "hls": [
        0.1568627450980392,
        0.505859375,
        0.06719367588932806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.39.jpg",
    "colors": {
      "hex": "#9d9c83",
      "hls": [
        0.16025641025641027,
        0.5625,
        0.11607142857142858
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.4.jpg",
    "colors": {
      "hex": "#a4a48f",
      "hls": [
        0.16666666666666666,
        0.599609375,
        0.1024390243902439
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.40.jpg",
    "colors": {
      "hex": "#91927d",
      "hls": [
        0.17460317460317457,
        0.529296875,
        0.08713692946058091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.41.jpg",
    "colors": {
      "hex": "#9a977c",
      "hls": [
        0.15,
        0.54296875,
        0.1282051282051282
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.42.jpg",
    "colors": {
      "hex": "#909282",
      "hls": [
        0.1875,
        0.5390625,
        0.06779661016949153
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.43.jpg",
    "colors": {
      "hex": "#818075",
      "hls": [
        0.15277777777777776,
        0.48046875,
        0.04878048780487805
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.44.jpg",
    "colors": {
      "hex": "#7c7b6c",
      "hls": [
        0.15625,
        0.453125,
        0.06896551724137931
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.45.jpg",
    "colors": {
      "hex": "#90907b",
      "hls": [
        0.16666666666666666,
        0.521484375,
        0.08571428571428572
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.46.jpg",
    "colors": {
      "hex": "#93917f",
      "hls": [
        0.15,
        0.53515625,
        0.08403361344537816
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.47.jpg",
    "colors": {
      "hex": "#989683",
      "hls": [
        0.15079365079365079,
        0.552734375,
        0.09170305676855896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.48.jpg",
    "colors": {
      "hex": "#908f7f",
      "hls": [
        0.1568627450980392,
        0.529296875,
        0.07053941908713693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.51.jpg",
    "colors": {
      "hex": "#9d9a89",
      "hls": [
        0.14166666666666666,
        0.57421875,
        0.09174311926605505
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.54.jpg",
    "colors": {
      "hex": "#919489",
      "hls": [
        0.21212121212121207,
        0.556640625,
        0.048458149779735685
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.55.jpg",
    "colors": {
      "hex": "#979684",
      "hls": [
        0.15789473684210528,
        0.552734375,
        0.08296943231441048
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.56.jpg",
    "colors": {
      "hex": "#92907f",
      "hls": [
        0.14912280701754385,
        0.533203125,
        0.0794979079497908
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.58.jpg",
    "colors": {
      "hex": "#a1a18c",
      "hls": [
        0.16666666666666666,
        0.587890625,
        0.0995260663507109
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.59.jpg",
    "colors": {
      "hex": "#959581",
      "hls": [
        0.16666666666666666,
        0.54296875,
        0.08547008547008547
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.6.jpg",
    "colors": {
      "hex": "#a2a094",
      "hls": [
        0.14285714285714288,
        0.60546875,
        0.06930693069306931
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.60.jpg",
    "colors": {
      "hex": "#a2a28f",
      "hls": [
        0.16666666666666666,
        0.595703125,
        0.09178743961352658
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.61.jpg",
    "colors": {
      "hex": "#9a9b88",
      "hls": [
        0.1754385964912281,
        0.568359375,
        0.08597285067873303
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.63.jpg",
    "colors": {
      "hex": "#9a9782",
      "hls": [
        0.14583333333333334,
        0.5546875,
        0.10526315789473684
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.64.jpg",
    "colors": {
      "hex": "#969883",
      "hls": [
        0.18253968253968256,
        0.552734375,
        0.09170305676855896
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.65.jpg",
    "colors": {
      "hex": "#8f907e",
      "hls": [
        0.1759259259259259,
        0.52734375,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.66.jpg",
    "colors": {
      "hex": "#989585",
      "hls": [
        0.14035087719298245,
        0.556640625,
        0.08370044052863436
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.67.jpg",
    "colors": {
      "hex": "#9f9e89",
      "hls": [
        0.1590909090909091,
        0.578125,
        0.10185185185185185
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.68.jpg",
    "colors": {
      "hex": "#8e8f7c",
      "hls": [
        0.1754385964912281,
        0.521484375,
        0.07755102040816327
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.69.jpg",
    "colors": {
      "hex": "#979682",
      "hls": [
        0.15873015873015872,
        0.548828125,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.7.jpg",
    "colors": {
      "hex": "#828071",
      "hls": [
        0.14705882352941177,
        0.474609375,
        0.06995884773662552
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.70.jpg",
    "colors": {
      "hex": "#a6a393",
      "hls": [
        0.14035087719298245,
        0.611328125,
        0.09547738693467336
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.71.jpg",
    "colors": {
      "hex": "#8c8a7c",
      "hls": [
        0.14583333333333334,
        0.515625,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.72.jpg",
    "colors": {
      "hex": "#908f7b",
      "hls": [
        0.15873015873015872,
        0.521484375,
        0.08571428571428572
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.73.jpg",
    "colors": {
      "hex": "#99978b",
      "hls": [
        0.14285714285714288,
        0.5703125,
        0.06363636363636363
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.74.jpg",
    "colors": {
      "hex": "#8b887a",
      "hls": [
        0.1372549019607843,
        0.509765625,
        0.06772908366533864
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.75.jpg",
    "colors": {
      "hex": "#908f78",
      "hls": [
        0.15972222222222224,
        0.515625,
        0.0967741935483871
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.76.jpg",
    "colors": {
      "hex": "#9f9d8d",
      "hls": [
        0.14814814814814814,
        0.5859375,
        0.08490566037735849
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.77.jpg",
    "colors": {
      "hex": "#90907f",
      "hls": [
        0.16666666666666666,
        0.529296875,
        0.07053941908713693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.78.jpg",
    "colors": {
      "hex": "#9e9f89",
      "hls": [
        0.17424242424242423,
        0.578125,
        0.10185185185185185
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.79.jpg",
    "colors": {
      "hex": "#8f8e7e",
      "hls": [
        0.1568627450980392,
        0.525390625,
        0.06995884773662552
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.8.jpg",
    "colors": {
      "hex": "#8c8c7d",
      "hls": [
        0.16666666666666666,
        0.517578125,
        0.06072874493927125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.80.jpg",
    "colors": {
      "hex": "#8a8875",
      "hls": [
        0.15079365079365079,
        0.498046875,
        0.08235294117647059
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.81.jpg",
    "colors": {
      "hex": "#92917d",
      "hls": [
        0.15873015873015872,
        0.529296875,
        0.08713692946058091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.82.jpg",
    "colors": {
      "hex": "#9b9980",
      "hls": [
        0.15432098765432098,
        0.552734375,
        0.11790393013100436
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.83.jpg",
    "colors": {
      "hex": "#92907c",
      "hls": [
        0.15151515151515152,
        0.52734375,
        0.09090909090909091
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.84.jpg",
    "colors": {
      "hex": "#a2a195",
      "hls": [
        0.15384615384615385,
        0.607421875,
        0.06467661691542288
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.85.jpg",
    "colors": {
      "hex": "#a1a08f",
      "hls": [
        0.1574074074074074,
        0.59375,
        0.08653846153846154
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.86.jpg",
    "colors": {
      "hex": "#a09f94",
      "hls": [
        0.15277777777777776,
        0.6015625,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.87.jpg",
    "colors": {
      "hex": "#8c8a78",
      "hls": [
        0.15,
        0.5078125,
        0.07936507936507936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.88.jpg",
    "colors": {
      "hex": "#9d9b8d",
      "hls": [
        0.14583333333333334,
        0.58203125,
        0.07476635514018691
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.89.jpg",
    "colors": {
      "hex": "#848174",
      "hls": [
        0.13541666666666666,
        0.484375,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.90.jpg",
    "colors": {
      "hex": "#a39c84",
      "hls": [
        0.12903225806451613,
        0.576171875,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.91.jpg",
    "colors": {
      "hex": "#8d8d7a",
      "hls": [
        0.16666666666666666,
        0.513671875,
        0.07630522088353414
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.93.jpg",
    "colors": {
      "hex": "#95907c",
      "hls": [
        0.13333333333333333,
        0.533203125,
        0.10460251046025104
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.94.jpg",
    "colors": {
      "hex": "#8c8672",
      "hls": [
        0.1282051282051282,
        0.49609375,
        0.10236220472440945
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.95.jpg",
    "colors": {
      "hex": "#a9a591",
      "hls": [
        0.1388888888888889,
        0.61328125,
        0.12121212121212122
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.96.jpg",
    "colors": {
      "hex": "#908d7e",
      "hls": [
        0.1388888888888889,
        0.52734375,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.97.jpg",
    "colors": {
      "hex": "#989782",
      "hls": [
        0.1590909090909091,
        0.55078125,
        0.09565217391304348
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.98.jpg",
    "colors": {
      "hex": "#87877a",
      "hls": [
        0.16666666666666666,
        0.501953125,
        0.050980392156862744
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D023.99.jpg",
    "colors": {
      "hex": "#949181",
      "hls": [
        0.14035087719298245,
        0.541015625,
        0.08085106382978724
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.10.jpg",
    "colors": {
      "hex": "#8e827f",
      "hls": [
        0.033333333333333326,
        0.525390625,
        0.06172839506172839
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.101.jpg",
    "colors": {
      "hex": "#7e7373",
      "hls": [
        0,
        0.470703125,
        0.04564315352697095
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.104.jpg",
    "colors": {
      "hex": "#847a77",
      "hls": [
        0.03846153846153846,
        0.490234375,
        0.05179282868525897
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.105.jpg",
    "colors": {
      "hex": "#7f7574",
      "hls": [
        0.015151515151515157,
        0.474609375,
        0.04526748971193416
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.106.jpg",
    "colors": {
      "hex": "#887b77",
      "hls": [
        0.03921568627450981,
        0.498046875,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.107.jpg",
    "colors": {
      "hex": "#82746f",
      "hls": [
        0.04385964912280702,
        0.470703125,
        0.07883817427385892
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.108.jpg",
    "colors": {
      "hex": "#847974",
      "hls": [
        0.052083333333333336,
        0.484375,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.109.jpg",
    "colors": {
      "hex": "#887e7a",
      "hls": [
        0.047619047619047616,
        0.50390625,
        0.05511811023622047
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.11.jpg",
    "colors": {
      "hex": "#8f7c74",
      "hls": [
        0.04938271604938271,
        0.505859375,
        0.1067193675889328
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.110.jpg",
    "colors": {
      "hex": "#99867f",
      "hls": [
        0.04487179487179488,
        0.546875,
        0.11206896551724138
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.111.jpg",
    "colors": {
      "hex": "#89807e",
      "hls": [
        0.030303030303030293,
        0.513671875,
        0.04417670682730924
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.112.jpg",
    "colors": {
      "hex": "#8b7e7b",
      "hls": [
        0.03125,
        0.51171875,
        0.064
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.113.jpg",
    "colors": {
      "hex": "#847775",
      "hls": [
        0.022222222222222216,
        0.486328125,
        0.060240963855421686
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.114.jpg",
    "colors": {
      "hex": "#a38c7c",
      "hls": [
        0.06837606837606837,
        0.560546875,
        0.17333333333333334
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.115.jpg",
    "colors": {
      "hex": "#847772",
      "hls": [
        0.0462962962962963,
        0.48046875,
        0.07317073170731707
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.116.jpg",
    "colors": {
      "hex": "#7b7373",
      "hls": [
        0,
        0.46484375,
        0.03361344537815126
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.117.jpg",
    "colors": {
      "hex": "#998377",
      "hls": [
        0.0588235294117647,
        0.53125,
        0.14166666666666666
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.118.jpg",
    "colors": {
      "hex": "#94837b",
      "hls": [
        0.05333333333333332,
        0.529296875,
        0.1037344398340249
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.119.jpg",
    "colors": {
      "hex": "#93827b",
      "hls": [
        0.048611111111111105,
        0.52734375,
        0.09917355371900827
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.12.jpg",
    "colors": {
      "hex": "#8f7e76",
      "hls": [
        0.05333333333333332,
        0.509765625,
        0.099601593625498
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.120.jpg",
    "colors": {
      "hex": "#887b76",
      "hls": [
        0.0462962962962963,
        0.49609375,
        0.07086614173228346
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.121.jpg",
    "colors": {
      "hex": "#9e8d85",
      "hls": [
        0.05333333333333332,
        0.568359375,
        0.11312217194570136
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.123.jpg",
    "colors": {
      "hex": "#8d7d78",
      "hls": [
        0.03968253968253969,
        0.509765625,
        0.08366533864541832
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.124.jpg",
    "colors": {
      "hex": "#9a877d",
      "hls": [
        0.0574712643678161,
        0.544921875,
        0.12446351931330472
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.125.jpg",
    "colors": {
      "hex": "#9d867c",
      "hls": [
        0.0505050505050505,
        0.548828125,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.126.jpg",
    "colors": {
      "hex": "#887a7a",
      "hls": [
        0,
        0.50390625,
        0.05511811023622047
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.127.jpg",
    "colors": {
      "hex": "#8c7b77",
      "hls": [
        0.031746031746031744,
        0.505859375,
        0.08300395256916997
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.128.jpg",
    "colors": {
      "hex": "#847a78",
      "hls": [
        0.027777777777777773,
        0.4921875,
        0.047619047619047616
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.129.jpg",
    "colors": {
      "hex": "#9a8780",
      "hls": [
        0.04487179487179488,
        0.55078125,
        0.11304347826086956
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.130.jpg",
    "colors": {
      "hex": "#857a79",
      "hls": [
        0.013888888888888895,
        0.49609375,
        0.047244094488188976
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.131.jpg",
    "colors": {
      "hex": "#8a7d78",
      "hls": [
        0.0462962962962963,
        0.50390625,
        0.07086614173228346
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.132.jpg",
    "colors": {
      "hex": "#807673",
      "hls": [
        0.03846153846153846,
        0.474609375,
        0.053497942386831275
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.133.jpg",
    "colors": {
      "hex": "#7e736e",
      "hls": [
        0.052083333333333336,
        0.4609375,
        0.06779661016949153
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.135.jpg",
    "colors": {
      "hex": "#8b8584",
      "hls": [
        0.02380952380952382,
        0.529296875,
        0.029045643153526972
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.136.jpg",
    "colors": {
      "hex": "#91817c",
      "hls": [
        0.03968253968253969,
        0.525390625,
        0.08641975308641975
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.137.jpg",
    "colors": {
      "hex": "#908786",
      "hls": [
        0.016666666666666663,
        0.54296875,
        0.042735042735042736
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.138.jpg",
    "colors": {
      "hex": "#a18f86",
      "hls": [
        0.05555555555555556,
        0.576171875,
        0.12442396313364056
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.139.jpg",
    "colors": {
      "hex": "#897e7b",
      "hls": [
        0.03571428571428572,
        0.5078125,
        0.05555555555555555
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.140.jpg",
    "colors": {
      "hex": "#8f7d79",
      "hls": [
        0.030303030303030293,
        0.515625,
        0.08870967741935484
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.141.jpg",
    "colors": {
      "hex": "#938178",
      "hls": [
        0.05555555555555556,
        0.521484375,
        0.11020408163265306
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.142.jpg",
    "colors": {
      "hex": "#98837a",
      "hls": [
        0.05000000000000001,
        0.53515625,
        0.12605042016806722
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.143.jpg",
    "colors": {
      "hex": "#8c7d78",
      "hls": [
        0.041666666666666664,
        0.5078125,
        0.07936507936507936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.144.jpg",
    "colors": {
      "hex": "#8a7b77",
      "hls": [
        0.03508771929824561,
        0.501953125,
        0.07450980392156863
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.145.jpg",
    "colors": {
      "hex": "#897b77",
      "hls": [
        0.037037037037037035,
        0.5,
        0.0703125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.146.jpg",
    "colors": {
      "hex": "#887a77",
      "hls": [
        0.02941176470588236,
        0.498046875,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.15.jpg",
    "colors": {
      "hex": "#84756f",
      "hls": [
        0.047619047619047616,
        0.474609375,
        0.08641975308641975
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.16.jpg",
    "colors": {
      "hex": "#837875",
      "hls": [
        0.03571428571428572,
        0.484375,
        0.056451612903225805
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.17.jpg",
    "colors": {
      "hex": "#7b7471",
      "hls": [
        0.05000000000000001,
        0.4609375,
        0.0423728813559322
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.18.jpg",
    "colors": {
      "hex": "#8c7973",
      "hls": [
        0.04,
        0.498046875,
        0.09803921568627451
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.19.jpg",
    "colors": {
      "hex": "#8a7c79",
      "hls": [
        0.02941176470588236,
        0.505859375,
        0.06719367588932806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.2.jpg",
    "colors": {
      "hex": "#907e75",
      "hls": [
        0.05555555555555556,
        0.509765625,
        0.10756972111553785
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.20.jpg",
    "colors": {
      "hex": "#8e7f7b",
      "hls": [
        0.03508771929824561,
        0.517578125,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.21.jpg",
    "colors": {
      "hex": "#8b7e79",
      "hls": [
        0.0462962962962963,
        0.5078125,
        0.07142857142857142
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.22.jpg",
    "colors": {
      "hex": "#8b7a76",
      "hls": [
        0.031746031746031744,
        0.501953125,
        0.08235294117647059
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.23.jpg",
    "colors": {
      "hex": "#827573",
      "hls": [
        0.022222222222222216,
        0.478515625,
        0.061224489795918366
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.24.jpg",
    "colors": {
      "hex": "#837a79",
      "hls": [
        0.016666666666666663,
        0.4921875,
        0.03968253968253968
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.25.jpg",
    "colors": {
      "hex": "#867d7c",
      "hls": [
        0.016666666666666663,
        0.50390625,
        0.03937007874015748
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.26.jpg",
    "colors": {
      "hex": "#867974",
      "hls": [
        0.0462962962962963,
        0.48828125,
        0.072
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.27.jpg",
    "colors": {
      "hex": "#7b7370",
      "hls": [
        0.04545454545454545,
        0.458984375,
        0.04680851063829787
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.28.jpg",
    "colors": {
      "hex": "#81726f",
      "hls": [
        0.027777777777777773,
        0.46875,
        0.075
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.29.jpg",
    "colors": {
      "hex": "#807473",
      "hls": [
        0.012820512820512811,
        0.474609375,
        0.053497942386831275
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.3.jpg",
    "colors": {
      "hex": "#89786f",
      "hls": [
        0.05769230769230769,
        0.484375,
        0.10483870967741936
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.30.jpg",
    "colors": {
      "hex": "#837876",
      "hls": [
        0.025641025641025644,
        0.486328125,
        0.05220883534136546
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.31.jpg",
    "colors": {
      "hex": "#7e7370",
      "hls": [
        0.03571428571428572,
        0.46484375,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.32.jpg",
    "colors": {
      "hex": "#817774",
      "hls": [
        0.03846153846153846,
        0.478515625,
        0.053061224489795916
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.33.jpg",
    "colors": {
      "hex": "#8c807a",
      "hls": [
        0.05555555555555556,
        0.51171875,
        0.072
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.34.jpg",
    "colors": {
      "hex": "#7b7170",
      "hls": [
        0.015151515151515157,
        0.458984375,
        0.04680851063829787
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.35.jpg",
    "colors": {
      "hex": "#79716f",
      "hls": [
        0.033333333333333326,
        0.453125,
        0.04310344827586207
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.36.jpg",
    "colors": {
      "hex": "#8b7c76",
      "hls": [
        0.047619047619047616,
        0.501953125,
        0.08235294117647059
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.37.jpg",
    "colors": {
      "hex": "#7f726e",
      "hls": [
        0.03921568627450981,
        0.462890625,
        0.07172995780590717
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.38.jpg",
    "colors": {
      "hex": "#847771",
      "hls": [
        0.05263157894736842,
        0.478515625,
        0.07755102040816327
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.39.jpg",
    "colors": {
      "hex": "#8a7b77",
      "hls": [
        0.03508771929824561,
        0.501953125,
        0.07450980392156863
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.4.jpg",
    "colors": {
      "hex": "#8c7c75",
      "hls": [
        0.050724637681159424,
        0.501953125,
        0.09019607843137255
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.40.jpg",
    "colors": {
      "hex": "#837773",
      "hls": [
        0.041666666666666664,
        0.48046875,
        0.06504065040650407
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.41.jpg",
    "colors": {
      "hex": "#8b7c77",
      "hls": [
        0.041666666666666664,
        0.50390625,
        0.07874015748031496
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.42.jpg",
    "colors": {
      "hex": "#85766e",
      "hls": [
        0.057971014492753624,
        0.474609375,
        0.09465020576131687
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.43.jpg",
    "colors": {
      "hex": "#837774",
      "hls": [
        0.033333333333333326,
        0.482421875,
        0.06072874493927125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.44.jpg",
    "colors": {
      "hex": "#807877",
      "hls": [
        0.018518518518518528,
        0.482421875,
        0.03643724696356275
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.45.jpg",
    "colors": {
      "hex": "#847571",
      "hls": [
        0.03508771929824561,
        0.478515625,
        0.07755102040816327
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.46.jpg",
    "colors": {
      "hex": "#8c807d",
      "hls": [
        0.033333333333333326,
        0.517578125,
        0.06072874493927125
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.47.jpg",
    "colors": {
      "hex": "#92837f",
      "hls": [
        0.03508771929824561,
        0.533203125,
        0.0794979079497908
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.48.jpg",
    "colors": {
      "hex": "#938582",
      "hls": [
        0.02941176470588236,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.49.jpg",
    "colors": {
      "hex": "#8a7e7b",
      "hls": [
        0.033333333333333326,
        0.509765625,
        0.05976095617529881
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.5.jpg",
    "colors": {
      "hex": "#7e746f",
      "hls": [
        0.05555555555555556,
        0.462890625,
        0.06329113924050633
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.50.jpg",
    "colors": {
      "hex": "#847b79",
      "hls": [
        0.030303030303030293,
        0.494140625,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.51.jpg",
    "colors": {
      "hex": "#827a76",
      "hls": [
        0.05555555555555556,
        0.484375,
        0.04838709677419355
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.52.jpg",
    "colors": {
      "hex": "#91827d",
      "hls": [
        0.041666666666666664,
        0.52734375,
        0.08264462809917356
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.53.jpg",
    "colors": {
      "hex": "#887670",
      "hls": [
        0.041666666666666664,
        0.484375,
        0.0967741935483871
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.54.jpg",
    "colors": {
      "hex": "#847774",
      "hls": [
        0.03125,
        0.484375,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.55.jpg",
    "colors": {
      "hex": "#7e7370",
      "hls": [
        0.03571428571428572,
        0.46484375,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.56.jpg",
    "colors": {
      "hex": "#8a7771",
      "hls": [
        0.04,
        0.490234375,
        0.099601593625498
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.57.jpg",
    "colors": {
      "hex": "#847a78",
      "hls": [
        0.027777777777777773,
        0.4921875,
        0.047619047619047616
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.58.jpg",
    "colors": {
      "hex": "#827672",
      "hls": [
        0.041666666666666664,
        0.4765625,
        0.06557377049180328
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.59.jpg",
    "colors": {
      "hex": "#77706f",
      "hls": [
        0.020833333333333332,
        0.44921875,
        0.034782608695652174
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.6.jpg",
    "colors": {
      "hex": "#837571",
      "hls": [
        0.037037037037037035,
        0.4765625,
        0.07377049180327869
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.60.jpg",
    "colors": {
      "hex": "#a2948d",
      "hls": [
        0.05555555555555556,
        0.591796875,
        0.10047846889952153
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.61.jpg",
    "colors": {
      "hex": "#83766f",
      "hls": [
        0.05833333333333333,
        0.47265625,
        0.08264462809917356
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.62.jpg",
    "colors": {
      "hex": "#8c7d76",
      "hls": [
        0.05303030303030304,
        0.50390625,
        0.08661417322834646
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.63.jpg",
    "colors": {
      "hex": "#8d7b73",
      "hls": [
        0.05128205128205129,
        0.5,
        0.1015625
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.64.jpg",
    "colors": {
      "hex": "#837572",
      "hls": [
        0.02941176470588236,
        0.478515625,
        0.06938775510204082
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.65.jpg",
    "colors": {
      "hex": "#978175",
      "hls": [
        0.0588235294117647,
        0.5234375,
        0.13934426229508196
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.66.jpg",
    "colors": {
      "hex": "#7f7471",
      "hls": [
        0.03571428571428572,
        0.46875,
        0.058333333333333334
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.67.jpg",
    "colors": {
      "hex": "#a18f84",
      "hls": [
        0.0632183908045977,
        0.572265625,
        0.1324200913242009
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.68.jpg",
    "colors": {
      "hex": "#7f7674",
      "hls": [
        0.030303030303030293,
        0.474609375,
        0.04526748971193416
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.69.jpg",
    "colors": {
      "hex": "#978378",
      "hls": [
        0.05913978494623656,
        0.529296875,
        0.12863070539419086
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.7.jpg",
    "colors": {
      "hex": "#8f7e78",
      "hls": [
        0.04347826086956522,
        0.513671875,
        0.09236947791164658
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.70.jpg",
    "colors": {
      "hex": "#998172",
      "hls": [
        0.0641025641025641,
        0.521484375,
        0.15918367346938775
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.72.jpg",
    "colors": {
      "hex": "#867b7b",
      "hls": [
        0,
        0.501953125,
        0.043137254901960784
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.74.jpg",
    "colors": {
      "hex": "#8d7f7b",
      "hls": [
        0.037037037037037035,
        0.515625,
        0.07258064516129033
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.75.jpg",
    "colors": {
      "hex": "#8e7d78",
      "hls": [
        0.03787878787878788,
        0.51171875,
        0.088
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.76.jpg",
    "colors": {
      "hex": "#92847e",
      "hls": [
        0.05000000000000001,
        0.53125,
        0.08333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.77.jpg",
    "colors": {
      "hex": "#887771",
      "hls": [
        0.04347826086956522,
        0.486328125,
        0.09236947791164658
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.78.jpg",
    "colors": {
      "hex": "#8b807c",
      "hls": [
        0.04444444444444445,
        0.513671875,
        0.060240963855421686
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.8.jpg",
    "colors": {
      "hex": "#81736d",
      "hls": [
        0.05000000000000001,
        0.46484375,
        0.08403361344537816
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.80.jpg",
    "colors": {
      "hex": "#8f827c",
      "hls": [
        0.05263157894736842,
        0.521484375,
        0.07755102040816327
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.81.jpg",
    "colors": {
      "hex": "#9c8c84",
      "hls": [
        0.05555555555555556,
        0.5625,
        0.10714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.82.jpg",
    "colors": {
      "hex": "#807a79",
      "hls": [
        0.02380952380952382,
        0.486328125,
        0.028112449799196786
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.83.jpg",
    "colors": {
      "hex": "#867c7b",
      "hls": [
        0.015151515151515157,
        0.501953125,
        0.043137254901960784
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.84.jpg",
    "colors": {
      "hex": "#817e79",
      "hls": [
        0.10416666666666667,
        0.48828125,
        0.032
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.86.jpg",
    "colors": {
      "hex": "#928076",
      "hls": [
        0.059523809523809514,
        0.515625,
        0.11290322580645161
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.87.jpg",
    "colors": {
      "hex": "#817571",
      "hls": [
        0.041666666666666664,
        0.47265625,
        0.06611570247933884
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.88.jpg",
    "colors": {
      "hex": "#96847a",
      "hls": [
        0.059523809523809514,
        0.53125,
        0.11666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.89.jpg",
    "colors": {
      "hex": "#968175",
      "hls": [
        0.06060606060606061,
        0.521484375,
        0.1346938775510204
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.9.jpg",
    "colors": {
      "hex": "#78726e",
      "hls": [
        0.06666666666666667,
        0.44921875,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.90.jpg",
    "colors": {
      "hex": "#827773",
      "hls": [
        0.04444444444444445,
        0.478515625,
        0.061224489795918366
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.91.jpg",
    "colors": {
      "hex": "#817876",
      "hls": [
        0.030303030303030293,
        0.482421875,
        0.044534412955465584
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.92.jpg",
    "colors": {
      "hex": "#857975",
      "hls": [
        0.041666666666666664,
        0.48828125,
        0.064
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.93.jpg",
    "colors": {
      "hex": "#7c706b",
      "hls": [
        0.04901960784313725,
        0.451171875,
        0.0735930735930736
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.94.jpg",
    "colors": {
      "hex": "#827470",
      "hls": [
        0.037037037037037035,
        0.47265625,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.95.jpg",
    "colors": {
      "hex": "#8e7d75",
      "hls": [
        0.05333333333333332,
        0.505859375,
        0.09881422924901186
      ]
    }
  },
  {
    "file": "MFNB_Col_Buprestidae_Julodinae_D030.97.jpg",
    "colors": {
      "hex": "#817572",
      "hls": [
        0.033333333333333326,
        0.474609375,
        0.06172839506172839
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.100.jpg",
    "colors": {
      "hex": "#817d75",
      "hls": [
        0.11111111111111112,
        0.48046875,
        0.04878048780487805
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.101.jpg",
    "colors": {
      "hex": "#837e75",
      "hls": [
        0.10714285714285714,
        0.484375,
        0.056451612903225805
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.102.jpg",
    "colors": {
      "hex": "#837d73",
      "hls": [
        0.10416666666666667,
        0.48046875,
        0.06504065040650407
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.105.jpg",
    "colors": {
      "hex": "#898377",
      "hls": [
        0.11111111111111112,
        0.5,
        0.0703125
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.106.jpg",
    "colors": {
      "hex": "#948d80",
      "hls": [
        0.10833333333333334,
        0.5390625,
        0.0847457627118644
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.109.jpg",
    "colors": {
      "hex": "#898274",
      "hls": [
        0.11111111111111112,
        0.494140625,
        0.08300395256916997
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.11.jpg",
    "colors": {
      "hex": "#888379",
      "hls": [
        0.11111111111111112,
        0.501953125,
        0.058823529411764705
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.111.jpg",
    "colors": {
      "hex": "#b6b6b2",
      "hls": [
        0.16666666666666666,
        0.703125,
        0.02631578947368421
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.117.jpg",
    "colors": {
      "hex": "#837c71",
      "hls": [
        0.10185185185185186,
        0.4765625,
        0.07377049180327869
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.12.jpg",
    "colors": {
      "hex": "#7e7b73",
      "hls": [
        0.12121212121212122,
        0.470703125,
        0.04564315352697095
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.124.jpg",
    "colors": {
      "hex": "#8f8c84",
      "hls": [
        0.12121212121212122,
        0.537109375,
        0.046413502109704644
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.13.jpg",
    "colors": {
      "hex": "#88837b",
      "hls": [
        0.10256410256410257,
        0.505859375,
        0.05138339920948617
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.15.jpg",
    "colors": {
      "hex": "#78746c",
      "hls": [
        0.11111111111111112,
        0.4453125,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.16.jpg",
    "colors": {
      "hex": "#7a776f",
      "hls": [
        0.12121212121212122,
        0.455078125,
        0.04721030042918455
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.17.jpg",
    "colors": {
      "hex": "#78756e",
      "hls": [
        0.11666666666666665,
        0.44921875,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.19.jpg",
    "colors": {
      "hex": "#8e8c86",
      "hls": [
        0.125,
        0.5390625,
        0.03389830508474576
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.20.jpg",
    "colors": {
      "hex": "#89857d",
      "hls": [
        0.11111111111111112,
        0.51171875,
        0.048
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.22.jpg",
    "colors": {
      "hex": "#88857d",
      "hls": [
        0.12121212121212122,
        0.509765625,
        0.043824701195219126
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.23.jpg",
    "colors": {
      "hex": "#9a9489",
      "hls": [
        0.10784313725490195,
        0.568359375,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.24.jpg",
    "colors": {
      "hex": "#908a80",
      "hls": [
        0.10416666666666667,
        0.53125,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.27.jpg",
    "colors": {
      "hex": "#8b8476",
      "hls": [
        0.11111111111111112,
        0.501953125,
        0.08235294117647059
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.30.jpg",
    "colors": {
      "hex": "#84817a",
      "hls": [
        0.11666666666666665,
        0.49609375,
        0.03937007874015748
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.33.jpg",
    "colors": {
      "hex": "#898479",
      "hls": [
        0.11458333333333333,
        0.50390625,
        0.06299212598425197
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.41.jpg",
    "colors": {
      "hex": "#8b8477",
      "hls": [
        0.10833333333333334,
        0.50390625,
        0.07874015748031496
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.42.jpg",
    "colors": {
      "hex": "#7f7e78",
      "hls": [
        0.14285714285714288,
        0.482421875,
        0.02834008097165992
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.44.jpg",
    "colors": {
      "hex": "#7c7b77",
      "hls": [
        0.13333333333333333,
        0.474609375,
        0.0205761316872428
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.46.jpg",
    "colors": {
      "hex": "#89867f",
      "hls": [
        0.11666666666666665,
        0.515625,
        0.04032258064516129
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.47.jpg",
    "colors": {
      "hex": "#807d74",
      "hls": [
        0.125,
        0.4765625,
        0.04918032786885246
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.5.jpg",
    "colors": {
      "hex": "#7a7670",
      "hls": [
        0.09999999999999999,
        0.45703125,
        0.042735042735042736
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.52.jpg",
    "colors": {
      "hex": "#7b7973",
      "hls": [
        0.125,
        0.46484375,
        0.03361344537815126
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.55.jpg",
    "colors": {
      "hex": "#9f9c93",
      "hls": [
        0.125,
        0.59765625,
        0.05825242718446602
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.65.jpg",
    "colors": {
      "hex": "#94928d",
      "hls": [
        0.11904761904761905,
        0.564453125,
        0.03139013452914798
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.66.jpg",
    "colors": {
      "hex": "#a4a099",
      "hls": [
        0.10606060606060606,
        0.619140625,
        0.05641025641025641
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.67.jpg",
    "colors": {
      "hex": "#938e85",
      "hls": [
        0.10714285714285714,
        0.546875,
        0.0603448275862069
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.70.jpg",
    "colors": {
      "hex": "#9f9a90",
      "hls": [
        0.11111111111111112,
        0.591796875,
        0.07177033492822966
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.72.jpg",
    "colors": {
      "hex": "#857f75",
      "hls": [
        0.10416666666666667,
        0.48828125,
        0.064
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.74.jpg",
    "colors": {
      "hex": "#777671",
      "hls": [
        0.1388888888888889,
        0.453125,
        0.02586206896551724
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.75.jpg",
    "colors": {
      "hex": "#797670",
      "hls": [
        0.11111111111111112,
        0.455078125,
        0.03862660944206009
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.76.jpg",
    "colors": {
      "hex": "#898782",
      "hls": [
        0.11904761904761905,
        0.521484375,
        0.02857142857142857
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.77.jpg",
    "colors": {
      "hex": "#898276",
      "hls": [
        0.10526315789473684,
        0.498046875,
        0.07450980392156863
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.78.jpg",
    "colors": {
      "hex": "#78746a",
      "hls": [
        0.11904761904761905,
        0.44140625,
        0.061946902654867256
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.79.jpg",
    "colors": {
      "hex": "#8f8a84",
      "hls": [
        0.0909090909090909,
        0.537109375,
        0.046413502109704644
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.80.jpg",
    "colors": {
      "hex": "#878580",
      "hls": [
        0.11904761904761905,
        0.513671875,
        0.028112449799196786
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.81.jpg",
    "colors": {
      "hex": "#7b7469",
      "hls": [
        0.10185185185185186,
        0.4453125,
        0.07894736842105263
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.82.jpg",
    "colors": {
      "hex": "#726f6b",
      "hls": [
        0.09523809523809523,
        0.431640625,
        0.03167420814479638
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.83.jpg",
    "colors": {
      "hex": "#6a6661",
      "hls": [
        0.0925925925925926,
        0.396484375,
        0.04433497536945813
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.84.jpg",
    "colors": {
      "hex": "#938d82",
      "hls": [
        0.10784313725490195,
        0.541015625,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.85.jpg",
    "colors": {
      "hex": "#9d9991",
      "hls": [
        0.11111111111111112,
        0.58984375,
        0.05714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.87.jpg",
    "colors": {
      "hex": "#8d877c",
      "hls": [
        0.10784313725490195,
        0.517578125,
        0.06882591093117409
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.88.jpg",
    "colors": {
      "hex": "#989389",
      "hls": [
        0.11111111111111112,
        0.564453125,
        0.06726457399103139
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.89.jpg",
    "colors": {
      "hex": "#848179",
      "hls": [
        0.12121212121212122,
        0.494140625,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.9.jpg",
    "colors": {
      "hex": "#8e897f",
      "hls": [
        0.11111111111111112,
        0.525390625,
        0.06172839506172839
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.90.jpg",
    "colors": {
      "hex": "#9a9387",
      "hls": [
        0.10526315789473684,
        0.564453125,
        0.08520179372197309
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.91.jpg",
    "colors": {
      "hex": "#87847c",
      "hls": [
        0.12121212121212122,
        0.505859375,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.92.jpg",
    "colors": {
      "hex": "#848077",
      "hls": [
        0.11538461538461538,
        0.490234375,
        0.05179282868525897
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.94.jpg",
    "colors": {
      "hex": "#8c8981",
      "hls": [
        0.12121212121212122,
        0.525390625,
        0.04526748971193416
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.95.jpg",
    "colors": {
      "hex": "#918a7e",
      "hls": [
        0.10526315789473684,
        0.529296875,
        0.07883817427385892
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.97.jpg",
    "colors": {
      "hex": "#87837a",
      "hls": [
        0.11538461538461538,
        0.501953125,
        0.050980392156862744
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.98.jpg",
    "colors": {
      "hex": "#8e8b84",
      "hls": [
        0.11666666666666665,
        0.53515625,
        0.04201680672268908
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D001.99.jpg",
    "colors": {
      "hex": "#878783",
      "hls": [
        0.16666666666666666,
        0.51953125,
        0.016260162601626018
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.106.jpg",
    "colors": {
      "hex": "#9b9d7b",
      "hls": [
        0.17647058823529407,
        0.546875,
        0.14655172413793102
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.107.jpg",
    "colors": {
      "hex": "#939a78",
      "hls": [
        0.20098039215686278,
        0.53515625,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.11.jpg",
    "colors": {
      "hex": "#808c68",
      "hls": [
        0.22222222222222224,
        0.4765625,
        0.14754098360655737
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.110.jpg",
    "colors": {
      "hex": "#96a074",
      "hls": [
        0.2045454545454545,
        0.5390625,
        0.1864406779661017
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.116.jpg",
    "colors": {
      "hex": "#7d9468",
      "hls": [
        0.25378787878787873,
        0.4921875,
        0.1746031746031746
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.117.jpg",
    "colors": {
      "hex": "#a3b296",
      "hls": [
        0.25595238095238093,
        0.640625,
        0.15217391304347827
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.122.jpg",
    "colors": {
      "hex": "#9fa984",
      "hls": [
        0.2117117117117117,
        0.587890625,
        0.17535545023696683
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.128.jpg",
    "colors": {
      "hex": "#a4a884",
      "hls": [
        0.1851851851851852,
        0.5859375,
        0.16981132075471697
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.129.jpg",
    "colors": {
      "hex": "#99a082",
      "hls": [
        0.20555555555555557,
        0.56640625,
        0.13513513513513514
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.130.jpg",
    "colors": {
      "hex": "#8a8280",
      "hls": [
        0.033333333333333326,
        0.51953125,
        0.04065040650406504
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.131.jpg",
    "colors": {
      "hex": "#a0a282",
      "hls": [
        0.17708333333333334,
        0.5703125,
        0.14545454545454545
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.132.jpg",
    "colors": {
      "hex": "#a1a47d",
      "hls": [
        0.17948717948717952,
        0.564453125,
        0.17488789237668162
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.133.jpg",
    "colors": {
      "hex": "#9da383",
      "hls": [
        0.19791666666666666,
        0.57421875,
        0.14678899082568808
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.134.jpg",
    "colors": {
      "hex": "#9ca07f",
      "hls": [
        0.18686868686868685,
        0.560546875,
        0.14666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.135.jpg",
    "colors": {
      "hex": "#b5baa0",
      "hls": [
        0.19871794871794876,
        0.67578125,
        0.1566265060240964
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.136.jpg",
    "colors": {
      "hex": "#aeb895",
      "hls": [
        0.21428571428571427,
        0.650390625,
        0.19553072625698323
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.137.jpg",
    "colors": {
      "hex": "#8d8682",
      "hls": [
        0.06060606060606061,
        0.529296875,
        0.04564315352697095
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.139.jpg",
    "colors": {
      "hex": "#8b8f73",
      "hls": [
        0.19047619047619047,
        0.50390625,
        0.11023622047244094
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.142.jpg",
    "colors": {
      "hex": "#9ba17d",
      "hls": [
        0.19444444444444442,
        0.55859375,
        0.1592920353982301
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.144.jpg",
    "colors": {
      "hex": "#949979",
      "hls": [
        0.19270833333333334,
        0.53515625,
        0.13445378151260504
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.146.jpg",
    "colors": {
      "hex": "#9ba07f",
      "hls": [
        0.1919191919191919,
        0.560546875,
        0.14666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.147.jpg",
    "colors": {
      "hex": "#a1a883",
      "hls": [
        0.19819819819819817,
        0.583984375,
        0.17370892018779344
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.148.jpg",
    "colors": {
      "hex": "#9fa27b",
      "hls": [
        0.17948717948717952,
        0.556640625,
        0.17180616740088106
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.15.jpg",
    "colors": {
      "hex": "#98a080",
      "hls": [
        0.20833333333333334,
        0.5625,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.150.jpg",
    "colors": {
      "hex": "#afba9d",
      "hls": [
        0.2298850574712644,
        0.669921875,
        0.17159763313609466
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.152.jpg",
    "colors": {
      "hex": "#8e8c88",
      "hls": [
        0.11111111111111112,
        0.54296875,
        0.02564102564102564
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.153.jpg",
    "colors": {
      "hex": "#a19f9a",
      "hls": [
        0.11904761904761905,
        0.615234375,
        0.03553299492385787
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.156.jpg",
    "colors": {
      "hex": "#94a385",
      "hls": [
        0.25,
        0.578125,
        0.1388888888888889
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.158.jpg",
    "colors": {
      "hex": "#9a9d78",
      "hls": [
        0.1801801801801802,
        0.541015625,
        0.1574468085106383
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.159.jpg",
    "colors": {
      "hex": "#9da07b",
      "hls": [
        0.1801801801801802,
        0.552734375,
        0.1615720524017467
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.16.jpg",
    "colors": {
      "hex": "#9ba280",
      "hls": [
        0.20098039215686278,
        0.56640625,
        0.15315315315315314
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.162.jpg",
    "colors": {
      "hex": "#9caa7c",
      "hls": [
        0.21739130434782608,
        0.57421875,
        0.21100917431192662
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.165.jpg",
    "colors": {
      "hex": "#95967c",
      "hls": [
        0.17307692307692304,
        0.53515625,
        0.1092436974789916
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.17.jpg",
    "colors": {
      "hex": "#9ba482",
      "hls": [
        0.2107843137254902,
        0.57421875,
        0.1559633027522936
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.170.jpg",
    "colors": {
      "hex": "#9a9c90",
      "hls": [
        0.19444444444444442,
        0.5859375,
        0.05660377358490566
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.171.jpg",
    "colors": {
      "hex": "#828769",
      "hls": [
        0.19444444444444442,
        0.46875,
        0.125
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.174.jpg",
    "colors": {
      "hex": "#9ea483",
      "hls": [
        0.19696969696969693,
        0.576171875,
        0.15207373271889402
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.176.jpg",
    "colors": {
      "hex": "#8e9777",
      "hls": [
        0.21354166666666666,
        0.52734375,
        0.1322314049586777
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.177.jpg",
    "colors": {
      "hex": "#a2a682",
      "hls": [
        0.1851851851851852,
        0.578125,
        0.16666666666666666
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.178.jpg",
    "colors": {
      "hex": "#a5a888",
      "hls": [
        0.18229166666666666,
        0.59375,
        0.15384615384615385
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.179.jpg",
    "colors": {
      "hex": "#989d77",
      "hls": [
        0.1885964912280702,
        0.5390625,
        0.16101694915254236
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.18.jpg",
    "colors": {
      "hex": "#9b9c81",
      "hls": [
        0.17283950617283952,
        0.556640625,
        0.11894273127753303
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.180.jpg",
    "colors": {
      "hex": "#99aa78",
      "hls": [
        0.2233333333333333,
        0.56640625,
        0.22522522522522523
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.181.jpg",
    "colors": {
      "hex": "#99a27b",
      "hls": [
        0.20512820512820515,
        0.556640625,
        0.17180616740088106
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.183.jpg",
    "colors": {
      "hex": "#9d9e7f",
      "hls": [
        0.17204301075268816,
        0.556640625,
        0.13656387665198239
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.184.jpg",
    "colors": {
      "hex": "#899677",
      "hls": [
        0.23655913978494625,
        0.525390625,
        0.12757201646090535
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.188.jpg",
    "colors": {
      "hex": "#909f7c",
      "hls": [
        0.23809523809523805,
        0.552734375,
        0.15283842794759825
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.189.jpg",
    "colors": {
      "hex": "#9aa681",
      "hls": [
        0.22072072072072077,
        0.576171875,
        0.17050691244239632
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.19.jpg",
    "colors": {
      "hex": "#8e9477",
      "hls": [
        0.20114942528735633,
        0.521484375,
        0.11836734693877551
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.191.jpg",
    "colors": {
      "hex": "#939276",
      "hls": [
        0.16091954022988506,
        0.517578125,
        0.11740890688259109
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.192.jpg",
    "colors": {
      "hex": "#9ca57e",
      "hls": [
        0.20512820512820515,
        0.568359375,
        0.17647058823529413
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.21.jpg",
    "colors": {
      "hex": "#8d9873",
      "hls": [
        0.21621621621621623,
        0.521484375,
        0.1510204081632653
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.23.jpg",
    "colors": {
      "hex": "#97ac7f",
      "hls": [
        0.24444444444444446,
        0.583984375,
        0.2112676056338028
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.26.jpg",
    "colors": {
      "hex": "#9cad81",
      "hls": [
        0.23106060606060605,
        0.58984375,
        0.20952380952380953
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.37.jpg",
    "colors": {
      "hex": "#878c6b",
      "hls": [
        0.1919191919191919,
        0.482421875,
        0.13360323886639677
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.40.jpg",
    "colors": {
      "hex": "#858d6b",
      "hls": [
        0.2058823529411765,
        0.484375,
        0.13709677419354838
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.43.jpg",
    "colors": {
      "hex": "#8f9a77",
      "hls": [
        0.21904761904761902,
        0.533203125,
        0.14644351464435146
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.45.jpg",
    "colors": {
      "hex": "#8e8e68",
      "hls": [
        0.16666666666666666,
        0.48046875,
        0.15447154471544716
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.46.jpg",
    "colors": {
      "hex": "#8c9a72",
      "hls": [
        0.225,
        0.5234375,
        0.16393442622950818
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.49.jpg",
    "colors": {
      "hex": "#879d76",
      "hls": [
        0.26068376068376065,
        0.537109375,
        0.16455696202531644
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.54.jpg",
    "colors": {
      "hex": "#8ea07a",
      "hls": [
        0.2456140350877193,
        0.55078125,
        0.16521739130434782
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.59.jpg",
    "colors": {
      "hex": "#9c9c81",
      "hls": [
        0.16666666666666666,
        0.556640625,
        0.11894273127753303
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.61.jpg",
    "colors": {
      "hex": "#9ca481",
      "hls": [
        0.20476190476190478,
        0.572265625,
        0.1598173515981735
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.62.jpg",
    "colors": {
      "hex": "#9ba079",
      "hls": [
        0.18803418803418803,
        0.548828125,
        0.16883116883116883
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.63.jpg",
    "colors": {
      "hex": "#838d64",
      "hls": [
        0.20731707317073175,
        0.470703125,
        0.17012448132780084
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.64.jpg",
    "colors": {
      "hex": "#8d9f76",
      "hls": [
        0.23983739837398374,
        0.541015625,
        0.17446808510638298
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.65.jpg",
    "colors": {
      "hex": "#90926e",
      "hls": [
        0.1759259259259259,
        0.5,
        0.140625
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.66.jpg",
    "colors": {
      "hex": "#828168",
      "hls": [
        0.16025641025641027,
        0.45703125,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.67.jpg",
    "colors": {
      "hex": "#8b8667",
      "hls": [
        0.14351851851851852,
        0.47265625,
        0.1487603305785124
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.68.jpg",
    "colors": {
      "hex": "#88877c",
      "hls": [
        0.15277777777777776,
        0.5078125,
        0.047619047619047616
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.79.jpg",
    "colors": {
      "hex": "#969977",
      "hls": [
        0.18137254901960786,
        0.53125,
        0.14166666666666666
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D004.80.jpg",
    "colors": {
      "hex": "#9ea381",
      "hls": [
        0.19117647058823528,
        0.5703125,
        0.15454545454545454
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.0.jpg",
    "colors": {
      "hex": "#a7b49a",
      "hls": [
        0.25,
        0.65234375,
        0.14606741573033707
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.1.jpg",
    "colors": {
      "hex": "#b8bfb0",
      "hls": [
        0.24444444444444446,
        0.716796875,
        0.10344827586206896
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.10.jpg",
    "colors": {
      "hex": "#9ca691",
      "hls": [
        0.24603174603174605,
        0.607421875,
        0.1044776119402985
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.11.jpg",
    "colors": {
      "hex": "#8fac84",
      "hls": [
        0.28750000000000003,
        0.59375,
        0.19230769230769232
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.12.jpg",
    "colors": {
      "hex": "#94a888",
      "hls": [
        0.2708333333333333,
        0.59375,
        0.15384615384615385
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.14.jpg",
    "colors": {
      "hex": "#8b9f77",
      "hls": [
        0.25,
        0.54296875,
        0.17094017094017094
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.2.jpg",
    "colors": {
      "hex": "#a8b99f",
      "hls": [
        0.2756410256410256,
        0.671875,
        0.15476190476190477
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.22.jpg",
    "colors": {
      "hex": "#86a67b",
      "hls": [
        0.29069767441860467,
        0.564453125,
        0.19282511210762332
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.24.jpg",
    "colors": {
      "hex": "#b4c5ac",
      "hls": [
        0.28,
        0.720703125,
        0.17482517482517482
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.25.jpg",
    "colors": {
      "hex": "#86a279",
      "hls": [
        0.2804878048780488,
        0.552734375,
        0.17903930131004367
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.26.jpg",
    "colors": {
      "hex": "#85a578",
      "hls": [
        0.2851851851851852,
        0.556640625,
        0.19823788546255505
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.27.jpg",
    "colors": {
      "hex": "#84aa77",
      "hls": [
        0.2908496732026144,
        0.564453125,
        0.22869955156950672
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.28.jpg",
    "colors": {
      "hex": "#8da67f",
      "hls": [
        0.2735042735042735,
        0.572265625,
        0.1780821917808219
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.29.jpg",
    "colors": {
      "hex": "#9faa95",
      "hls": [
        0.25396825396825395,
        0.623046875,
        0.10880829015544041
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.42.jpg",
    "colors": {
      "hex": "#91a27b",
      "hls": [
        0.23931623931623935,
        0.556640625,
        0.17180616740088106
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.45.jpg",
    "colors": {
      "hex": "#87957f",
      "hls": [
        0.2727272727272727,
        0.5390625,
        0.09322033898305085
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.47.jpg",
    "colors": {
      "hex": "#787e76",
      "hls": [
        0.2916666666666667,
        0.4765625,
        0.03278688524590164
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.49.jpg",
    "colors": {
      "hex": "#859979",
      "hls": [
        0.2708333333333333,
        0.53515625,
        0.13445378151260504
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.52.jpg",
    "colors": {
      "hex": "#8c8780",
      "hls": [
        0.09722222222222221,
        0.5234375,
        0.04918032786885246
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.54.jpg",
    "colors": {
      "hex": "#909180",
      "hls": [
        0.17647058823529407,
        0.533203125,
        0.07112970711297072
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.55.jpg",
    "colors": {
      "hex": "#778270",
      "hls": [
        0.26851851851851855,
        0.47265625,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.56.jpg",
    "colors": {
      "hex": "#848874",
      "hls": [
        0.20000000000000004,
        0.4921875,
        0.07936507936507936
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.58.jpg",
    "colors": {
      "hex": "#798d6f",
      "hls": [
        0.27777777777777773,
        0.4921875,
        0.11904761904761904
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.59.jpg",
    "colors": {
      "hex": "#78886f",
      "hls": [
        0.2733333333333334,
        0.482421875,
        0.10121457489878542
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.63.jpg",
    "colors": {
      "hex": "#85957a",
      "hls": [
        0.2654320987654321,
        0.529296875,
        0.11203319502074689
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.64.jpg",
    "colors": {
      "hex": "#8b9a84",
      "hls": [
        0.2803030303030303,
        0.55859375,
        0.09734513274336283
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.68.jpg",
    "colors": {
      "hex": "#767764",
      "hls": [
        0.1754385964912281,
        0.427734375,
        0.0867579908675799
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.69.jpg",
    "colors": {
      "hex": "#849876",
      "hls": [
        0.2647058823529412,
        0.52734375,
        0.14049586776859505
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.70.jpg",
    "colors": {
      "hex": "#909380",
      "hls": [
        0.1929824561403509,
        0.537109375,
        0.08016877637130802
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.71.jpg",
    "colors": {
      "hex": "#758a6b",
      "hls": [
        0.27956989247311825,
        0.478515625,
        0.12653061224489795
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.72.jpg",
    "colors": {
      "hex": "#8a9a6f",
      "hls": [
        0.22868217054263562,
        0.517578125,
        0.17408906882591094
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.73.jpg",
    "colors": {
      "hex": "#9daa8c",
      "hls": [
        0.23888888888888893,
        0.60546875,
        0.1485148514851485
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.75.jpg",
    "colors": {
      "hex": "#89a27b",
      "hls": [
        0.2735042735042735,
        0.556640625,
        0.17180616740088106
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.77.jpg",
    "colors": {
      "hex": "#8aa875",
      "hls": [
        0.2647058823529412,
        0.556640625,
        0.22466960352422907
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.78.jpg",
    "colors": {
      "hex": "#81926c",
      "hls": [
        0.24122807017543857,
        0.49609375,
        0.14960629921259844
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.79.jpg",
    "colors": {
      "hex": "#959c7c",
      "hls": [
        0.203125,
        0.546875,
        0.13793103448275862
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.80.jpg",
    "colors": {
      "hex": "#8e9b7f",
      "hls": [
        0.24404761904761907,
        0.55078125,
        0.12173913043478261
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.82.jpg",
    "colors": {
      "hex": "#949788",
      "hls": [
        0.20000000000000004,
        0.560546875,
        0.06666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.83.jpg",
    "colors": {
      "hex": "#7c7f6a",
      "hls": [
        0.19047619047619047,
        0.455078125,
        0.09012875536480687
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.84.jpg",
    "colors": {
      "hex": "#8b967d",
      "hls": [
        0.24,
        0.537109375,
        0.10548523206751055
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.85.jpg",
    "colors": {
      "hex": "#7f9976",
      "hls": [
        0.2904761904761905,
        0.529296875,
        0.14522821576763487
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.90.jpg",
    "colors": {
      "hex": "#a0ac92",
      "hls": [
        0.2435897435897436,
        0.62109375,
        0.13402061855670103
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.92.jpg",
    "colors": {
      "hex": "#7b8e68",
      "hls": [
        0.25,
        0.48046875,
        0.15447154471544716
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.94.jpg",
    "colors": {
      "hex": "#7d9076",
      "hls": [
        0.2884615384615385,
        0.51171875,
        0.104
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.95.jpg",
    "colors": {
      "hex": "#b7baa6",
      "hls": [
        0.19166666666666665,
        0.6875,
        0.125
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.97.jpg",
    "colors": {
      "hex": "#b3beaa",
      "hls": [
        0.2583333333333333,
        0.703125,
        0.13157894736842105
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D018.99.jpg",
    "colors": {
      "hex": "#b8bda7",
      "hls": [
        0.2045454545454545,
        0.6953125,
        0.14102564102564102
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.10.jpg",
    "colors": {
      "hex": "#828079",
      "hls": [
        0.12962962962962962,
        0.490234375,
        0.035856573705179286
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.11.jpg",
    "colors": {
      "hex": "#7e7c75",
      "hls": [
        0.12962962962962962,
        0.474609375,
        0.037037037037037035
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.13.jpg",
    "colors": {
      "hex": "#87857e",
      "hls": [
        0.12962962962962962,
        0.509765625,
        0.035856573705179286
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.14.jpg",
    "colors": {
      "hex": "#8c8b84",
      "hls": [
        0.14583333333333334,
        0.53125,
        0.03333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.15.jpg",
    "colors": {
      "hex": "#84837c",
      "hls": [
        0.14583333333333334,
        0.5,
        0.03125
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.16.jpg",
    "colors": {
      "hex": "#898882",
      "hls": [
        0.14285714285714288,
        0.521484375,
        0.02857142857142857
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.18.jpg",
    "colors": {
      "hex": "#8a8780",
      "hls": [
        0.11666666666666665,
        0.51953125,
        0.04065040650406504
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.19.jpg",
    "colors": {
      "hex": "#9a908b",
      "hls": [
        0.05555555555555556,
        0.572265625,
        0.0684931506849315
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.2.jpg",
    "colors": {
      "hex": "#96928c",
      "hls": [
        0.09999999999999999,
        0.56640625,
        0.04504504504504504
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.23.jpg",
    "colors": {
      "hex": "#7d7c75",
      "hls": [
        0.14583333333333334,
        0.47265625,
        0.03305785123966942
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.25.jpg",
    "colors": {
      "hex": "#7d7c74",
      "hls": [
        0.14814814814814814,
        0.470703125,
        0.03734439834024896
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.26.jpg",
    "colors": {
      "hex": "#b8b6b0",
      "hls": [
        0.125,
        0.703125,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.27.jpg",
    "colors": {
      "hex": "#aba9a4",
      "hls": [
        0.11904761904761905,
        0.654296875,
        0.03954802259887006
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.30.jpg",
    "colors": {
      "hex": "#a09995",
      "hls": [
        0.06060606060606061,
        0.603515625,
        0.054187192118226604
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.33.jpg",
    "colors": {
      "hex": "#87847b",
      "hls": [
        0.125,
        0.50390625,
        0.047244094488188976
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.34.jpg",
    "colors": {
      "hex": "#82817c",
      "hls": [
        0.1388888888888889,
        0.49609375,
        0.023622047244094488
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.35.jpg",
    "colors": {
      "hex": "#7e7d76",
      "hls": [
        0.14583333333333334,
        0.4765625,
        0.03278688524590164
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.36.jpg",
    "colors": {
      "hex": "#8e8c84",
      "hls": [
        0.13333333333333333,
        0.53515625,
        0.04201680672268908
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.37.jpg",
    "colors": {
      "hex": "#84827a",
      "hls": [
        0.13333333333333333,
        0.49609375,
        0.03937007874015748
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.39.jpg",
    "colors": {
      "hex": "#847f76",
      "hls": [
        0.10714285714285714,
        0.48828125,
        0.056
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.42.jpg",
    "colors": {
      "hex": "#827f78",
      "hls": [
        0.11666666666666665,
        0.48828125,
        0.04
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.43.jpg",
    "colors": {
      "hex": "#8a877f",
      "hls": [
        0.12121212121212122,
        0.517578125,
        0.044534412955465584
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.44.jpg",
    "colors": {
      "hex": "#7e7c76",
      "hls": [
        0.125,
        0.4765625,
        0.03278688524590164
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.45.jpg",
    "colors": {
      "hex": "#b0a8a4",
      "hls": [
        0.05555555555555556,
        0.6640625,
        0.06976744186046512
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.46.jpg",
    "colors": {
      "hex": "#9a8c86",
      "hls": [
        0.05000000000000001,
        0.5625,
        0.08928571428571429
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.48.jpg",
    "colors": {
      "hex": "#979793",
      "hls": [
        0.16666666666666666,
        0.58203125,
        0.018691588785046728
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.49.jpg",
    "colors": {
      "hex": "#7b7a75",
      "hls": [
        0.1388888888888889,
        0.46875,
        0.025
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.5.jpg",
    "colors": {
      "hex": "#988b84",
      "hls": [
        0.05833333333333333,
        0.5546875,
        0.08771929824561403
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.52.jpg",
    "colors": {
      "hex": "#a29894",
      "hls": [
        0.047619047619047616,
        0.60546875,
        0.06930693069306931
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.54.jpg",
    "colors": {
      "hex": "#93908a",
      "hls": [
        0.11111111111111112,
        0.556640625,
        0.039647577092511016
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.57.jpg",
    "colors": {
      "hex": "#87857d",
      "hls": [
        0.13333333333333333,
        0.5078125,
        0.03968253968253968
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.6.jpg",
    "colors": {
      "hex": "#888780",
      "hls": [
        0.14583333333333334,
        0.515625,
        0.03225806451612903
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.61.jpg",
    "colors": {
      "hex": "#757570",
      "hls": [
        0.16666666666666666,
        0.447265625,
        0.021834061135371178
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.7.jpg",
    "colors": {
      "hex": "#97958f",
      "hls": [
        0.125,
        0.57421875,
        0.03669724770642202
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D030.8.jpg",
    "colors": {
      "hex": "#807c74",
      "hls": [
        0.11111111111111112,
        0.4765625,
        0.04918032786885246
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.15.jpg",
    "colors": {
      "hex": "#7b7972",
      "hls": [
        0.12962962962962962,
        0.462890625,
        0.0379746835443038
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.25.jpg",
    "colors": {
      "hex": "#98958f",
      "hls": [
        0.11111111111111112,
        0.576171875,
        0.041474654377880185
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.28.jpg",
    "colors": {
      "hex": "#929188",
      "hls": [
        0.15,
        0.55078125,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.33.jpg",
    "colors": {
      "hex": "#736d65",
      "hls": [
        0.09523809523809523,
        0.421875,
        0.06481481481481481
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.36.jpg",
    "colors": {
      "hex": "#989690",
      "hls": [
        0.125,
        0.578125,
        0.037037037037037035
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.40.jpg",
    "colors": {
      "hex": "#76736b",
      "hls": [
        0.12121212121212122,
        0.439453125,
        0.04888888888888889
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.45.jpg",
    "colors": {
      "hex": "#89877b",
      "hls": [
        0.14285714285714288,
        0.5078125,
        0.05555555555555555
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D042.46.jpg",
    "colors": {
      "hex": "#827c75",
      "hls": [
        0.08974358974358974,
        0.482421875,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.10.jpg",
    "colors": {
      "hex": "#999894",
      "hls": [
        0.13333333333333333,
        0.587890625,
        0.023696682464454975
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.100.jpg",
    "colors": {
      "hex": "#70797b",
      "hls": [
        0.5303030303030303,
        0.458984375,
        0.04680851063829787
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.101.jpg",
    "colors": {
      "hex": "#7a8483",
      "hls": [
        0.48333333333333334,
        0.49609375,
        0.03937007874015748
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.102.jpg",
    "colors": {
      "hex": "#787f80",
      "hls": [
        0.5208333333333334,
        0.484375,
        0.03225806451612903
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.103.jpg",
    "colors": {
      "hex": "#a18d7f",
      "hls": [
        0.06862745098039215,
        0.5625,
        0.15178571428571427
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.104.jpg",
    "colors": {
      "hex": "#958c7e",
      "hls": [
        0.10144927536231885,
        0.537109375,
        0.0970464135021097
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.105.jpg",
    "colors": {
      "hex": "#9d897e",
      "hls": [
        0.05913978494623656,
        0.552734375,
        0.13537117903930132
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.106.jpg",
    "colors": {
      "hex": "#828386",
      "hls": [
        0.625,
        0.515625,
        0.016129032258064516
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.107.jpg",
    "colors": {
      "hex": "#9b8573",
      "hls": [
        0.075,
        0.52734375,
        0.1652892561983471
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.108.jpg",
    "colors": {
      "hex": "#94796e",
      "hls": [
        0.048245614035087724,
        0.50390625,
        0.14960629921259844
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.109.jpg",
    "colors": {
      "hex": "#a39086",
      "hls": [
        0.0574712643678161,
        0.580078125,
        0.13488372093023257
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.110.jpg",
    "colors": {
      "hex": "#a99786",
      "hls": [
        0.08095238095238096,
        0.591796875,
        0.1674641148325359
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.111.jpg",
    "colors": {
      "hex": "#a79381",
      "hls": [
        0.07894736842105264,
        0.578125,
        0.17592592592592593
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.112.jpg",
    "colors": {
      "hex": "#a88e82",
      "hls": [
        0.05263157894736842,
        0.58203125,
        0.17757009345794392
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.113.jpg",
    "colors": {
      "hex": "#9c8775",
      "hls": [
        0.07692307692307693,
        0.533203125,
        0.16317991631799164
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.114.jpg",
    "colors": {
      "hex": "#a38e82",
      "hls": [
        0.06060606060606061,
        0.572265625,
        0.1506849315068493
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.115.jpg",
    "colors": {
      "hex": "#a89687",
      "hls": [
        0.07575757575757576,
        0.591796875,
        0.15789473684210525
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.118.jpg",
    "colors": {
      "hex": "#a1999c",
      "hls": [
        0.9375,
        0.61328125,
        0.04040404040404041
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.119.jpg",
    "colors": {
      "hex": "#7c7f85",
      "hls": [
        0.6111111111111112,
        0.501953125,
        0.03529411764705882
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.12.jpg",
    "colors": {
      "hex": "#a2947f",
      "hls": [
        0.09999999999999999,
        0.564453125,
        0.15695067264573992
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.120.jpg",
    "colors": {
      "hex": "#7d917a",
      "hls": [
        0.3115942028985507,
        0.521484375,
        0.09387755102040816
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.121.jpg",
    "colors": {
      "hex": "#7b867f",
      "hls": [
        0.393939393939394,
        0.501953125,
        0.043137254901960784
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.122.jpg",
    "colors": {
      "hex": "#819178",
      "hls": [
        0.2733333333333334,
        0.517578125,
        0.10121457489878542
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.123.jpg",
    "colors": {
      "hex": "#7d8488",
      "hls": [
        0.5606060606060606,
        0.509765625,
        0.043824701195219126
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.125.jpg",
    "colors": {
      "hex": "#8e9095",
      "hls": [
        0.6190476190476191,
        0.568359375,
        0.03167420814479638
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.127.jpg",
    "colors": {
      "hex": "#847868",
      "hls": [
        0.09523809523809523,
        0.4609375,
        0.11864406779661017
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.129.jpg",
    "colors": {
      "hex": "#979e81",
      "hls": [
        0.2068965517241379,
        0.560546875,
        0.1288888888888889
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.130.jpg",
    "colors": {
      "hex": "#907e71",
      "hls": [
        0.06989247311827956,
        0.501953125,
        0.12156862745098039
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.131.jpg",
    "colors": {
      "hex": "#959a7f",
      "hls": [
        0.19753086419753085,
        0.548828125,
        0.11688311688311688
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.132.jpg",
    "colors": {
      "hex": "#968279",
      "hls": [
        0.051724137931034475,
        0.529296875,
        0.12033195020746888
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.135.jpg",
    "colors": {
      "hex": "#a38377",
      "hls": [
        0.04545454545454545,
        0.55078125,
        0.19130434782608696
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.136.jpg",
    "colors": {
      "hex": "#9f8a79",
      "hls": [
        0.07456140350877193,
        0.546875,
        0.16379310344827586
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.137.jpg",
    "colors": {
      "hex": "#9c887d",
      "hls": [
        0.05913978494623656,
        0.548828125,
        0.1341991341991342
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.138.jpg",
    "colors": {
      "hex": "#a98f81",
      "hls": [
        0.05833333333333333,
        0.58203125,
        0.18691588785046728
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.139.jpg",
    "colors": {
      "hex": "#a08a80",
      "hls": [
        0.052083333333333336,
        0.5625,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.140.jpg",
    "colors": {
      "hex": "#8a9290",
      "hls": [
        0.4583333333333333,
        0.5546875,
        0.03508771929824561
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.142.jpg",
    "colors": {
      "hex": "#919892",
      "hls": [
        0.35714285714285715,
        0.580078125,
        0.03255813953488372
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.143.jpg",
    "colors": {
      "hex": "#89918c",
      "hls": [
        0.3958333333333333,
        0.55078125,
        0.034782608695652174
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.144.jpg",
    "colors": {
      "hex": "#7a8382",
      "hls": [
        0.48148148148148145,
        0.494140625,
        0.03557312252964427
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.145.jpg",
    "colors": {
      "hex": "#7e9475",
      "hls": [
        0.2849462365591398,
        0.517578125,
        0.12550607287449392
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.146.jpg",
    "colors": {
      "hex": "#83917c",
      "hls": [
        0.27777777777777773,
        0.525390625,
        0.08641975308641975
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.147.jpg",
    "colors": {
      "hex": "#6d757e",
      "hls": [
        0.5882352941176471,
        0.458984375,
        0.07234042553191489
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.148.jpg",
    "colors": {
      "hex": "#a68e7f",
      "hls": [
        0.0641025641025641,
        0.572265625,
        0.1780821917808219
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.15.jpg",
    "colors": {
      "hex": "#868a72",
      "hls": [
        0.19444444444444442,
        0.4921875,
        0.09523809523809523
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.151.jpg",
    "colors": {
      "hex": "#a18b80",
      "hls": [
        0.05555555555555556,
        0.564453125,
        0.14798206278026907
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.155.jpg",
    "colors": {
      "hex": "#a68e82",
      "hls": [
        0.05555555555555556,
        0.578125,
        0.16666666666666666
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.156.jpg",
    "colors": {
      "hex": "#96837a",
      "hls": [
        0.05357142857142857,
        0.53125,
        0.11666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.157.jpg",
    "colors": {
      "hex": "#9d877d",
      "hls": [
        0.052083333333333336,
        0.55078125,
        0.1391304347826087
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.158.jpg",
    "colors": {
      "hex": "#7fa177",
      "hls": [
        0.30158730158730157,
        0.546875,
        0.1810344827586207
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.159.jpg",
    "colors": {
      "hex": "#95989a",
      "hls": [
        0.5666666666666668,
        0.591796875,
        0.023923444976076555
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.160.jpg",
    "colors": {
      "hex": "#9c897e",
      "hls": [
        0.061111111111111116,
        0.55078125,
        0.13043478260869565
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.161.jpg",
    "colors": {
      "hex": "#9aa0a2",
      "hls": [
        0.5416666666666666,
        0.6171875,
        0.04081632653061224
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.162.jpg",
    "colors": {
      "hex": "#8b9091",
      "hls": [
        0.5277777777777778,
        0.5546875,
        0.02631578947368421
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.163.jpg",
    "colors": {
      "hex": "#919799",
      "hls": [
        0.5416666666666666,
        0.58203125,
        0.037383177570093455
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.164.jpg",
    "colors": {
      "hex": "#89958d",
      "hls": [
        0.3888888888888889,
        0.55859375,
        0.05309734513274336
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.165.jpg",
    "colors": {
      "hex": "#81907f",
      "hls": [
        0.3137254901960784,
        0.529296875,
        0.07053941908713693
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.166.jpg",
    "colors": {
      "hex": "#707673",
      "hls": [
        0.4166666666666667,
        0.44921875,
        0.02608695652173913
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.167.jpg",
    "colors": {
      "hex": "#8a9b78",
      "hls": [
        0.24761904761904763,
        0.537109375,
        0.14767932489451477
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.168.jpg",
    "colors": {
      "hex": "#939689",
      "hls": [
        0.20512820512820515,
        0.560546875,
        0.057777777777777775
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.170.jpg",
    "colors": {
      "hex": "#a5927e",
      "hls": [
        0.08547008547008546,
        0.568359375,
        0.17647058823529413
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.171.jpg",
    "colors": {
      "hex": "#a0887d",
      "hls": [
        0.05238095238095238,
        0.556640625,
        0.15418502202643172
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.174.jpg",
    "colors": {
      "hex": "#978175",
      "hls": [
        0.0588235294117647,
        0.5234375,
        0.13934426229508196
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.175.jpg",
    "colors": {
      "hex": "#90959a",
      "hls": [
        0.5833333333333334,
        0.58203125,
        0.04672897196261682
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.177.jpg",
    "colors": {
      "hex": "#9f8879",
      "hls": [
        0.06578947368421052,
        0.546875,
        0.16379310344827586
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.178.jpg",
    "colors": {
      "hex": "#889291",
      "hls": [
        0.48333333333333334,
        0.55078125,
        0.043478260869565216
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.179.jpg",
    "colors": {
      "hex": "#959c8e",
      "hls": [
        0.25,
        0.58203125,
        0.06542056074766354
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.18.jpg",
    "colors": {
      "hex": "#81866a",
      "hls": [
        0.1964285714285714,
        0.46875,
        0.11666666666666667
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.180.jpg",
    "colors": {
      "hex": "#898f86",
      "hls": [
        0.27777777777777773,
        0.541015625,
        0.03829787234042553
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.181.jpg",
    "colors": {
      "hex": "#777f76",
      "hls": [
        0.3148148148148148,
        0.478515625,
        0.036734693877551024
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.182.jpg",
    "colors": {
      "hex": "#ae9e97",
      "hls": [
        0.050724637681159424,
        0.634765625,
        0.12299465240641712
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.183.jpg",
    "colors": {
      "hex": "#97a38b",
      "hls": [
        0.25,
        0.58984375,
        0.11428571428571428
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.184.jpg",
    "colors": {
      "hex": "#8f9797",
      "hls": [
        0.5,
        0.57421875,
        0.03669724770642202
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.21.jpg",
    "colors": {
      "hex": "#928b7b",
      "hls": [
        0.11594202898550725,
        0.525390625,
        0.09465020576131687
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.22.jpg",
    "colors": {
      "hex": "#8a8b72",
      "hls": [
        0.17333333333333334,
        0.494140625,
        0.09881422924901186
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.23.jpg",
    "colors": {
      "hex": "#80876a",
      "hls": [
        0.2068965517241379,
        0.470703125,
        0.12033195020746888
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.24.jpg",
    "colors": {
      "hex": "#97a384",
      "hls": [
        0.23118279569892475,
        0.576171875,
        0.14285714285714285
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.26.jpg",
    "colors": {
      "hex": "#8e967b",
      "hls": [
        0.21604938271604937,
        0.533203125,
        0.11297071129707113
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.31.jpg",
    "colors": {
      "hex": "#8e9b7c",
      "hls": [
        0.23655913978494625,
        0.544921875,
        0.13304721030042918
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.32.jpg",
    "colors": {
      "hex": "#868973",
      "hls": [
        0.18939393939393936,
        0.4921875,
        0.0873015873015873
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.4.jpg",
    "colors": {
      "hex": "#869f75",
      "hls": [
        0.26587301587301587,
        0.5390625,
        0.17796610169491525
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.40.jpg",
    "colors": {
      "hex": "#a69a8b",
      "hls": [
        0.0925925925925926,
        0.595703125,
        0.13043478260869565
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.41.jpg",
    "colors": {
      "hex": "#8d8b74",
      "hls": [
        0.15333333333333335,
        0.501953125,
        0.09803921568627451
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.43.jpg",
    "colors": {
      "hex": "#9a8a7c",
      "hls": [
        0.07777777777777778,
        0.54296875,
        0.1282051282051282
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.5.jpg",
    "colors": {
      "hex": "#91a282",
      "hls": [
        0.2552083333333333,
        0.5703125,
        0.14545454545454545
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.50.jpg",
    "colors": {
      "hex": "#909679",
      "hls": [
        0.20114942528735633,
        0.529296875,
        0.12033195020746888
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.51.jpg",
    "colors": {
      "hex": "#8c9579",
      "hls": [
        0.22023809523809526,
        0.52734375,
        0.11570247933884298
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.52.jpg",
    "colors": {
      "hex": "#8d9883",
      "hls": [
        0.25396825396825395,
        0.552734375,
        0.09170305676855896
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.53.jpg",
    "colors": {
      "hex": "#76785c",
      "hls": [
        0.1785714285714286,
        0.4140625,
        0.1320754716981132
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.54.jpg",
    "colors": {
      "hex": "#788f68",
      "hls": [
        0.26495726495726496,
        0.482421875,
        0.15789473684210525
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.55.jpg",
    "colors": {
      "hex": "#92977b",
      "hls": [
        0.1964285714285714,
        0.53515625,
        0.11764705882352941
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.56.jpg",
    "colors": {
      "hex": "#8a957a",
      "hls": [
        0.23456790123456792,
        0.529296875,
        0.11203319502074689
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.57.jpg",
    "colors": {
      "hex": "#878a6d",
      "hls": [
        0.1839080459770115,
        0.482421875,
        0.11740890688259109
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.58.jpg",
    "colors": {
      "hex": "#868e6e",
      "hls": [
        0.20833333333333334,
        0.4921875,
        0.12698412698412698
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.6.jpg",
    "colors": {
      "hex": "#95897a",
      "hls": [
        0.0925925925925926,
        0.529296875,
        0.11203319502074689
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.66.jpg",
    "colors": {
      "hex": "#9b9080",
      "hls": [
        0.09876543209876543,
        0.552734375,
        0.11790393013100436
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.7.jpg",
    "colors": {
      "hex": "#8c8d78",
      "hls": [
        0.17460317460317457,
        0.509765625,
        0.08366533864541832
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.74.jpg",
    "colors": {
      "hex": "#888b77",
      "hls": [
        0.19166666666666665,
        0.50390625,
        0.07874015748031496
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.8.jpg",
    "colors": {
      "hex": "#968677",
      "hls": [
        0.08064516129032258,
        0.525390625,
        0.12757201646090535
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.89.jpg",
    "colors": {
      "hex": "#83886e",
      "hls": [
        0.19871794871794876,
        0.48046875,
        0.10569105691056911
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.9.jpg",
    "colors": {
      "hex": "#879575",
      "hls": [
        0.23958333333333334,
        0.51953125,
        0.13008130081300814
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.96.jpg",
    "colors": {
      "hex": "#7e8983",
      "hls": [
        0.4090909090909091,
        0.513671875,
        0.04417670682730924
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D086.98.jpg",
    "colors": {
      "hex": "#778378",
      "hls": [
        0.34722222222222227,
        0.48828125,
        0.048
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.1.jpg",
    "colors": {
      "hex": "#9da696",
      "hls": [
        0.2604166666666667,
        0.6171875,
        0.08163265306122448
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.10.jpg",
    "colors": {
      "hex": "#909482",
      "hls": [
        0.20370370370370372,
        0.54296875,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.103.jpg",
    "colors": {
      "hex": "#98a288",
      "hls": [
        0.23076923076923075,
        0.58203125,
        0.12149532710280374
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.105.jpg",
    "colors": {
      "hex": "#85847c",
      "hls": [
        0.14814814814814814,
        0.501953125,
        0.03529411764705882
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.106.jpg",
    "colors": {
      "hex": "#7f7f79",
      "hls": [
        0.16666666666666666,
        0.484375,
        0.024193548387096774
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.107.jpg",
    "colors": {
      "hex": "#7d8572",
      "hls": [
        0.23684210526315788,
        0.482421875,
        0.07692307692307693
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.109.jpg",
    "colors": {
      "hex": "#898780",
      "hls": [
        0.12962962962962962,
        0.517578125,
        0.03643724696356275
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.114.jpg",
    "colors": {
      "hex": "#7f7e75",
      "hls": [
        0.15,
        0.4765625,
        0.040983606557377046
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.12.jpg",
    "colors": {
      "hex": "#838970",
      "hls": [
        0.2066666666666667,
        0.486328125,
        0.10040160642570281
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.120.jpg",
    "colors": {
      "hex": "#798c72",
      "hls": [
        0.2884615384615385,
        0.49609375,
        0.10236220472440945
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.121.jpg",
    "colors": {
      "hex": "#818c70",
      "hls": [
        0.23214285714285712,
        0.4921875,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.122.jpg",
    "colors": {
      "hex": "#808573",
      "hls": [
        0.21296296296296294,
        0.484375,
        0.07258064516129033
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.123.jpg",
    "colors": {
      "hex": "#798470",
      "hls": [
        0.2583333333333333,
        0.4765625,
        0.08196721311475409
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.125.jpg",
    "colors": {
      "hex": "#8f8a7c",
      "hls": [
        0.12280701754385966,
        0.521484375,
        0.07755102040816327
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.126.jpg",
    "colors": {
      "hex": "#838a70",
      "hls": [
        0.21153846153846154,
        0.48828125,
        0.104
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.13.jpg",
    "colors": {
      "hex": "#8e877f",
      "hls": [
        0.08888888888888889,
        0.525390625,
        0.06172839506172839
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.132.jpg",
    "colors": {
      "hex": "#7c806b",
      "hls": [
        0.19841269841269846,
        0.458984375,
        0.08936170212765958
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.136.jpg",
    "colors": {
      "hex": "#7f8568",
      "hls": [
        0.20114942528735633,
        0.462890625,
        0.12236286919831224
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.14.jpg",
    "colors": {
      "hex": "#949189",
      "hls": [
        0.12121212121212122,
        0.556640625,
        0.048458149779735685
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.141.jpg",
    "colors": {
      "hex": "#849279",
      "hls": [
        0.26,
        0.521484375,
        0.10204081632653061
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.142.jpg",
    "colors": {
      "hex": "#717c67",
      "hls": [
        0.25396825396825395,
        0.443359375,
        0.09251101321585903
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.143.jpg",
    "colors": {
      "hex": "#7c7a73",
      "hls": [
        0.12962962962962962,
        0.466796875,
        0.03765690376569038
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.144.jpg",
    "colors": {
      "hex": "#7d7c76",
      "hls": [
        0.14285714285714288,
        0.474609375,
        0.02880658436213992
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.15.jpg",
    "colors": {
      "hex": "#867a74",
      "hls": [
        0.05555555555555556,
        0.48828125,
        0.072
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.159.jpg",
    "colors": {
      "hex": "#929b85",
      "hls": [
        0.23484848484848486,
        0.5625,
        0.09821428571428571
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.16.jpg",
    "colors": {
      "hex": "#80796c",
      "hls": [
        0.10833333333333334,
        0.4609375,
        0.0847457627118644
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.161.jpg",
    "colors": {
      "hex": "#8c9384",
      "hls": [
        0.24444444444444446,
        0.544921875,
        0.06437768240343347
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.162.jpg",
    "colors": {
      "hex": "#919b7e",
      "hls": [
        0.2241379310344828,
        0.548828125,
        0.12554112554112554
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.163.jpg",
    "colors": {
      "hex": "#93997f",
      "hls": [
        0.20512820512820515,
        0.546875,
        0.11206896551724138
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.164.jpg",
    "colors": {
      "hex": "#8a9484",
      "hls": [
        0.2708333333333333,
        0.546875,
        0.06896551724137931
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.166.jpg",
    "colors": {
      "hex": "#909984",
      "hls": [
        0.23809523809523805,
        0.556640625,
        0.09251101321585903
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.175.jpg",
    "colors": {
      "hex": "#818e75",
      "hls": [
        0.25333333333333335,
        0.505859375,
        0.09881422924901186
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.178.jpg",
    "colors": {
      "hex": "#8b957c",
      "hls": [
        0.2333333333333333,
        0.533203125,
        0.10460251046025104
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.18.jpg",
    "colors": {
      "hex": "#888376",
      "hls": [
        0.12037037037037036,
        0.49609375,
        0.07086614173228346
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.180.jpg",
    "colors": {
      "hex": "#979f8e",
      "hls": [
        0.2450980392156863,
        0.587890625,
        0.08056872037914692
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.182.jpg",
    "colors": {
      "hex": "#949d8b",
      "hls": [
        0.25,
        0.578125,
        0.08333333333333333
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.183.jpg",
    "colors": {
      "hex": "#8e8f80",
      "hls": [
        0.1777777777777778,
        0.529296875,
        0.06224066390041494
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.19.jpg",
    "colors": {
      "hex": "#889078",
      "hls": [
        0.22222222222222224,
        0.515625,
        0.0967741935483871
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.2.jpg",
    "colors": {
      "hex": "#92957c",
      "hls": [
        0.18666666666666668,
        0.533203125,
        0.10460251046025104
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.20.jpg",
    "colors": {
      "hex": "#7d8b6c",
      "hls": [
        0.24193548387096775,
        0.482421875,
        0.12550607287449392
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.22.jpg",
    "colors": {
      "hex": "#7c876e",
      "hls": [
        0.24,
        0.478515625,
        0.10204081632653061
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.23.jpg",
    "colors": {
      "hex": "#6c6d5b",
      "hls": [
        0.1759259259259259,
        0.390625,
        0.09
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.24.jpg",
    "colors": {
      "hex": "#7f776c",
      "hls": [
        0.09649122807017545,
        0.458984375,
        0.08085106382978724
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.26.jpg",
    "colors": {
      "hex": "#858076",
      "hls": [
        0.11111111111111112,
        0.490234375,
        0.05976095617529881
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.28.jpg",
    "colors": {
      "hex": "#8c8780",
      "hls": [
        0.09722222222222221,
        0.5234375,
        0.04918032786885246
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.3.jpg",
    "colors": {
      "hex": "#8f967c",
      "hls": [
        0.21153846153846154,
        0.53515625,
        0.1092436974789916
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.32.jpg",
    "colors": {
      "hex": "#92a086",
      "hls": [
        0.2564102564102564,
        0.57421875,
        0.11926605504587157
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.33.jpg",
    "colors": {
      "hex": "#8b7d77",
      "hls": [
        0.05000000000000001,
        0.50390625,
        0.07874015748031496
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.37.jpg",
    "colors": {
      "hex": "#9f9e8d",
      "hls": [
        0.1574074074074074,
        0.5859375,
        0.08490566037735849
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.38.jpg",
    "colors": {
      "hex": "#989389",
      "hls": [
        0.11111111111111112,
        0.564453125,
        0.06726457399103139
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.4.jpg",
    "colors": {
      "hex": "#9ea291",
      "hls": [
        0.2058823529411765,
        0.599609375,
        0.08292682926829269
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.44.jpg",
    "colors": {
      "hex": "#849276",
      "hls": [
        0.25,
        0.515625,
        0.11290322580645161
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.46.jpg",
    "colors": {
      "hex": "#90907f",
      "hls": [
        0.16666666666666666,
        0.529296875,
        0.07053941908713693
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.47.jpg",
    "colors": {
      "hex": "#979986",
      "hls": [
        0.18421052631578946,
        0.560546875,
        0.08444444444444445
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.49.jpg",
    "colors": {
      "hex": "#777866",
      "hls": [
        0.1759259259259259,
        0.43359375,
        0.08108108108108109
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.50.jpg",
    "colors": {
      "hex": "#787964",
      "hls": [
        0.17460317460317457,
        0.431640625,
        0.09502262443438914
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.51.jpg",
    "colors": {
      "hex": "#808170",
      "hls": [
        0.17647058823529407,
        0.470703125,
        0.07053941908713693
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.52.jpg",
    "colors": {
      "hex": "#7e7f6b",
      "hls": [
        0.17499999999999996,
        0.45703125,
        0.08547008547008547
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.54.jpg",
    "colors": {
      "hex": "#827f74",
      "hls": [
        0.13095238095238096,
        0.48046875,
        0.056910569105691054
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.58.jpg",
    "colors": {
      "hex": "#7c8a6e",
      "hls": [
        0.25,
        0.484375,
        0.11290322580645161
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.60.jpg",
    "colors": {
      "hex": "#83836c",
      "hls": [
        0.16666666666666666,
        0.466796875,
        0.09623430962343096
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.61.jpg",
    "colors": {
      "hex": "#83917a",
      "hls": [
        0.26811594202898553,
        0.521484375,
        0.09387755102040816
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.63.jpg",
    "colors": {
      "hex": "#8f9e87",
      "hls": [
        0.27536231884057977,
        0.572265625,
        0.1050228310502283
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.65.jpg",
    "colors": {
      "hex": "#878b73",
      "hls": [
        0.19444444444444442,
        0.49609375,
        0.09448818897637795
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.66.jpg",
    "colors": {
      "hex": "#959082",
      "hls": [
        0.12280701754385966,
        0.544921875,
        0.0815450643776824
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.70.jpg",
    "colors": {
      "hex": "#929181",
      "hls": [
        0.1568627450980392,
        0.537109375,
        0.07172995780590717
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.71.jpg",
    "colors": {
      "hex": "#959c84",
      "hls": [
        0.21527777777777776,
        0.5625,
        0.10714285714285714
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.72.jpg",
    "colors": {
      "hex": "#93997d",
      "hls": [
        0.2023809523809524,
        0.54296875,
        0.11965811965811966
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.73.jpg",
    "colors": {
      "hex": "#988e82",
      "hls": [
        0.0909090909090909,
        0.55078125,
        0.09565217391304348
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.79.jpg",
    "colors": {
      "hex": "#7f8a6d",
      "hls": [
        0.2298850574712644,
        0.482421875,
        0.11740890688259109
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.8.jpg",
    "colors": {
      "hex": "#828c73",
      "hls": [
        0.2333333333333333,
        0.498046875,
        0.09803921568627451
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.82.jpg",
    "colors": {
      "hex": "#a1a892",
      "hls": [
        0.21969696969696972,
        0.61328125,
        0.1111111111111111
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.85.jpg",
    "colors": {
      "hex": "#8e8b83",
      "hls": [
        0.12121212121212122,
        0.533203125,
        0.04602510460251046
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.86.jpg",
    "colors": {
      "hex": "#868480",
      "hls": [
        0.11111111111111112,
        0.51171875,
        0.024
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.9.jpg",
    "colors": {
      "hex": "#928f89",
      "hls": [
        0.11111111111111112,
        0.552734375,
        0.039301310043668124
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.90.jpg",
    "colors": {
      "hex": "#919989",
      "hls": [
        0.25,
        0.56640625,
        0.07207207207207207
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.92.jpg",
    "colors": {
      "hex": "#78806d",
      "hls": [
        0.23684210526315788,
        0.462890625,
        0.08016877637130802
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D111.95.jpg",
    "colors": {
      "hex": "#7d7b74",
      "hls": [
        0.12962962962962962,
        0.470703125,
        0.03734439834024896
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.10.jpg",
    "colors": {
      "hex": "#97938c",
      "hls": [
        0.10606060606060606,
        0.568359375,
        0.049773755656108594
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.12.jpg",
    "colors": {
      "hex": "#8c887c",
      "hls": [
        0.125,
        0.515625,
        0.06451612903225806
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.13.jpg",
    "colors": {
      "hex": "#736c62",
      "hls": [
        0.09803921568627451,
        0.416015625,
        0.07981220657276995
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.14.jpg",
    "colors": {
      "hex": "#837f72",
      "hls": [
        0.12745098039215685,
        0.478515625,
        0.06938775510204082
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.15.jpg",
    "colors": {
      "hex": "#7c786c",
      "hls": [
        0.125,
        0.453125,
        0.06896551724137931
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.16.jpg",
    "colors": {
      "hex": "#837c6f",
      "hls": [
        0.10833333333333334,
        0.47265625,
        0.08264462809917356
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.17.jpg",
    "colors": {
      "hex": "#8a867e",
      "hls": [
        0.11111111111111112,
        0.515625,
        0.04838709677419355
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.18.jpg",
    "colors": {
      "hex": "#848077",
      "hls": [
        0.11538461538461538,
        0.490234375,
        0.05179282868525897
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.20.jpg",
    "colors": {
      "hex": "#81796e",
      "hls": [
        0.09649122807017545,
        0.466796875,
        0.0794979079497908
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.21.jpg",
    "colors": {
      "hex": "#8a8377",
      "hls": [
        0.10526315789473684,
        0.501953125,
        0.07450980392156863
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.23.jpg",
    "colors": {
      "hex": "#79756b",
      "hls": [
        0.11904761904761905,
        0.4453125,
        0.06140350877192982
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.24.jpg",
    "colors": {
      "hex": "#787066",
      "hls": [
        0.0925925925925926,
        0.43359375,
        0.08108108108108109
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.25.jpg",
    "colors": {
      "hex": "#7a7363",
      "hls": [
        0.11594202898550725,
        0.431640625,
        0.10407239819004525
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.26.jpg",
    "colors": {
      "hex": "#837f74",
      "hls": [
        0.12222222222222223,
        0.482421875,
        0.06072874493927125
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.28.jpg",
    "colors": {
      "hex": "#837c71",
      "hls": [
        0.10185185185185186,
        0.4765625,
        0.07377049180327869
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.34.jpg",
    "colors": {
      "hex": "#7a7166",
      "hls": [
        0.09166666666666667,
        0.4375,
        0.08928571428571429
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.35.jpg",
    "colors": {
      "hex": "#6c6357",
      "hls": [
        0.09523809523809523,
        0.380859375,
        0.1076923076923077
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.36.jpg",
    "colors": {
      "hex": "#afaba3",
      "hls": [
        0.11111111111111112,
        0.66015625,
        0.06896551724137931
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.38.jpg",
    "colors": {
      "hex": "#8f877c",
      "hls": [
        0.09649122807017545,
        0.521484375,
        0.07755102040816327
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.40.jpg",
    "colors": {
      "hex": "#8a847b",
      "hls": [
        0.09999999999999999,
        0.509765625,
        0.05976095617529881
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.60.jpg",
    "colors": {
      "hex": "#807e78",
      "hls": [
        0.125,
        0.484375,
        0.03225806451612903
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.61.jpg",
    "colors": {
      "hex": "#82796b",
      "hls": [
        0.10144927536231885,
        0.462890625,
        0.0970464135021097
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.62.jpg",
    "colors": {
      "hex": "#8b8373",
      "hls": [
        0.11111111111111112,
        0.49609375,
        0.09448818897637795
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.80.jpg",
    "colors": {
      "hex": "#7f7d77",
      "hls": [
        0.125,
        0.48046875,
        0.032520325203252036
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.81.jpg",
    "colors": {
      "hex": "#7b7a73",
      "hls": [
        0.14583333333333334,
        0.46484375,
        0.03361344537815126
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.82.jpg",
    "colors": {
      "hex": "#85837d",
      "hls": [
        0.125,
        0.50390625,
        0.031496062992125984
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.83.jpg",
    "colors": {
      "hex": "#7c7a72",
      "hls": [
        0.13333333333333333,
        0.46484375,
        0.04201680672268908
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.85.jpg",
    "colors": {
      "hex": "#968a77",
      "hls": [
        0.10215053763440861,
        0.525390625,
        0.12757201646090535
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.86.jpg",
    "colors": {
      "hex": "#a79d89",
      "hls": [
        0.11111111111111112,
        0.59375,
        0.14423076923076922
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.87.jpg",
    "colors": {
      "hex": "#9e9481",
      "hls": [
        0.10919540229885057,
        0.560546875,
        0.1288888888888889
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Cetoniinae_D166a.88.jpg",
    "colors": {
      "hex": "#978d78",
      "hls": [
        0.11290322580645162,
        0.529296875,
        0.12863070539419086
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.10.jpg",
    "colors": {
      "hex": "#807f7a",
      "hls": [
        0.1388888888888889,
        0.48828125,
        0.024
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.100.jpg",
    "colors": {
      "hex": "#6d6a64",
      "hls": [
        0.11111111111111112,
        0.408203125,
        0.0430622009569378
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.103.jpg",
    "colors": {
      "hex": "#7a7670",
      "hls": [
        0.09999999999999999,
        0.45703125,
        0.042735042735042736
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.105.jpg",
    "colors": {
      "hex": "#78736c",
      "hls": [
        0.09722222222222221,
        0.4453125,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.106.jpg",
    "colors": {
      "hex": "#6d6b64",
      "hls": [
        0.12962962962962962,
        0.408203125,
        0.0430622009569378
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.107.jpg",
    "colors": {
      "hex": "#83817a",
      "hls": [
        0.12962962962962962,
        0.494140625,
        0.03557312252964427
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.109.jpg",
    "colors": {
      "hex": "#6f6a64",
      "hls": [
        0.0909090909090909,
        0.412109375,
        0.052132701421800945
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.11.jpg",
    "colors": {
      "hex": "#a09e99",
      "hls": [
        0.11904761904761905,
        0.611328125,
        0.035175879396984924
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.110.jpg",
    "colors": {
      "hex": "#6f6c66",
      "hls": [
        0.11111111111111112,
        0.416015625,
        0.04225352112676056
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.111.jpg",
    "colors": {
      "hex": "#62625c",
      "hls": [
        0.16666666666666666,
        0.37109375,
        0.031578947368421054
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.113.jpg",
    "colors": {
      "hex": "#6e6a65",
      "hls": [
        0.0925925925925926,
        0.412109375,
        0.04265402843601896
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.114.jpg",
    "colors": {
      "hex": "#76716c",
      "hls": [
        0.08333333333333333,
        0.44140625,
        0.04424778761061947
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.115.jpg",
    "colors": {
      "hex": "#736860",
      "hls": [
        0.07017543859649122,
        0.412109375,
        0.09004739336492891
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.118.jpg",
    "colors": {
      "hex": "#6e6c66",
      "hls": [
        0.125,
        0.4140625,
        0.03773584905660377
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.12.jpg",
    "colors": {
      "hex": "#736b66",
      "hls": [
        0.0641025641025641,
        0.423828125,
        0.059907834101382486
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.120.jpg",
    "colors": {
      "hex": "#696762",
      "hls": [
        0.11904761904761905,
        0.396484375,
        0.034482758620689655
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.121.jpg",
    "colors": {
      "hex": "#6b6762",
      "hls": [
        0.0925925925925926,
        0.400390625,
        0.04390243902439024
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.13.jpg",
    "colors": {
      "hex": "#6c6862",
      "hls": [
        0.09999999999999999,
        0.40234375,
        0.04854368932038835
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.134.jpg",
    "colors": {
      "hex": "#717069",
      "hls": [
        0.14583333333333334,
        0.42578125,
        0.03669724770642202
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.14.jpg",
    "colors": {
      "hex": "#716e69",
      "hls": [
        0.10416666666666667,
        0.42578125,
        0.03669724770642202
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.140.jpg",
    "colors": {
      "hex": "#726e69",
      "hls": [
        0.0925925925925926,
        0.427734375,
        0.0410958904109589
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.145.jpg",
    "colors": {
      "hex": "#a09c98",
      "hls": [
        0.08333333333333333,
        0.609375,
        0.04
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.149.jpg",
    "colors": {
      "hex": "#76726d",
      "hls": [
        0.0925925925925926,
        0.443359375,
        0.039647577092511016
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.150.jpg",
    "colors": {
      "hex": "#726a65",
      "hls": [
        0.0641025641025641,
        0.419921875,
        0.06046511627906977
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.158.jpg",
    "colors": {
      "hex": "#73706a",
      "hls": [
        0.11111111111111112,
        0.431640625,
        0.04072398190045249
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.166.jpg",
    "colors": {
      "hex": "#786d67",
      "hls": [
        0.0588235294117647,
        0.435546875,
        0.07623318385650224
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.168.jpg",
    "colors": {
      "hex": "#827670",
      "hls": [
        0.05555555555555556,
        0.47265625,
        0.0743801652892562
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.17.jpg",
    "colors": {
      "hex": "#6d6a64",
      "hls": [
        0.11111111111111112,
        0.408203125,
        0.0430622009569378
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.174.jpg",
    "colors": {
      "hex": "#6b6962",
      "hls": [
        0.12962962962962962,
        0.400390625,
        0.04390243902439024
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.175.jpg",
    "colors": {
      "hex": "#706d67",
      "hls": [
        0.11111111111111112,
        0.419921875,
        0.04186046511627907
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.19.jpg",
    "colors": {
      "hex": "#6a6861",
      "hls": [
        0.12962962962962962,
        0.396484375,
        0.04433497536945813
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.68.jpg",
    "colors": {
      "hex": "#756d67",
      "hls": [
        0.07142857142857144,
        0.4296875,
        0.06363636363636363
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.7.jpg",
    "colors": {
      "hex": "#85837e",
      "hls": [
        0.11904761904761905,
        0.505859375,
        0.02766798418972332
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.74.jpg",
    "colors": {
      "hex": "#78746b",
      "hls": [
        0.11538461538461538,
        0.443359375,
        0.05726872246696035
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.77.jpg",
    "colors": {
      "hex": "#82807b",
      "hls": [
        0.11904761904761905,
        0.494140625,
        0.02766798418972332
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.8.jpg",
    "colors": {
      "hex": "#7b7973",
      "hls": [
        0.125,
        0.46484375,
        0.03361344537815126
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.80.jpg",
    "colors": {
      "hex": "#6e6863",
      "hls": [
        0.07575757575757576,
        0.408203125,
        0.05263157894736842
      ]
    }
  },
  {
    "file": "MFNB_Col_Scarabaeidae_Dynastinae_D071.89.jpg",
    "colors": {
      "hex": "#807d77",
      "hls": [
        0.11111111111111112,
        0.482421875,
        0.03643724696356275
      ]
    }
  }
]


// WEBPACK FOOTER //
// ./data/colors.one.js